// This file is auto-generated by @hey-api/openapi-ts

import * as z from 'zod';

export const zCaptureIdType = z.enum(['digitalQld', 'digitalVic', 'connectId']);

export const zDatetimeIsoString = z.iso.datetime();

export const zHealthResponse = z.object({
  success: z.literal(true),
  data: z.object({
    status: z.string(),
    version: z.string(),
    buildId: z.string().nullable(),
    timestamp: zDatetimeIsoString,
  }),
});

export const zApiError = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.unknown().optional(),
    stack: z.string().optional(),
  }),
  data: z.unknown().optional(),
});

export const zFeatureFlags = z.object({
  confirmationOfPayeeEnabled: z.boolean(),
  pepScreeningEnabled: z.boolean(),
  patronNowEnabled: z.boolean(),
});

export const zLogResponse = z.object({
  success: z.literal(true),
  data: z.object({
    success: z.boolean(),
  }),
});

export const zLogRequest = z.object({
  type: z.string(),
  level: z.enum(['log', 'error', 'warn', 'info', 'debug']),
  args: z.array(z.string()),
  timestamp: z.iso.datetime(),
  clientInfo: z
    .object({
      userAgent: z.string().optional(),
      language: z.string().optional(),
      platform: z.string().optional(),
      screen: z
        .object({
          width: z.number().optional(),
          height: z.number().optional(),
          availWidth: z.number().optional(),
          availHeight: z.number().optional(),
        })
        .optional(),
      window: z
        .object({
          innerWidth: z.number().optional(),
          innerHeight: z.number().optional(),
        })
        .optional(),
      timezone: z.string().optional(),
      online: z.boolean().optional(),
    })
    .optional(),
  meta: z.record(z.string(), z.string()).optional(),
});

export const zAuthResetPasswordResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zAuthResetPasswordRequest = z.object({
  email: z.string(),
  continueUrl: z.url().optional(),
});

export const zSignupUserResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

/**
 * Application the account is being created for. Only Trackd and nightlife permit self-signup.
 */
export const zSignupApplication = z.enum([
  'trackd',
  'checkd',
  'idu_dashboard',
  'nightlife_snp',
  'nightlife_osnp',
  'nightlife',
]);

export const zSignupUserRequest = z.object({
  email: z.email(),
  phoneNumber: z.string().nullish(),
  name: z.string().min(1),
  password: z.string().min(6).max(20),
  application: zSignupApplication,
});

export const zOauthProvisionResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zSignupUserWithInviteIdResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zAuthAcceptInviteRequest = z.object({
  phoneNumber: z.string().nullish(),
  name: z.string().min(1),
  password: z.string().min(6).max(20),
});

export const zSignUpUserCheckInviteIdResponse = z.object({
  success: z.literal(true),
  data: z.object({
    venueName: z.string(),
    accountExists: z.boolean(),
  }),
});

export const zTwoStepMethodKind = z.enum(['authenticator', 'sms']);

export const zTwoStepStatus = z.object({
  twoStep: z.enum(['off', 'on', 'required']),
  passed: z.boolean(),
  smsAvailable: z.boolean(),
  smsCountries: z.array(z.string()),
  rememberDays: z.int(),
  methods: z.array(
    z.object({
      kind: zTwoStepMethodKind,
      preferred: z.boolean(),
      hint: z.string().optional(),
    }),
  ),
  phoneOnRecord: z.string().optional(),
});

export const zTwoStepDone = z.object({
  message: z.string(),
});

export const zTwoStepAuthenticator = z.object({
  secret: z.string(),
  uri: z.string(),
});

export const zTwoStepCodeSent = z.object({
  hint: z.string().optional(),
});

export const zTwoStepSignIn = z.object({
  token: z.string(),
  deviceToken: z.string().optional(),
});

export const zTwoStepVerificationBody = z.intersection(
  z.union([
    z.object({
      kind: zTwoStepMethodKind,
      code: z.string().regex(/^\d{6}$/),
    }),
    z.object({
      googleIdToken: z.string().min(1),
    }),
    z.object({
      supportCode: z.string().min(8).max(16),
    }),
  ]),
  z.object({
    rememberDevice: z.boolean().optional(),
    deviceLabel: z.string().max(255).optional(),
  }),
);

export const zTwoStepDevices = z.array(
  z.object({
    id: z.string(),
    label: z.string().nullable(),
    rememberedAt: z.string(),
    lastUsedAt: z.string().nullable(),
    expiresAt: z.string(),
  }),
);

export const zStaffAccess = z.object({
  staff: z.boolean(),
});

export const zUserPublic = z.object({
  id: z.uuid(),
  email: z.email(),
  phoneNumber: z.string().nullable(),
  fullname: z.string().min(1).max(255),
  photoFileId: z.uuid().nullable(),
  createdAt: zDatetimeIsoString,
  updatedAt: zDatetimeIsoString,
});

export const zUserPublicResponse = z.object({
  success: z.literal(true),
  data: zUserPublic,
});

export const zVicDigitalResponse = z.object({
  name: z.string(),
  given_names: z.string().optional(),
  family_name: z.string().optional(),
  birth_date: z.string(),
  expiry_date: z.string(),
  country: z.string(),
  state: z.string(),
  city: z.string().optional(),
  postcode: z.string().optional(),
  document_photo: z.string(),
  document_type: z.string(),
  document_id: z.string(),
  address: z.string().optional(),
});

export const zMeUser = z.object({
  id: z.uuid(),
  fullname: z.string().min(1).max(255),
  email: z.email(),
  phoneNumber: z.string().nullable(),
  photoFileId: z.uuid().nullable(),
  createdAt: zDatetimeIsoString,
  updatedAt: zDatetimeIsoString,
});

export const zVenueStatus = z.enum(['active', 'inactive', 'suspended']);

export const zApplications = z.enum([
  'trackd',
  'checkd',
  'idu_dashboard',
  'nightlife_snp',
  'nightlife_osnp',
]);

export const zJobTitles = z.enum([
  'bar_staff',
  'cleaner',
  'security',
  'kitchen_staff',
  'entertainer',
  'other',
  'owner',
]);

export const zRoles = z.enum(['operator', 'manager', 'staff', 'admin']);

export const zMyVenue = z.object({
  id: z.uuid(),
  externalId: z.string().nullable(),
  slug: z.string(),
  name: z.string(),
  venueStatus: zVenueStatus,
  application: zApplications,
  status: zVenueStatus,
  jobTitle: zJobTitles,
  role: zRoles.nullable(),
  roleId: z.uuid().nullish(),
  roleName: z.string().nullish(),
  permissions: z.array(z.string()).optional().default([]),
  securityFirm: z.string().max(255).nullable(),
  shiftCutoffTime: z.string().nullish(),
  timezone: z.string().nullish(),
  associatedBy: z.uuid().nullish(),
  locations: z.array(
    z.object({
      id: z.uuid(),
      venueId: z.uuid(),
      name: z.string(),
      createdAt: z.iso.datetime(),
      discardedAt: z.iso.datetime().nullable(),
      createdBy: z.string().nullable(),
      discardedBy: z.string().nullable(),
    }),
  ),
});

export const zUserGetAppData = z.object({
  me: zMeUser,
  venues: z.array(zMyVenue),
});

export const zUserAppDataResponse = z.object({
  success: z.literal(true),
  data: zUserGetAppData,
});

export const zSelfProfile = z.object({
  fullname: z.string().min(1).max(255),
  phoneNumber: z.string().nullable(),
  email: z.email(),
  hasPin: z.boolean(),
});

export const zSelfProfileGetResponse = z.object({
  success: z.literal(true),
  data: zSelfProfile,
});

export const zSelfProfileUpdateResponse = z.object({
  success: z.literal(true),
  data: zSelfProfile,
});

export const zUpdateSelfProfileInput = z.object({
  fullname: z.string().min(1).max(255),
  phoneNumber: z.union([z.string(), z.enum([''])]),
  pinCode: z
    .string()
    .regex(/^(\d{4}|)$/)
    .nullable(),
});

export const zInAppMessageTypeEnum = z.enum(['error', 'warning', 'info']);

export const zInAppMessageApplicationEnum = z.enum(['checkd']);

export const zInAppMessageStatusEnum = z.enum(['active', 'scheduled', 'expired']);

export const zInAppMessageResponseData = z.object({
  id: z.uuid(),
  title: z.string(),
  type: zInAppMessageTypeEnum,
  application: zInAppMessageApplicationEnum,
  startAt: zDatetimeIsoString,
  endAt: zDatetimeIsoString,
  message: z.string(),
  status: zInAppMessageStatusEnum,
  createdBy: z.uuid(),
  createdAt: zDatetimeIsoString,
  updatedBy: z.uuid(),
  updatedAt: zDatetimeIsoString,
});

export const zInAppMessageUnreadForApplicationListResponse = z.object({
  success: z.literal(true),
  data: z.array(zInAppMessageResponseData),
});

export const zInAppMessageMarkReadResponse = z.object({
  success: z.literal(true),
  data: z.object({
    success: z.boolean(),
  }),
});

export const zRouteResponse = z.object({
  success: z.literal(true),
  data: z.record(
    z.string(),
    z.array(
      z.object({
        value: z.string(),
        label: z.string().nullable(),
        caption: z.string().nullable(),
      }),
    ),
  ),
});

export const zCheckdAddressValidateParts = z.object({
  street: z.string(),
  suburb: z.string(),
  state: z.string(),
  postcode: z.string(),
  country: z.string(),
});

export const zCheckdAddressValidateResult = z.object({
  available: z.boolean(),
  resolved: z.boolean().optional(),
  parts: zCheckdAddressValidateParts.optional(),
  provenance: z
    .object({
      street: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
      suburb: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
      state: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
      postcode: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
    })
    .optional(),
  verdict: z
    .object({
      addressComplete: z.boolean(),
      hasUnconfirmedComponents: z.boolean(),
      hasInferredComponents: z.boolean(),
      hasReplacedComponents: z.boolean(),
      validationGranularity: z.string(),
    })
    .optional(),
  cause: z
    .enum([
      'venue_not_enrolled',
      'platform_switch_off',
      'rate_ceiling',
      'provider_error',
      'deadline_exceeded',
    ])
    .optional(),
});

export const zCheckdAddressValidateInput = z.object({
  address: z.string().min(1),
  regionCode: z.string().length(2).optional(),
});

export const zPayoutStatus = z.enum([
  'draft',
  'discarded',
  'needs_review',
  'payment_pending',
  'rejected',
  'finalised',
]);

export const zPatronIdTypes = z
  .enum(['digitalQld', 'digitalVic', 'physicalDriversLicence', 'passport', 'other', 'connectId'])
  .nullable();

export const zGenders = z.enum(['male', 'female', 'other', 'unknown']).nullable();

export const zPayoutKycOutcome = z
  .enum(['valid', 'unknown', 'error', 'skipped', 'pending'])
  .nullable();

export const zPatronBehaviourObservation = z.enum([
  'nervous_behaviour',
  'avoiding_questions',
  'refusing_identification',
  'insisting_on_unusual_payment_methods',
  'appearing_coached_by_another_person',
  'excessive_secrecy',
  'refusal_to_provide_source_of_funds',
  'attempts_to_circumvent_procedures',
  'no_suspicious_behaviour_seen',
]);

export const zGamingBehaviourObservation = z.enum([
  'minimal_play_then_cash_out',
  'large_cash_in_with_little_gaming',
  'ticket_purchasing',
  'credit_purchasing',
  'loitering',
  'frequent_movement_between_machines',
  'multiple_payouts_in_short_periods',
  'refusal_to_photograph_wins',
  'structuring_transactions',
  'no_suspicious_behaviour_seen',
]);

export const zDocumentCodes = z.enum([
  'AUS_PASSPORT_CURR_EXP',
  'AUS_CITZ_CERT',
  'AUS_BIRTH_CERT_FULL',
  'AUS_CERT_IDENTITY',
  'AUS_DRIVER_LICENCE',
  'AUS_TERT_STUDENT_ID',
  'AUS_PHOTO_ID',
  'AUS_GOV_EMP_ID',
  'AUS_DEF_FORCE_ID',
  'AUS_DVA_CARD',
  'AUS_CENTRELINK_CARD',
  'AUS_BIRTH_CERT_EXTRACT',
  'AUS_BIRTH_CARD_NSW',
  'AUS_MEDICARE_CARD',
  'AUS_CREDIT_CARD',
  'AUS_MARRIAGE_CERT',
  'AUS_DECREE_NISI_ABSOLUTE',
  'AUS_CHANGE_NAME_CERT',
  'AUS_BANK_STATEMENT',
  'AUS_PROPERTY_LEASE',
  'AUS_TAX_ASSESSMENT',
  'AUS_MORTGAGE_DOCS',
  'AUS_RATING_AUTHORITY',
  'AUS_UTILITY_BILL',
  'AUS_INDIGENOUS_ORG_REF',
  'INT_PASSPORT_CURR',
  'INT_BIRTH_CERT_FULL',
  'INT_DRIVER_LICENCE',
  'INT_GOV_EMP_ID',
  'INT_TRAVEL_DOC',
  'INT_CREDIT_CARD',
  'INT_BANK_STATEMENT',
  'OTHER_ID',
  'AUS_QLD_DIGITAL_LICENCE',
  'AUS_VIC_DIGITAL_LICENCE',
  'AUS_NSW_DIGITAL_LICENCE',
]);

export const zPayoutRiskRuleResult = z.object({
  id: z.uuid(),
  ppPayoutId: z.uuid(),
  ruleId: z.string(),
  label: z.string(),
  description: z.string(),
  score: z.int(),
  createdAt: zDatetimeIsoString,
});

export const zPayoutRiskRule = z.object({
  ruleId: z.string(),
  label: z.string(),
  description: z.string(),
  tripped: z.boolean(),
  score: z.number(),
});

export const zPayoutRiskAssessmentResult = z.object({
  rules: z.array(zPayoutRiskRule),
  score: z.number(),
  suggestedLevel: z.enum(['low', 'medium', 'high']),
  mediumScoreThreshold: z.int(),
  highScoreThreshold: z.int(),
});

export const zPayoutPhaseState = z.object({
  isRequired: z.boolean(),
  isCompleted: z.boolean(),
  isSkipped: z.boolean(),
  role: zRoles,
});

export const zPayoutState = z.object({
  '1-patron-id': zPayoutPhaseState.optional(),
  '2-ticket': zPayoutPhaseState.optional(),
  '3-kyc': zPayoutPhaseState.optional(),
  '4-contact-payment': zPayoutPhaseState.optional(),
  '5-patron-sign-off': zPayoutPhaseState.optional(),
  '6-attendant-sign-off': zPayoutPhaseState.optional(),
  '7-manager-sign-off': zPayoutPhaseState.optional(),
  '8-payout': zPayoutPhaseState.optional(),
  '9-finalised': zPayoutPhaseState.optional(),
});

export const zPayoutKycStateCodes = z.enum([
  'AUTOMATIC_VERIFICATION_SUCCEEDED',
  'AUTOMATIC_VERIFICATION_SKIPPED_FULL_POINTS',
  'AUTOMATIC_VERIFICATION_SKIPPED_ALTERNATE_VERIFICATION',
  'AUTOMATIC_VERIFICATION_FAILED_FULL_POINTS',
  'AUTOMATIC_VERIFICATION_FAILED_ALTERNATE_VERIFICATION',
  'AUTOMATIC_VERIFICATION_FAILED_NO_FULL_POINTS',
  'AUTOMATIC_VERIFICATION_SKIPPED_NO_FULL_POINTS',
  'AUTOMATIC_VERIFICATION_SKIPPED_NO_ALTERNATE_VERIFICATION',
  'UNDER_THRESHOLD',
  'RUNNING',
  'NOT_YET_RUN',
  'UNAVAILABLE',
]);

export const zPayoutKycState = z.object({
  code: zPayoutKycStateCodes,
  description: z.string(),
});

export const zPepTier = z.enum([
  'PEP_TIER_UNSPECIFIED',
  'PEP_TIER_1',
  'PEP_TIER_2',
  'PEP_TIER_3',
  'PEP_TIER_BY_ASSOCIATION',
]);

export const zPepMatch = z.object({
  score: z.number(),
  pepTier: zPepTier,
  fullName: z.string(),
  datesOfBirth: zDatetimeIsoString.optional(),
  gender: zGenders.optional(),
  profileImageUrl: z.string().optional(),
  geography: z.string().optional(),
  pepPosition: z.string().nullish(),
  sanctionStatus: z.enum(['unknown', 'no-match', 'active', 'none']).optional(),
  knownAliases: z.array(z.string()).optional(),
  adverseMedia: z
    .array(
      z.object({
        category: z.string().optional(),
        subcategory: z.string().nullish(),
      }),
    )
    .optional(),
});

export const zPayoutPatron = z.object({
  id: z.uuid(),
  firstName: z.string(),
  middleName: z.string().nullable(),
  lastName: z.string().nullable(),
  riskRating: z.int(),
  bndryEntityId: z.uuid().nullable(),
  pepStatus: z.enum([
    'failed',
    'unknown',
    'no-match',
    'confirmed-pep',
    'confirmed-not-pep',
    'confirmed-associated',
  ]),
  pepUpdatedAt: zDatetimeIsoString.nullish(),
  sanctionStatus: z.enum(['unknown', 'no-match', 'active', 'none']),
  venueCreatedId: z.uuid(),
  createdAt: zDatetimeIsoString,
  photoUrl: z.string().optional(),
  associatedPepMatch: zPepMatch.optional(),
});

export const zConfirmationOfPayeeResultCode = z
  .enum([
    'match',
    'close_match',
    'weak_match',
    'not_enough_info',
    'no_match',
    'account_closed',
    'account_not_found',
    'unavailable',
  ])
  .nullable();

export const zPayoutAutoEftPaymentAbsent = z.object({
  enrolled: z.literal(false),
});

export const zAutoEftPaymentStatus = z.enum([
  'scheduled',
  'held',
  'locked',
  'submitting',
  'processing',
  'paid',
  'payment_failed',
  'cancelled',
]);

export const zPayoutAutoEftPaymentPresent = z.object({
  enrolled: z.literal(true),
  id: z.uuid(),
  status: zAutoEftPaymentStatus,
  amountInCents: z.int().gte(0),
  eligibleAt: zDatetimeIsoString,
  holdExpiresAt: zDatetimeIsoString.nullable(),
  heldAt: zDatetimeIsoString.nullable(),
  submittedAt: zDatetimeIsoString.nullable(),
  outcomeObservedAt: zDatetimeIsoString.nullable(),
  cancelledAt: zDatetimeIsoString.nullable(),
  cancellationReason: z.string().nullable(),
  failureReason: z.string().nullable(),
  providerReportedStatus: z.string().nullable(),
  providerResponseMessage: z.string().nullable(),
  staffResolutionRecordedAt: zDatetimeIsoString.nullable(),
});

export const zPayoutAutoEftPayment = z.union([
  zPayoutAutoEftPaymentAbsent,
  zPayoutAutoEftPaymentPresent,
]);

export const zConnectIdBankAccount = z
  .object({
    bsb: z.string(),
    accountNumber: z.string(),
    accountName: z.string(),
  })
  .nullable();

export const zPayout = z.object({
  id: z.uuid(),
  status: zPayoutStatus,
  payoutNumber: z.int().gte(0),
  externalId: z.string(),
  patronIdFrontFileId: z.uuid().nullable(),
  patronIdBackFileId: z.uuid().nullable(),
  patronIdFaceFileId: z.uuid().nullable(),
  associatedPatronId: z.uuid().nullish(),
  patronFullname: z.string(),
  patronFirstName: z.string().optional(),
  patronMiddleName: z.string().nullish(),
  patronLastName: z.string().nullish(),
  patronIdType: zPatronIdTypes,
  patronIdOcrIdentifier: z.string().nullable(),
  connectIdDocumentName: z.string().nullish(),
  patronDateOfBirth: z.string().nullable(),
  patronIdExpiry: z.string().nullable(),
  patronIdNumber: z.string().nullable(),
  isPatronIdHashed: z.boolean().optional().default(false),
  patronIdAddress: z.string().nullish().default(''),
  patronIdState: z.string().nullish().default(''),
  patronIdCardNumber: z.string().nullish().default(''),
  patronAddressStreet: z.string().nullable(),
  patronAddressSuburb: z.string().nullable(),
  patronAddressState: z.string().nullable(),
  patronAddressPostcode: z.string().nullable(),
  patronAddressCountry: z.string().nullable(),
  patronAddressValidation: z
    .object({
      outcome: z.enum(['confirmed', 'asserted', 'overridden', 'unvalidated']),
      parts: z.object({
        street: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        suburb: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        state: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        postcode: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
      }),
      providerVerdict: z
        .object({
          addressComplete: z.boolean(),
          hasUnconfirmedComponents: z.boolean(),
          hasInferredComponents: z.boolean(),
          hasReplacedComponents: z.boolean(),
          validationGranularity: z.string(),
        })
        .optional(),
      refusal: z
        .object({
          status: z.enum(['unresolvable', 'unavailable']),
          cause: z
            .enum([
              'venue_not_enrolled',
              'platform_switch_off',
              'rate_ceiling',
              'provider_error',
              'deadline_exceeded',
            ])
            .optional(),
          reportedStatus: z.string().optional(),
        })
        .optional(),
    })
    .nullable(),
  isPatronPrimaryIdentityDocumentsCleaned: z.boolean().optional().default(false),
  isPatronSecondaryIdentityDocumentsCleaned: z.boolean().optional().default(false),
  patronGender: zGenders,
  patronOccupation: z.string().nullable(),
  patronOccupationNotes: z.string().nullable(),
  patronSourceOfFunds: z.string().nullable(),
  patronSourceOfFundsNotes: z.string().nullable(),
  patronSourceOfWealth: z.string().nullable(),
  patronSourceOfWealthNotes: z.string().nullable(),
  kycPerform: z.boolean().nullable(),
  kycPatronSignatureFileId: z.uuid().nullable(),
  patronEmailConsented: z.boolean().nullable(),
  patronReceiptEmailTarget: z.string().nullable(),
  patronReceiptEmailSentAt: zDatetimeIsoString.nullable(),
  createdBy: z.string().nullable(),
  createdAt: zDatetimeIsoString,
  updatedBy: z.uuid(),
  updatedAt: zDatetimeIsoString,
  venueId: z.uuid(),
  ticketFileId: z.uuid().nullable(),
  ticketNumber: z.string().nullish(),
  ticketNotes: z.string().nullable(),
  egmNumber: z.string().nullish(),
  amountInCents: z.int().gte(0),
  kycDvsOutcome: zPayoutKycOutcome,
  patronPhoneNumber: z.string().nullable(),
  patronEmail: z.string().nullable(),
  paymentCashInCents: z.int().gte(0).optional().default(0),
  paymentChequeInCents: z.int().gte(0).optional().default(0),
  paymentEftInCents: z.int().gte(0).optional().default(0),
  paymentEftBsb: z.string().nullish().default(''),
  paymentEftAccountName: z.string().nullish().default(''),
  paymentEftAccountNumber: z.string().nullish().default(''),
  paymentPatronConfirmationSignatureFileId: z.uuid().nullable(),
  paymentAttendantConfirmationSignatureFileId: z.uuid().nullable(),
  submittedForManagerReviewAt: zDatetimeIsoString.nullable(),
  patronBehaviourObservations: z.array(zPatronBehaviourObservation),
  gamingBehaviourObservations: z.array(zGamingBehaviourObservation),
  reviewedAt: zDatetimeIsoString.nullable(),
  reviewedApprovedSignatureFileId: z.uuid().nullable(),
  reviewedRejectedReason: z.string().nullish().default(''),
  reviewedBy: z.uuid().nullable(),
  managerRiskLevel: z.enum(['low', 'medium', 'high']).nullish(),
  managerRiskLevelNotes: z.string().nullish().default(''),
  suggestedRiskLevel: z.enum(['low', 'medium', 'high']).nullish(),
  suggestedRiskMediumScoreThreshold: z.int().nullish(),
  suggestedRiskHighScoreThreshold: z.int().nullish(),
  payoutFinalizedAt: zDatetimeIsoString.nullable(),
  payoutFinalizedBy: z.uuid().nullable(),
  paidCash: z.boolean().nullable(),
  paidCashBy: z.uuid().nullable(),
  paidCashAt: zDatetimeIsoString.nullable(),
  paidCashSignatureFileId: z.uuid().nullable(),
  paidEftTransactionNumber: z.string().nullable(),
  paidEft: z.boolean().nullable(),
  paidEftBy: z.uuid().nullable(),
  paidEftAt: zDatetimeIsoString.nullable(),
  paidEftSignatureFileId: z.uuid().nullable(),
  paidCheque: z.boolean().nullable(),
  paidChequeBy: z.uuid().nullable(),
  paidChequeAt: zDatetimeIsoString.nullable(),
  paidChequeFileId: z.uuid().nullable(),
  paidChequeSignatureFileId: z.uuid().nullable(),
  paidChequeChequeNumber: z.string().nullish(),
  paidFully: z.boolean().nullable(),
  paidFullyAt: zDatetimeIsoString.nullable(),
  discardedAt: zDatetimeIsoString.nullable(),
  discardedBy: z.uuid().nullable(),
  discardedReason: z.string().nullish().default(''),
});

export const zPayoutEnriched = zPayout.and(
  z.object({
    createdByName: z.string().nullish(),
    updatedByName: z.string().nullish(),
    reviewedByName: z.string().nullish(),
    paidCashByName: z.string().nullish(),
    paidEftByName: z.string().nullish(),
    paidChequeByName: z.string().nullish(),
    discardedByName: z.string().nullish(),
    payoutFinalizedByName: z.string().nullish(),
    ticketFileUrl: z.url().nullish(),
    patronIdFrontFileUrl: z.url().nullish(),
    patronIdBackFileUrl: z.url().nullish(),
    patronIdFaceFileUrl: z.url().nullish(),
    kycPatronSignatureFileUrl: z.url().nullish(),
    reviewedApprovedSignatureFileUrl: z.url().nullish(),
    paidCashSignatureFileUrl: z.url().nullish(),
    paidEftSignatureFileUrl: z.url().nullish(),
    paidChequeFileUrl: z.url().nullish(),
    paidChequeSignatureFileUrl: z.url().nullish(),
    paymentAttendantConfirmationSignatureFileUrl: z.url().nullish(),
    paymentPatronConfirmationSignatureFileUrl: z.url().nullish(),
    documents: z.array(
      z.object({
        type: z.enum(['primary', 'secondary']),
        id: z.string(),
        code: zDocumentCodes,
        frontFileId: z.string().nullable(),
        backFileId: z.string().nullable(),
        faceFileId: z.string().nullable(),
        frontFileUrl: z.url().nullish(),
        backFileUrl: z.url().nullish(),
        faceFileUrl: z.url().nullish(),
        ppPayoutId: z.uuid(),
      }),
    ),
    riskRuleResults: z.array(zPayoutRiskRuleResult),
    currentRiskAssessmentResult: zPayoutRiskAssessmentResult.optional(),
    payoutState: zPayoutState,
    kycState: zPayoutKycState.optional(),
    patron: zPayoutPatron.optional(),
    confirmationOfPayeeResult: zConfirmationOfPayeeResultCode,
    confirmationOfPayeeIsStale: z.boolean(),
    confirmationOfPayeeNotes: z.string().nullish(),
    eftRiskAcceptanceReason: z.string().nullish(),
    eftRiskAcceptanceConditions: z.array(z.string()).optional(),
    eftRiskAcceptanceAt: z.iso.datetime().nullish(),
    eftRiskAcceptanceByName: z.string().nullish(),
    eftRiskAcceptanceIsCurrent: z.boolean().optional(),
    bankingDetailChangeReason: z.string().nullish(),
    bankingDetailChangedAt: z.iso.datetime().nullish(),
    bankingDetailChangedByName: z.string().nullish(),
    bankingDetailChangedFields: z.array(z.string()).optional(),
    autoEftPayment: zPayoutAutoEftPayment,
    withheldPatronFields: z.array(z.string()),
    outsideBrowsingScope: z.boolean().optional(),
    connectIdBankAccount: zConnectIdBankAccount.optional(),
    eftAccountValidatedByBank: z.boolean().optional(),
  }),
);

export const zConnectIdDocumentAcceptedVerdict = z.enum(['partial', 'notChecked']);

export const zPayoutCreateInput = z.object({
  patronFirstName: z.string().optional(),
  patronMiddleName: z.string().nullish(),
  patronLastName: z.string().nullish(),
  patronFullName: z.string().optional(),
  patronFullname: z.string().optional(),
  patronPhoneNumber: z.string().nullish(),
  patronEmail: z.email().nullish(),
  patronIdType: zPatronIdTypes,
  patronIdNumber: z.string().nullish(),
  patronIdExpiry: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullish(),
  patronDateOfBirth: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  patronIdAddress: z.string().nullish(),
  patronAddressStreet: z.string().nullish(),
  patronAddressSuburb: z.string().nullish(),
  patronAddressState: z.string().nullish(),
  patronAddressPostcode: z.string().nullish(),
  patronAddressCountry: z.string().nullish(),
  patronAddressValidation: z
    .object({
      outcome: z.enum(['confirmed', 'asserted', 'overridden', 'unvalidated']),
      parts: z.object({
        street: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        suburb: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        state: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        postcode: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
      }),
      providerVerdict: z
        .object({
          addressComplete: z.boolean(),
          hasUnconfirmedComponents: z.boolean(),
          hasInferredComponents: z.boolean(),
          hasReplacedComponents: z.boolean(),
          validationGranularity: z.string(),
        })
        .optional(),
      refusal: z
        .object({
          status: z.enum(['unresolvable', 'unavailable']),
          cause: z
            .enum([
              'venue_not_enrolled',
              'platform_switch_off',
              'rate_ceiling',
              'provider_error',
              'deadline_exceeded',
            ])
            .optional(),
          reportedStatus: z.string().optional(),
        })
        .optional(),
    })
    .nullish(),
  patronIdState: z.string().optional().default(''),
  patronIdCardNumber: z.string().optional().default(''),
  patronGender: zGenders.optional(),
  patronIdFrontFileId: z.uuid().optional(),
  patronIdBackFileId: z.uuid().optional(),
  patronIdFaceFileId: z.uuid().optional(),
  connectIdDocumentName: z.string().nullish(),
  connectIdDocumentAcceptedVerdict: zConnectIdDocumentAcceptedVerdict.optional(),
  connectIdDocumentCode: zDocumentCodes.optional(),
  patronIdOcrIdentifier: z.string().nullish(),
  patronOccupation: z.string().nullish(),
  patronOccupationNotes: z.string().nullish(),
  patronSourceOfFunds: z.string().nullish(),
  patronSourceOfFundsNotes: z.string().nullish(),
  patronSourceOfWealth: z.string().nullish(),
  patronSourceOfWealthNotes: z.string().nullish(),
});

export const zPayoutUpdateResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

export const zPayoutUpdateRequest = z.object({
  ticketNumber: z.string().nullish(),
  egmNumber: z.string().nullish(),
  ticketNotes: z.string().optional(),
  amountInCents: z.int().gte(1).optional(),
  patronFirstName: z.string().min(1).optional(),
  patronMiddleName: z.string().nullish(),
  patronLastName: z.string().nullish(),
  patronIdType: zPatronIdTypes.optional(),
  patronIdNumber: z.string().min(1).optional(),
  patronIdExpiry: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullish(),
  patronDateOfBirth: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  patronIdAddress: z.string().nullish(),
  patronIdState: z.string().nullish(),
  patronIdCardNumber: z.string().nullish(),
  patronAddressStreet: z.string().nullish(),
  patronAddressSuburb: z.string().nullish(),
  patronAddressState: z.string().nullish(),
  patronAddressPostcode: z.string().nullish(),
  patronAddressCountry: z.string().nullish(),
  patronGender: zGenders.optional(),
  patronPhoneNumber: z.string().nullish(),
  patronEmail: z.email().nullish(),
  patronOccupation: z.string().nullish(),
  patronOccupationNotes: z.string().nullish(),
  patronSourceOfFunds: z.string().nullish(),
  patronSourceOfFundsNotes: z.string().nullish(),
  patronSourceOfWealth: z.string().nullish(),
  patronSourceOfWealthNotes: z.string().nullish(),
  paymentCashInCents: z.int().gte(0).optional(),
  paymentChequeInCents: z.int().gte(0).optional(),
  paymentEftInCents: z.int().gte(0).optional(),
  paymentEftBsb: z.string().nullish(),
  paymentEftAccountName: z.string().nullish(),
  paymentEftAccountNumber: z.string().nullish(),
  bankingDetailChangeReason: z.string().min(1).optional(),
});

export const zPayoutViewResponse = z.object({
  success: z.literal(true),
  data: z.object({
    success: z.boolean(),
  }),
});

export const zPayoutReceiptResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zPayoutReceiptRequest = z.object({
  email: z.email(),
  send: z.boolean().optional().default(true),
  patronEmailConsented: z.boolean().optional(),
});

export const zPaginationMeta = z.object({
  page: z.int().gte(1),
  pageSize: z.int().gte(1),
  totalPages: z.int().gte(0),
  totalItems: z.int().gte(0),
  hasNextPage: z.boolean(),
  hasPreviousPage: z.boolean(),
});

export const zPayoutStatuses = z.enum([
  'draft',
  'discarded',
  'needs_review',
  'payment_pending',
  'rejected',
  'finalised',
]);

export const zPayoutMethods = z.enum(['eft', 'cash', 'cheque']);

export const zPayoutPhase1PatronIdInput = z.object({
  patronFirstName: z.string().optional(),
  patronMiddleName: z.string().nullish(),
  patronLastName: z.string().nullish(),
  patronFullName: z.string().optional(),
  patronFullname: z.string().optional(),
  patronPhoneNumber: z.string().nullish(),
  patronEmail: z.email().nullish(),
  patronIdType: zPatronIdTypes,
  patronIdNumber: z.string().nullish(),
  patronIdExpiry: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullish(),
  patronDateOfBirth: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .optional(),
  patronIdAddress: z.string().nullish(),
  patronAddressStreet: z.string().nullish(),
  patronAddressSuburb: z.string().nullish(),
  patronAddressState: z.string().nullish(),
  patronAddressPostcode: z.string().nullish(),
  patronAddressCountry: z.string().nullish(),
  patronAddressValidation: z
    .object({
      outcome: z.enum(['confirmed', 'asserted', 'overridden', 'unvalidated']),
      parts: z.object({
        street: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        suburb: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        state: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
        postcode: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
      }),
      providerVerdict: z
        .object({
          addressComplete: z.boolean(),
          hasUnconfirmedComponents: z.boolean(),
          hasInferredComponents: z.boolean(),
          hasReplacedComponents: z.boolean(),
          validationGranularity: z.string(),
        })
        .optional(),
      refusal: z
        .object({
          status: z.enum(['unresolvable', 'unavailable']),
          cause: z
            .enum([
              'venue_not_enrolled',
              'platform_switch_off',
              'rate_ceiling',
              'provider_error',
              'deadline_exceeded',
            ])
            .optional(),
          reportedStatus: z.string().optional(),
        })
        .optional(),
    })
    .nullish(),
  patronIdState: z.string().optional().default(''),
  patronIdCardNumber: z.string().optional().default(''),
  patronGender: zGenders.optional(),
  patronIdFrontFileId: z.uuid().optional(),
  patronIdBackFileId: z.uuid().optional(),
  patronIdFaceFileId: z.uuid().optional(),
  connectIdDocumentName: z.string().nullish(),
  connectIdDocumentAcceptedVerdict: zConnectIdDocumentAcceptedVerdict.optional(),
  connectIdDocumentCode: zDocumentCodes.optional(),
  patronIdOcrIdentifier: z.string().nullish(),
  patronOccupation: z.string().nullish(),
  patronOccupationNotes: z.string().nullish(),
  patronSourceOfFunds: z.string().nullish(),
  patronSourceOfFundsNotes: z.string().nullish(),
  patronSourceOfWealth: z.string().nullish(),
  patronSourceOfWealthNotes: z.string().nullish(),
});

export const zDigitalLicenceType = z.enum(['digitalQld', 'digitalVic']);

export const zCapturedIdentity = z.object({
  patronFirstName: z.string(),
  patronMiddleName: z.string().nullable(),
  patronLastName: z.string().nullable(),
  patronDateOfBirth: z.string().nullable(),
  patronIdExpiry: z.string().nullable(),
  patronIdNumber: z.string().nullable(),
  patronIdState: z.string(),
  patronIdCardNumber: z.string(),
  patronGender: zGenders,
  patronIdType: zDigitalLicenceType,
});

export const zDigitalCaptureResult = z.object({
  identityCheckId: z.uuid(),
  outcome: z.enum(['valid', 'unknown', 'error']),
  identity: zCapturedIdentity,
  licence: zVicDigitalResponse.optional(),
});

export const zDigitalCapture = z.union([
  z.object({
    method: z.enum(['vic_digital']),
    qrData: z.string().regex(/qr-scan/),
  }),
  z.object({
    method: z.enum(['qld_digital']),
    deviceResult: z.object({
      validationPassed: z.boolean(),
      validationResults: z.record(
        z.string(),
        z.object({
          value: z.enum(['passed', 'failed']),
        }),
      ),
      identity: z.object({
        givenNames: z.string().min(1),
        familyName: z.string(),
        dateOfBirth: z
          .string()
          .regex(/^\d{4}-\d{2}-\d{2}$/)
          .nullable(),
        documentNumber: z.string().nullable(),
        expiryDate: z
          .string()
          .regex(/^\d{4}-\d{2}-\d{2}$/)
          .nullable(),
        cardNumber: z.string().nullable(),
        state: z.string(),
      }),
    }),
  }),
]);

export const zPayoutConnectIdVerificationStarted = z.object({
  state: z.enum(['waiting']),
  initialRedirectUri: z.string(),
  shortLinkUri: z.string().optional(),
  expiresAt: z.string(),
});

export const zPayoutConnectIdVerificationStartInput = z.object({
  patronName: z.string().min(1).optional(),
});

export const zPayoutConnectIdVerificationStatus = z.object({
  state: z.enum([
    'starting',
    'waiting',
    'verified',
    'refused',
    'timed-out',
    'errored',
    'cancelled',
  ]),
  initialRedirectUri: z.string().optional(),
  shortLinkUri: z.string().optional(),
  reason: z.string().optional(),
  expiresAt: z.string().optional(),
  verifiedIdentity: z
    .object({
      firstName: z.string(),
      middleName: z.string().optional(),
      lastName: z.string(),
      dateOfBirth: z.string().optional(),
      email: z.string().optional(),
      phoneNumber: z.string().optional(),
      address: z.string().optional(),
      addressProposal: z
        .object({
          resolved: z.boolean(),
          parts: z.object({
            street: z.string(),
            suburb: z.string(),
            state: z.string(),
            postcode: z.string(),
            country: z.string(),
          }),
          provenance: z.object({
            street: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
            suburb: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
            state: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
            postcode: z.enum(['entered', 'asserted', 'inferred', 'replaced']),
          }),
          verdict: z
            .object({
              addressComplete: z.boolean(),
              hasUnconfirmedComponents: z.boolean(),
              hasInferredComponents: z.boolean(),
              hasReplacedComponents: z.boolean(),
              validationGranularity: z.string(),
            })
            .optional(),
        })
        .optional(),
    })
    .optional(),
});

export const zPayoutPhase2TicketInput = z.object({
  ticketNumber: z.string().nullish(),
  egmNumber: z.string().nullish(),
  amountInCents: z.int().gte(1),
  ticketFileId: z.uuid().nullish(),
  kycPerform: z.boolean().nullish(),
  ticketNotes: z.string().optional(),
});

export const zPayoutPhase3KycInput = z.object({
  kycPatronSignatureFileId: z.uuid().optional(),
  performDvsCheck: z.boolean().optional().default(false),
  files: z
    .array(
      z.object({
        frontFileId: z.uuid(),
        backFileId: z.uuid().nullish(),
        type: z.enum(['primary', 'secondary']),
        code: zDocumentCodes,
      }),
    )
    .optional(),
});

export const zPayoutPhase4ContactPaymentInput = z.object({
  paymentCashInCents: z.int().gte(0).optional().default(0),
  paymentChequeInCents: z.int().gte(0).optional().default(0),
  paymentEftInCents: z.int().gte(0).optional().default(0),
  paymentEftBsb: z.string().nullish(),
  paymentEftAccountName: z.string().nullish(),
  paymentEftAccountNumber: z.string().nullish(),
  eftRiskAcceptanceReason: z.string().min(1).optional(),
});

export const zPayoutConfirmationOfPayeeVerifyInput = z.object({
  paymentEftBsb: z.string().min(1),
  paymentEftAccountNumber: z.string().min(1),
  paymentEftAccountName: z.string().min(1),
});

export const zPayoutConfirmationOfPayeeNotesUpdateInput = z.object({
  notes: z.string(),
});

export const zPayoutPhase5PatronSignOffInput = z.object({
  patronEmailConsented: z.boolean().nullish(),
  patronReceiptEmailTarget: z.email().nullish(),
  paymentPatronConfirmationSignatureFileId: z.uuid(),
});

export const zPayoutPhase6AttendantSignOffInput = z.object({
  paymentAttendantConfirmationSignatureFileId: z.uuid(),
  patronBehaviourObservations: z.array(zPatronBehaviourObservation).optional(),
  gamingBehaviourObservations: z.array(zGamingBehaviourObservation).optional(),
});

export const zPatronSimilarityResultItem = z.object({
  patronId: z.uuid(),
  overallSimilarityScore: z.number(),
  photoUrl: z.string().optional(),
  facts: z.object({
    first_name: z
      .object({
        value: z.string(),
        similarity: z.number(),
      })
      .optional(),
    middle_names: z
      .object({
        value: z.string(),
        similarity: z.number(),
      })
      .optional(),
    last_name: z
      .object({
        value: z.string(),
        similarity: z.number(),
      })
      .optional(),
    date_of_birth: z
      .object({
        value: z.string(),
        similarity: z.number(),
      })
      .optional(),
    government_identity_document: z
      .object({
        value: z.string(),
        similarity: z.number(),
      })
      .optional(),
    phone: z
      .object({
        value: z.string(),
        similarity: z.number(),
      })
      .optional(),
    patron_type: z
      .object({
        value: z.string(),
        similarity: z.number(),
      })
      .optional(),
  }),
  comparedFacts: z
    .array(
      z.enum([
        'first_name',
        'middle_names',
        'last_name',
        'date_of_birth',
        'government_identity_document',
        'phone',
        'patron_type',
      ]),
    )
    .optional(),
  documentType: zPatronIdTypes.optional(),
  documentNumberMasked: z.string().optional(),
  matchPercent: z.int().gte(0).lte(100).optional(),
  nameMatchPercent: z.int().gte(0).lte(100).optional(),
  patronType: z.enum(['patron', 'employee', 'contractor']).optional(),
  checkCount: z.int().optional(),
  lastCheckedAt: z.iso.datetime().optional(),
});

export const zPatronSimilaritySearchResult = z.array(zPatronSimilarityResultItem);

export const zPayoutReviewState = z.object({
  payout: zPayoutEnriched,
  step: z.enum(['link_patron', 'resolve_pep', 'risk_assessment', 'ready']),
  patronMatches: zPatronSimilaritySearchResult.optional(),
  pepMatches: z.array(zPepMatch).optional(),
  riskAssessmentResult: zPayoutRiskAssessmentResult.optional(),
});

export const zPayoutReviewAction = z.union([
  z.object({
    type: z.enum(['link_patron']),
    patronId: z.uuid(),
    temporaryManagerToken: z.string().optional(),
  }),
  z.object({
    type: z.enum(['create_patron']),
    temporaryManagerToken: z.string().optional(),
  }),
  z.object({
    type: z.enum(['resolve_pep']),
    status: z.enum([
      'failed',
      'unknown',
      'no-match',
      'confirmed-pep',
      'confirmed-not-pep',
      'confirmed-associated',
    ]),
    match: zPepMatch.optional(),
    temporaryManagerToken: z.string().optional(),
  }),
  z.object({
    type: z.enum(['acknowledge_risk']),
    level: z.enum(['low', 'medium', 'high']),
    notes: z.string().optional(),
    patronBehaviourObservations: z.array(zPatronBehaviourObservation).optional(),
    gamingBehaviourObservations: z.array(zGamingBehaviourObservation).optional(),
    temporaryManagerToken: z.string().optional(),
  }),
  z.object({
    type: z.enum(['update_observations']),
    patronBehaviourObservations: z.array(zPatronBehaviourObservation).optional(),
    gamingBehaviourObservations: z.array(zGamingBehaviourObservation).optional(),
    temporaryManagerToken: z.string().optional(),
  }),
  z.object({
    type: z.enum(['hold_auto_eft_payment']),
    payoutId: z.uuid(),
    release: z.boolean().optional(),
    holdExpiresAt: z.iso.datetime().optional(),
    temporaryManagerToken: z.string().optional(),
  }),
  z.object({
    type: z.enum(['cancel_auto_eft_payment']),
    payoutId: z.uuid(),
    reasonCode: z.enum([
      'incorrect_bank_details',
      'patron_request',
      'duplicate_payment',
      'under_review',
      'other',
    ]),
    reasonText: z.string().optional(),
    temporaryManagerToken: z.string().optional(),
  }),
  z.object({
    type: z.enum(['mark_auto_eft_payment_retryable']),
    payoutId: z.uuid(),
    reasonText: z.string().optional(),
    temporaryManagerToken: z.string().optional(),
  }),
]);

export const zPayoutManagerElevationRefresh = z.object({
  token: z.string(),
});

export const zPayoutPhase7ManagerSignOffInput = z.object({
  reviewedApprovedSignatureFileId: z.uuid().optional(),
  reviewedRejectedReason: z.string().optional().default(''),
  temporaryManagerToken: z.string().optional(),
});

export const zPaymentLeg = z.enum(['cash', 'eft', 'cheque']);

export const zPayoutPaymentLegResult = z.union([
  z.object({
    leg: zPaymentLeg,
    outcome: z.enum(['recorded']),
    recordedBy: z.uuid(),
    recordedAt: zDatetimeIsoString,
  }),
  z.object({
    leg: zPaymentLeg,
    outcome: z.enum(['refused']),
    requiresPermission: z.string(),
  }),
]);

export const zPayoutPhase8PayoutResult = z.object({
  payout: zPayoutEnriched,
  legs: z.array(zPayoutPaymentLegResult),
});

export const zPayoutPhase8PayoutInput = z.object({
  cash: z
    .object({
      paymentConfirmationSignatureId: z.uuid(),
    })
    .optional(),
  eft: z
    .object({
      paymentConfirmationSignatureId: z.uuid(),
      transactionNumber: z.string().optional(),
    })
    .optional(),
  cheque: z
    .object({
      paidChequeFileId: z.uuid(),
      paymentConfirmationSignatureId: z.uuid(),
      paidChequeChequeNumber: z.string().optional(),
    })
    .optional(),
});

export const zPayoutDiscardInput = z.object({
  discardedReason: z.string().min(1).max(1000),
});

export const zEftAutoPaymentHistoryStatus = z.enum([
  'scheduled',
  'held',
  'locked',
  'submitting',
  'processing',
  'paid',
  'payment_failed',
  'cancelled',
]);

export const zEftAutoPaymentHistoryItem = z.object({
  id: z.uuid(),
  payoutId: z.uuid(),
  payoutReference: z.string(),
  amountInCents: z.int().gte(0),
  status: zEftAutoPaymentHistoryStatus,
  eligibleAt: zDatetimeIsoString,
  holdExpiresAt: zDatetimeIsoString.nullable(),
  heldAt: zDatetimeIsoString.nullable(),
  submittedAt: zDatetimeIsoString.nullable(),
  outcomeObservedAt: zDatetimeIsoString.nullable(),
  failureReason: z.string().nullable(),
  cancelledAt: zDatetimeIsoString.nullable(),
  cancellationReason: z.string().nullable(),
  payoutEftOutstanding: z.boolean(),
  createdAt: zDatetimeIsoString,
});

export const zEftAutoPaymentStage = z.enum([
  'queued',
  'paused',
  'transferring',
  'paid',
  'failed',
  'cancelled',
]);

export const zCheckdVenueUserRole = z.enum(['manager', 'staff']).nullable();

export const zPpVenueUser = z.object({
  id: z.uuid(),
  fullname: z.string(),
  email: z.email(),
  phoneNumber: z.string().nullable(),
  jobTitle: z.string().nullable(),
  role: zCheckdVenueUserRole,
  roleId: z.uuid().nullable(),
  roleName: z.string().nullable(),
  application: zApplications,
  isApplicationMember: z.boolean(),
  isVenueOnly: z.boolean(),
  status: z.enum(['invited', 'requested', 'active', 'inactive', 'suspended']).nullable(),
  invitedBy: z.uuid().nullable(),
  invitedByName: z.string().nullable(),
  invitedAt: z.iso.datetime().nullable(),
  inviteExpiresAt: z.iso.datetime().nullable(),
  lastLoginAt: z.iso.datetime().nullable(),
});

export const zUserPinCheckResponse = z.object({
  isValid: z.boolean(),
  token: z.string().optional(),
  lockedUntil: z.iso.datetime().optional(),
  lockScope: z.enum(['caller', 'all_callers']).optional(),
});

export const zUserPinCheckInput = z.object({
  pinCode: z.string().regex(/^(\d{4}|)$/),
  payoutId: z.uuid().optional(),
  requiredPermission: z
    .enum(['review_payouts', 'eft_payment'])
    .optional()
    .default('review_payouts'),
});

export const zCheckdUserVenueAssociation = z.object({
  id: z.uuid(),
  fullname: z.string().min(1).max(255),
  email: z.email(),
  phoneNumber: z.string().nullable(),
  photoFileId: z.uuid().nullable(),
  role: zCheckdVenueUserRole,
  roleId: z.uuid().nullable(),
  roleName: z.string().nullable(),
  securityFirm: z.string().max(255).nullable(),
  jobTitle: zJobTitles,
  application: zApplications,
  associatedBy: z.uuid().nullish(),
});

export const zCheckdCreateUserVenueAssociation = z.object({
  roleId: z.uuid(),
  securityFirm: z.string().max(255).nullable(),
  jobTitle: zJobTitles,
});

export const zCheckdUpdateUserVenueAssociation = z.object({
  roleId: z.uuid(),
  securityFirm: z.string().max(255).nullable(),
  jobTitle: zJobTitles,
});

export const zDeleteEntityResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
    success: z.literal(true),
  }),
});

export const zPokieVenueSettingRiskRule = z.object({
  ruleId: z.string(),
  label: z.string(),
  description: z.string(),
  defaultScore: z.int().gte(0),
  scoreSettingKey: z.enum([
    'shortTermPayoutLimitRuleScore',
    'identityVerificationFailedRuleScore',
    'identityVerificationNotRanRuleScore',
    'patronPepAssociatedRuleScore',
    'patronPepRuleScore',
    'adverseMediaRuleScore',
    'pepCheckFailRuleScore',
    'patronSanctionedRuleScore',
    'suspiciousPatronBehavioursObservedRuleScore',
    'unusualSourceOfFundsRuleScore',
    'unusualSourceOfWealthRuleScore',
    'nonCashPaymentOnlyRuleScore',
    'cashPayoutBehaviourChangeRuleScore',
    'newEftAccountRuleScore',
    'accountNameMismatchRuleScore',
    'connectIdDocumentNamePartialMatchRuleScore',
    'connectIdDocumentNameNotCheckedRuleScore',
    'confirmationOfPayeeRuleScore',
    'confirmationOfPayeeNotRunRuleScore',
    'differentIdToLastPayoutRuleScore',
    'addressDiffersFromPreviousPayoutRuleScore',
    'multipleLargePayoutsSameDayRuleScore',
    'mediumTermPayoutLimitRuleScore',
    'rejectedPayoutsInLookbackRuleScore',
    'frequentPayoutsInLookbackRuleScore',
    'highRiskPayoutInLookbackRuleScore',
    'mediumRiskPayoutInLookbackRuleScore',
    'averageMonthlyPayoutChangeRuleScore',
    'venueDistanceRuleScore',
    'nonAustralianIdRuleScore',
  ]),
  enabledSettingKey: z.enum([
    'shortTermPayoutLimitRuleEnabled',
    'identityVerificationFailedRuleEnabled',
    'identityVerificationNotRanRuleEnabled',
    'patronPepAssociatedRuleEnabled',
    'patronPepRuleEnabled',
    'adverseMediaRuleEnabled',
    'pepCheckFailRuleEnabled',
    'patronSanctionedRuleEnabled',
    'suspiciousPatronBehavioursObservedRuleEnabled',
    'unusualSourceOfFundsRuleEnabled',
    'unusualSourceOfWealthRuleEnabled',
    'nonCashPaymentOnlyRuleEnabled',
    'cashPayoutBehaviourChangeRuleEnabled',
    'newEftAccountRuleEnabled',
    'accountNameMismatchRuleEnabled',
    'connectIdDocumentNamePartialMatchRuleEnabled',
    'connectIdDocumentNameNotCheckedRuleEnabled',
    'confirmationOfPayeeRuleEnabled',
    'confirmationOfPayeeNotRunRuleEnabled',
    'differentIdToLastPayoutRuleEnabled',
    'addressDiffersFromPreviousPayoutRuleEnabled',
    'multipleLargePayoutsSameDayRuleEnabled',
    'mediumTermPayoutLimitRuleEnabled',
    'rejectedPayoutsInLookbackRuleEnabled',
    'frequentPayoutsInLookbackRuleEnabled',
    'highRiskPayoutInLookbackRuleEnabled',
    'mediumRiskPayoutInLookbackRuleEnabled',
    'averageMonthlyPayoutChangeRuleEnabled',
    'venueDistanceRuleEnabled',
    'nonAustralianIdRuleEnabled',
  ]),
  includeInRiskRegisterSettingKey: z.enum([
    'shortTermPayoutLimitRuleIncludeInRiskRegister',
    'identityVerificationFailedRuleIncludeInRiskRegister',
    'identityVerificationNotRanRuleIncludeInRiskRegister',
    'patronPepAssociatedRuleIncludeInRiskRegister',
    'patronPepRuleIncludeInRiskRegister',
    'adverseMediaRuleIncludeInRiskRegister',
    'pepCheckFailRuleIncludeInRiskRegister',
    'patronSanctionedRuleIncludeInRiskRegister',
    'suspiciousPatronBehavioursObservedRuleIncludeInRiskRegister',
    'unusualSourceOfFundsRuleIncludeInRiskRegister',
    'unusualSourceOfWealthRuleIncludeInRiskRegister',
    'nonCashPaymentOnlyRuleIncludeInRiskRegister',
    'cashPayoutBehaviourChangeRuleIncludeInRiskRegister',
    'newEftAccountRuleIncludeInRiskRegister',
    'accountNameMismatchRuleIncludeInRiskRegister',
    'connectIdDocumentNamePartialMatchRuleIncludeInRiskRegister',
    'connectIdDocumentNameNotCheckedRuleIncludeInRiskRegister',
    'confirmationOfPayeeRuleIncludeInRiskRegister',
    'confirmationOfPayeeNotRunRuleIncludeInRiskRegister',
    'differentIdToLastPayoutRuleIncludeInRiskRegister',
    'addressDiffersFromPreviousPayoutRuleIncludeInRiskRegister',
    'multipleLargePayoutsSameDayRuleIncludeInRiskRegister',
    'mediumTermPayoutLimitRuleIncludeInRiskRegister',
    'rejectedPayoutsInLookbackRuleIncludeInRiskRegister',
    'frequentPayoutsInLookbackRuleIncludeInRiskRegister',
    'highRiskPayoutInLookbackRuleIncludeInRiskRegister',
    'mediumRiskPayoutInLookbackRuleIncludeInRiskRegister',
    'averageMonthlyPayoutChangeRuleIncludeInRiskRegister',
    'venueDistanceRuleIncludeInRiskRegister',
    'nonAustralianIdRuleIncludeInRiskRegister',
  ]),
});

export const zRequire = z.enum(['HIDDEN', 'NOT_REQUIRED', 'REQUIRE_ANY', 'REQUIRE_ALL']);

export const zCollectionPoint = z.enum(['NEW_PAYOUT_PROCESS', 'PAYOUT_REVIEW_PROCESS']);

export const zProofOfPayoutOptions = z.enum([
  'not_required',
  'require_any_field',
  'require_any_field_and_photo',
  'require_all_fields',
  'require_all_fields_and_photo',
]);

export const zConfirmationOfPayeeSettingOptions = z.enum([
  'disabled',
  'staff_facing',
  'manager_only',
]);

export const zNotificationEvent = z.enum([
  'payout_submitted_for_review',
  'payout_approved_pending_payment',
  'payout_rejected',
  'aml_risk_register_entry_added',
  'auto_eft_payment_failed',
  'auto_eft_payment_cancelled',
]);

export const zNotificationRecipient = z.object({
  email: z.email(),
  events: z.array(zNotificationEvent),
});

export const zPatronReceiptMode = z.enum([
  'disabled',
  'automatic_submission',
  'automatic_approval',
  'automatic_both',
  'manual',
]);

export const zPatronIdStorageOptions = z.enum(['until_payout_decision', 'retain_for_duration']);

export const zPokieVenueSetting = z.object({
  id: z.uuid(),
  venueId: z.uuid(),
  requirePatronResidentialAddress: zRequire,
  collectionPointPatronResidentialAddress: zCollectionPoint,
  requirePatronPhoneNumber: zRequire,
  collectionPointPatronPhoneNumber: zCollectionPoint,
  requirePatronEmail: zRequire,
  collectionPointPatronEmail: zCollectionPoint,
  requirePatronOccupation: zRequire,
  collectionPointPatronOccupation: zCollectionPoint,
  requirePatronSourceOfFunds: zRequire,
  collectionPointPatronSourceOfFunds: zCollectionPoint,
  requirePatronSourceOfWealth: zRequire,
  collectionPointPatronSourceOfWealth: zCollectionPoint,
  proofOfPayout: zProofOfPayoutOptions,
  confirmationOfPayeeSetting: zConfirmationOfPayeeSettingOptions,
  confirmationOfPayeeAvailable: z.boolean(),
  autoEftPlatformEntitled: z.boolean(),
  autoEftMwEnabledConfirmedBy: z.uuid().nullable(),
  autoEftMwEnabledConfirmedAt: z.iso.datetime().nullable(),
  autoEftEnabled: z.boolean(),
  autoEftHoldHours: z.int(),
  autoEftVenueChoiceAt: z.iso.datetime().nullable(),
  requirePatronBehaviourObservations: zRequire,
  collectionPointPatronBehaviourObservations: zCollectionPoint,
  requireGamingBehaviourObservations: zRequire,
  collectionPointGamingBehaviourObservations: zCollectionPoint,
  allowCheque: z.boolean(),
  allowCash: z.boolean(),
  allowEft: z.boolean(),
  riskRegisterEnabled: z.boolean(),
  patronNowEnabled: z.boolean(),
  cashFloorLimitInCents: z.int().gte(0),
  requiredPointsOfId: z.int().gte(0),
  mandatoryKycThresholdInCents: z.int().gte(0),
  notificationRecipients: z.array(zNotificationRecipient),
  patronReceiptMode: zPatronReceiptMode,
  primaryIdDocumentStorage: zPatronIdStorageOptions,
  primaryIdDocumentRetentionDays: z.int().gte(0).lte(180),
  secondaryIdDocumentStorage: zPatronIdStorageOptions,
  secondaryIdDocumentRetentionDays: z.int().gte(0).lte(180),
  patronPhotoRetention: z.enum(['as_needed', 'after_last_visit']),
  patronPhotoRetentionDays: z.int(),
  venueLat: z.number().nullable(),
  venueLong: z.number().nullable(),
  connectIdEnabled: z.boolean(),
  connectIdSecondDocumentRequired: z.boolean(),
  patronMediumRiskScoreThreshold: z.int().gte(0),
  patronHighRiskScoreThreshold: z.int().gte(0),
  shortTermPayoutLimitRuleScore: z.int().gte(0),
  shortTermPayoutLimitRuleEnabled: z.boolean(),
  shortTermPayoutLimitRuleIncludeInRiskRegister: z.boolean(),
  identityVerificationFailedRuleScore: z.int().gte(0),
  identityVerificationFailedRuleEnabled: z.boolean(),
  identityVerificationFailedRuleIncludeInRiskRegister: z.boolean(),
  identityVerificationNotRanRuleScore: z.int().gte(0),
  identityVerificationNotRanRuleEnabled: z.boolean(),
  identityVerificationNotRanRuleIncludeInRiskRegister: z.boolean(),
  patronPepAssociatedRuleScore: z.int().gte(0),
  patronPepAssociatedRuleEnabled: z.boolean(),
  patronPepAssociatedRuleIncludeInRiskRegister: z.boolean(),
  patronPepRuleScore: z.int().gte(0),
  patronPepRuleEnabled: z.boolean(),
  patronPepRuleIncludeInRiskRegister: z.boolean(),
  pepCheckFailRuleScore: z.int().gte(0),
  pepCheckFailRuleEnabled: z.boolean(),
  pepCheckFailRuleIncludeInRiskRegister: z.boolean(),
  patronSanctionedRuleScore: z.int().gte(0),
  patronSanctionedRuleEnabled: z.boolean(),
  patronSanctionedRuleIncludeInRiskRegister: z.boolean(),
  nonCashPaymentOnlyRuleScore: z.int().gte(0),
  nonCashPaymentOnlyRuleEnabled: z.boolean(),
  nonCashPaymentOnlyRuleIncludeInRiskRegister: z.boolean(),
  newEftAccountRuleScore: z.int().gte(0),
  newEftAccountRuleEnabled: z.boolean(),
  newEftAccountRuleIncludeInRiskRegister: z.boolean(),
  differentIdToLastPayoutRuleScore: z.int().gte(0),
  differentIdToLastPayoutRuleEnabled: z.boolean(),
  differentIdToLastPayoutRuleIncludeInRiskRegister: z.boolean(),
  multipleLargePayoutsSameDayRuleScore: z.int().gte(0),
  multipleLargePayoutsSameDayRuleEnabled: z.boolean(),
  multipleLargePayoutsSameDayRuleIncludeInRiskRegister: z.boolean(),
  mediumTermPayoutLimitRuleScore: z.int().gte(0),
  mediumTermPayoutLimitRuleEnabled: z.boolean(),
  mediumTermPayoutLimitRuleIncludeInRiskRegister: z.boolean(),
  rejectedPayoutsInLookbackRuleScore: z.int().gte(0),
  rejectedPayoutsInLookbackRuleEnabled: z.boolean(),
  rejectedPayoutsInLookbackRuleIncludeInRiskRegister: z.boolean(),
  addressDiffersFromPreviousPayoutRuleScore: z.int().gte(0),
  addressDiffersFromPreviousPayoutRuleEnabled: z.boolean(),
  addressDiffersFromPreviousPayoutRuleIncludeInRiskRegister: z.boolean(),
  frequentPayoutsInLookbackRuleScore: z.int().gte(0),
  frequentPayoutsInLookbackRuleEnabled: z.boolean(),
  frequentPayoutsInLookbackRuleIncludeInRiskRegister: z.boolean(),
  highRiskPayoutInLookbackRuleScore: z.int().gte(0),
  highRiskPayoutInLookbackRuleEnabled: z.boolean(),
  highRiskPayoutInLookbackRuleIncludeInRiskRegister: z.boolean(),
  mediumRiskPayoutInLookbackRuleScore: z.int().gte(0),
  mediumRiskPayoutInLookbackRuleEnabled: z.boolean(),
  mediumRiskPayoutInLookbackRuleIncludeInRiskRegister: z.boolean(),
  averageMonthlyPayoutChangeRuleScore: z.int().gte(0),
  averageMonthlyPayoutChangeRuleEnabled: z.boolean(),
  averageMonthlyPayoutChangeRuleIncludeInRiskRegister: z.boolean(),
  cashPayoutBehaviourChangeRuleScore: z.int().gte(0),
  cashPayoutBehaviourChangeRuleEnabled: z.boolean(),
  cashPayoutBehaviourChangeRuleIncludeInRiskRegister: z.boolean(),
  adverseMediaRuleScore: z.int().gte(0),
  adverseMediaRuleEnabled: z.boolean(),
  adverseMediaRuleIncludeInRiskRegister: z.boolean(),
  suspiciousPatronBehavioursObservedRuleScore: z.int().gte(0),
  suspiciousPatronBehavioursObservedRuleEnabled: z.boolean(),
  suspiciousPatronBehavioursObservedRuleIncludeInRiskRegister: z.boolean(),
  unusualSourceOfFundsRuleScore: z.int().gte(0),
  unusualSourceOfFundsRuleEnabled: z.boolean(),
  unusualSourceOfFundsRuleIncludeInRiskRegister: z.boolean(),
  unusualSourceOfWealthRuleScore: z.int().gte(0),
  unusualSourceOfWealthRuleEnabled: z.boolean(),
  unusualSourceOfWealthRuleIncludeInRiskRegister: z.boolean(),
  venueDistanceRuleScore: z.int().gte(0),
  venueDistanceRuleEnabled: z.boolean(),
  venueDistanceRuleIncludeInRiskRegister: z.boolean(),
  venueDistanceRuleThresholdKm: z.int().gte(1),
  nonAustralianIdRuleScore: z.int().gte(0),
  nonAustralianIdRuleEnabled: z.boolean(),
  nonAustralianIdRuleIncludeInRiskRegister: z.boolean(),
  confirmationOfPayeeRuleScore: z.int().gte(0),
  confirmationOfPayeeRuleEnabled: z.boolean(),
  confirmationOfPayeeRuleIncludeInRiskRegister: z.boolean(),
  confirmationOfPayeeNotRunRuleScore: z.int().gte(0),
  confirmationOfPayeeNotRunRuleEnabled: z.boolean(),
  confirmationOfPayeeNotRunRuleIncludeInRiskRegister: z.boolean(),
  accountNameMismatchRuleScore: z.int().gte(0),
  accountNameMismatchRuleEnabled: z.boolean(),
  accountNameMismatchRuleIncludeInRiskRegister: z.boolean(),
  connectIdDocumentNamePartialMatchRuleScore: z.int().gte(0),
  connectIdDocumentNamePartialMatchRuleEnabled: z.boolean(),
  connectIdDocumentNamePartialMatchRuleIncludeInRiskRegister: z.boolean(),
  connectIdDocumentNameNotCheckedRuleScore: z.int().gte(0),
  connectIdDocumentNameNotCheckedRuleEnabled: z.boolean(),
  connectIdDocumentNameNotCheckedRuleIncludeInRiskRegister: z.boolean(),
  shortTermPayoutLimitLookbackDays: z.int().gte(1),
  shortTermPayoutLimitThresholdInCents: z.int().gte(0),
  mediumTermPayoutLimitLookbackDays: z.int().gte(1),
  mediumTermPayoutLimitThresholdInCents: z.int().gte(0),
  rejectedPayoutsLookbackDays: z.int().gte(1),
  averageMonthlyPayoutChangeThresholdPercentage: z.int().gte(0),
  nonCashPaymentCashThresholdInCents: z.int().gte(0),
  nonCashPaymentMinimumNonCashInCents: z.int().gte(0),
  newEftAccountPayoutHistoryLimit: z.int().gte(1),
  cashPayoutBehaviourPayoutHistoryLimit: z.int().gte(1),
  differentIdPayoutHistoryLimit: z.int().gte(1),
  addressDiffersPayoutHistoryLimit: z.int().gte(1),
  frequentPayoutsCountThreshold: z.int().gte(1),
  frequentPayoutsLookbackDays: z.int().gte(1),
  highRiskPayoutLookbackDays: z.int().gte(1),
  mediumRiskPayoutLookbackDays: z.int().gte(1),
  multipleLargePayoutsSameDayThresholdInCents: z.int().gte(0),
  multipleLargePayoutsSameDayCountThreshold: z.int().gte(1),
  unusualSourceOfFundsValues: z.array(z.string()),
  unusualSourceOfWealthValues: z.array(z.string()),
});

export const zPokieVenueSettingUpdateInput = z.object({
  requirePatronResidentialAddress: zRequire,
  collectionPointPatronResidentialAddress: zCollectionPoint.optional(),
  requirePatronPhoneNumber: zRequire,
  collectionPointPatronPhoneNumber: zCollectionPoint.optional(),
  requirePatronEmail: zRequire,
  collectionPointPatronEmail: zCollectionPoint.optional(),
  requirePatronOccupation: zRequire,
  collectionPointPatronOccupation: zCollectionPoint.optional(),
  requirePatronSourceOfFunds: zRequire,
  collectionPointPatronSourceOfFunds: zCollectionPoint.optional(),
  requirePatronSourceOfWealth: zRequire,
  collectionPointPatronSourceOfWealth: zCollectionPoint.optional(),
  proofOfPayout: zProofOfPayoutOptions.optional(),
  confirmationOfPayeeSetting: zConfirmationOfPayeeSettingOptions.optional(),
  requirePatronBehaviourObservations: zRequire,
  collectionPointPatronBehaviourObservations: zCollectionPoint.optional(),
  requireGamingBehaviourObservations: zRequire,
  collectionPointGamingBehaviourObservations: zCollectionPoint.optional(),
  allowCheque: z.boolean(),
  allowCash: z.boolean(),
  allowEft: z.boolean(),
  cashFloorLimitInCents: z.int().gte(0),
  requiredPointsOfId: z.int().gte(0),
  mandatoryKycThresholdInCents: z.int().gte(0).lte(500000),
  notificationRecipients: z.array(zNotificationRecipient).optional(),
  patronReceiptMode: zPatronReceiptMode.optional(),
  primaryIdDocumentStorage: zPatronIdStorageOptions.optional(),
  primaryIdDocumentRetentionDays: z.int().gte(0).lte(180).optional().default(30),
  secondaryIdDocumentStorage: zPatronIdStorageOptions.optional(),
  secondaryIdDocumentRetentionDays: z.int().gte(0).lte(180).optional().default(30),
  connectIdSecondDocumentRequired: z.boolean().optional(),
  autoEftEnabled: z.boolean().optional(),
  autoEftHoldHours: z.int().gte(1).lte(72).optional(),
  patronMediumRiskScoreThreshold: z.int().gte(0).optional(),
  patronHighRiskScoreThreshold: z.int().gte(0).optional(),
  shortTermPayoutLimitRuleScore: z.int().gte(0).optional(),
  shortTermPayoutLimitRuleEnabled: z.boolean().optional(),
  shortTermPayoutLimitRuleIncludeInRiskRegister: z.boolean().optional(),
  identityVerificationFailedRuleScore: z.int().gte(0).optional(),
  identityVerificationFailedRuleEnabled: z.boolean().optional(),
  identityVerificationFailedRuleIncludeInRiskRegister: z.boolean().optional(),
  identityVerificationNotRanRuleScore: z.int().gte(0).optional(),
  identityVerificationNotRanRuleEnabled: z.boolean().optional(),
  identityVerificationNotRanRuleIncludeInRiskRegister: z.boolean().optional(),
  patronPepAssociatedRuleScore: z.int().gte(0).optional(),
  patronPepAssociatedRuleEnabled: z.boolean().optional(),
  patronPepAssociatedRuleIncludeInRiskRegister: z.boolean().optional(),
  patronPepRuleScore: z.int().gte(0).optional(),
  patronPepRuleEnabled: z.boolean().optional(),
  patronPepRuleIncludeInRiskRegister: z.boolean().optional(),
  pepCheckFailRuleScore: z.int().gte(0).optional(),
  pepCheckFailRuleEnabled: z.boolean().optional(),
  pepCheckFailRuleIncludeInRiskRegister: z.boolean().optional(),
  patronSanctionedRuleScore: z.int().gte(0).optional(),
  patronSanctionedRuleEnabled: z.boolean().optional(),
  patronSanctionedRuleIncludeInRiskRegister: z.boolean().optional(),
  nonCashPaymentOnlyRuleScore: z.int().gte(0).optional(),
  nonCashPaymentOnlyRuleEnabled: z.boolean().optional(),
  nonCashPaymentOnlyRuleIncludeInRiskRegister: z.boolean().optional(),
  newEftAccountRuleScore: z.int().gte(0).optional(),
  newEftAccountRuleEnabled: z.boolean().optional(),
  newEftAccountRuleIncludeInRiskRegister: z.boolean().optional(),
  differentIdToLastPayoutRuleScore: z.int().gte(0).optional(),
  differentIdToLastPayoutRuleEnabled: z.boolean().optional(),
  differentIdToLastPayoutRuleIncludeInRiskRegister: z.boolean().optional(),
  multipleLargePayoutsSameDayRuleScore: z.int().gte(0).optional(),
  multipleLargePayoutsSameDayRuleEnabled: z.boolean().optional(),
  multipleLargePayoutsSameDayRuleIncludeInRiskRegister: z.boolean().optional(),
  mediumTermPayoutLimitRuleScore: z.int().gte(0).optional(),
  mediumTermPayoutLimitRuleEnabled: z.boolean().optional(),
  mediumTermPayoutLimitRuleIncludeInRiskRegister: z.boolean().optional(),
  rejectedPayoutsInLookbackRuleScore: z.int().gte(0).optional(),
  rejectedPayoutsInLookbackRuleEnabled: z.boolean().optional(),
  rejectedPayoutsInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  addressDiffersFromPreviousPayoutRuleScore: z.int().gte(0).optional(),
  addressDiffersFromPreviousPayoutRuleEnabled: z.boolean().optional(),
  addressDiffersFromPreviousPayoutRuleIncludeInRiskRegister: z.boolean().optional(),
  frequentPayoutsInLookbackRuleScore: z.int().gte(0).optional(),
  frequentPayoutsInLookbackRuleEnabled: z.boolean().optional(),
  frequentPayoutsInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  highRiskPayoutInLookbackRuleScore: z.int().gte(0).optional(),
  highRiskPayoutInLookbackRuleEnabled: z.boolean().optional(),
  highRiskPayoutInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  mediumRiskPayoutInLookbackRuleScore: z.int().gte(0).optional(),
  mediumRiskPayoutInLookbackRuleEnabled: z.boolean().optional(),
  mediumRiskPayoutInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  averageMonthlyPayoutChangeRuleScore: z.int().gte(0).optional(),
  averageMonthlyPayoutChangeRuleEnabled: z.boolean().optional(),
  averageMonthlyPayoutChangeRuleIncludeInRiskRegister: z.boolean().optional(),
  cashPayoutBehaviourChangeRuleScore: z.int().gte(0).optional(),
  cashPayoutBehaviourChangeRuleEnabled: z.boolean().optional(),
  cashPayoutBehaviourChangeRuleIncludeInRiskRegister: z.boolean().optional(),
  adverseMediaRuleScore: z.int().gte(0).optional(),
  adverseMediaRuleEnabled: z.boolean().optional(),
  adverseMediaRuleIncludeInRiskRegister: z.boolean().optional(),
  suspiciousPatronBehavioursObservedRuleScore: z.int().gte(0).optional(),
  suspiciousPatronBehavioursObservedRuleEnabled: z.boolean().optional(),
  suspiciousPatronBehavioursObservedRuleIncludeInRiskRegister: z.boolean().optional(),
  unusualSourceOfFundsRuleScore: z.int().gte(0).optional(),
  unusualSourceOfFundsRuleEnabled: z.boolean().optional(),
  unusualSourceOfFundsRuleIncludeInRiskRegister: z.boolean().optional(),
  unusualSourceOfWealthRuleScore: z.int().gte(0).optional(),
  unusualSourceOfWealthRuleEnabled: z.boolean().optional(),
  unusualSourceOfWealthRuleIncludeInRiskRegister: z.boolean().optional(),
  venueDistanceRuleScore: z.int().gte(0).optional(),
  venueDistanceRuleEnabled: z.boolean().optional(),
  venueDistanceRuleIncludeInRiskRegister: z.boolean().optional(),
  venueDistanceRuleThresholdKm: z.int().gte(1).optional(),
  nonAustralianIdRuleScore: z.int().gte(0).optional(),
  nonAustralianIdRuleEnabled: z.boolean().optional(),
  nonAustralianIdRuleIncludeInRiskRegister: z.boolean().optional(),
  confirmationOfPayeeRuleScore: z.int().gte(0).optional(),
  confirmationOfPayeeRuleEnabled: z.boolean().optional(),
  confirmationOfPayeeRuleIncludeInRiskRegister: z.boolean().optional(),
  confirmationOfPayeeNotRunRuleScore: z.int().gte(0).optional(),
  confirmationOfPayeeNotRunRuleEnabled: z.boolean().optional(),
  confirmationOfPayeeNotRunRuleIncludeInRiskRegister: z.boolean().optional(),
  accountNameMismatchRuleScore: z.int().gte(0).optional(),
  accountNameMismatchRuleEnabled: z.boolean().optional(),
  accountNameMismatchRuleIncludeInRiskRegister: z.boolean().optional(),
  connectIdDocumentNamePartialMatchRuleScore: z.int().gte(0).optional(),
  connectIdDocumentNamePartialMatchRuleEnabled: z.boolean().optional(),
  connectIdDocumentNamePartialMatchRuleIncludeInRiskRegister: z.boolean().optional(),
  connectIdDocumentNameNotCheckedRuleScore: z.int().gte(0).optional(),
  connectIdDocumentNameNotCheckedRuleEnabled: z.boolean().optional(),
  connectIdDocumentNameNotCheckedRuleIncludeInRiskRegister: z.boolean().optional(),
  shortTermPayoutLimitLookbackDays: z.int().gte(1).optional(),
  shortTermPayoutLimitThresholdInCents: z.int().gte(0).optional(),
  mediumTermPayoutLimitLookbackDays: z.int().gte(1).optional(),
  mediumTermPayoutLimitThresholdInCents: z.int().gte(0).optional(),
  rejectedPayoutsLookbackDays: z.int().gte(1).optional(),
  averageMonthlyPayoutChangeThresholdPercentage: z.int().gte(0).optional(),
  nonCashPaymentCashThresholdInCents: z.int().gte(0).optional(),
  nonCashPaymentMinimumNonCashInCents: z.int().gte(0).optional(),
  newEftAccountPayoutHistoryLimit: z.int().gte(1).optional(),
  cashPayoutBehaviourPayoutHistoryLimit: z.int().gte(1).optional(),
  differentIdPayoutHistoryLimit: z.int().gte(1).optional(),
  addressDiffersPayoutHistoryLimit: z.int().gte(1).optional(),
  frequentPayoutsCountThreshold: z.int().gte(1).optional(),
  frequentPayoutsLookbackDays: z.int().gte(1).optional(),
  highRiskPayoutLookbackDays: z.int().gte(1).optional(),
  mediumRiskPayoutLookbackDays: z.int().gte(1).optional(),
  multipleLargePayoutsSameDayThresholdInCents: z.int().gte(0).optional(),
  multipleLargePayoutsSameDayCountThreshold: z.int().gte(1).optional(),
  unusualSourceOfFundsValues: z.array(z.string()).optional(),
  unusualSourceOfWealthValues: z.array(z.string()).optional(),
});

export const zVoiCheckType = z.enum(['simple', 'advanced']);

export const zVoiDocumentCode = z.enum([
  'AUS_PASSPORT_CURR_EXP',
  'AUS_CITZ_CERT',
  'AUS_BIRTH_CERT_FULL',
  'AUS_CERT_IDENTITY',
  'AUS_DRIVER_LICENCE',
  'AUS_TERT_STUDENT_ID',
  'AUS_PHOTO_ID',
  'AUS_GOV_EMP_ID',
  'AUS_DEF_FORCE_ID',
  'AUS_DVA_CARD',
  'AUS_CENTRELINK_CARD',
  'AUS_BIRTH_CERT_EXTRACT',
  'AUS_BIRTH_CARD_NSW',
  'AUS_MEDICARE_CARD',
  'AUS_CREDIT_CARD',
  'AUS_MARRIAGE_CERT',
  'AUS_DECREE_NISI_ABSOLUTE',
  'AUS_CHANGE_NAME_CERT',
  'AUS_BANK_STATEMENT',
  'AUS_PROPERTY_LEASE',
  'AUS_TAX_ASSESSMENT',
  'AUS_MORTGAGE_DOCS',
  'AUS_RATING_AUTHORITY',
  'AUS_UTILITY_BILL',
  'AUS_INDIGENOUS_ORG_REF',
  'INT_PASSPORT_CURR',
  'INT_BIRTH_CERT_FULL',
  'INT_DRIVER_LICENCE',
  'INT_GOV_EMP_ID',
  'INT_TRAVEL_DOC',
  'INT_CREDIT_CARD',
  'INT_BANK_STATEMENT',
  'OTHER_ID',
  'AUS_QLD_DIGITAL_LICENCE',
  'AUS_VIC_DIGITAL_LICENCE',
  'AUS_NSW_DIGITAL_LICENCE',
]);

export const zVoiDocument = z.object({
  id: z.uuid(),
  code: zVoiDocumentCode,
  points: z.int().gte(0).nullable(),
});

export const zVoiSetting = z.object({
  id: z.uuid(),
  venueId: z.uuid(),
  checkType: zVoiCheckType,
  numberSecondaryDocs: z.int().gte(1),
  requiredPoints: z.int().gte(1).nullable(),
  documents: z.array(zVoiDocument),
});

export const zVoiSettingUpdateInput = z.object({
  checkType: zVoiCheckType,
  numberSecondaryDocs: z.int().gte(1).optional().default(1),
  requiredPoints: z.int().gte(1).nullish(),
  documents: z.array(
    z.object({
      code: zVoiDocumentCode,
      points: z.int().gte(0).nullish(),
    }),
  ),
});

export const zCheckdDashboardMetrics = z.object({
  draft: z.number(),
  payment_pending: z.number(),
  finalised: z.number(),
  discarded: z.number(),
  needs_review: z.number(),
  rejected: z.number(),
});

export const zCheckdAutoEftDashboard = z.object({
  dueWithin24h: z.object({
    count: z.int().gte(0),
    totalInCents: z.int().gte(0),
    payments: z.array(zEftAutoPaymentHistoryItem),
  }),
  failures: z.object({
    count: z.int().gte(0),
    payments: z.array(zEftAutoPaymentHistoryItem),
  }),
});

export const zPatronIdentitySearch = z.object({
  firstName: z.string().max(200).optional(),
  middleName: z.string().max(200).optional(),
  lastName: z.string().max(200).optional(),
  dateOfBirth: z.iso.date().optional(),
  phone: z.string().max(200).optional(),
  document: z
    .object({
      type: zPatronIdTypes,
      number: z.string().min(1).max(200),
    })
    .optional(),
  photoFileId: z.uuid().optional(),
});

export const zPatronDetailField = z.enum([
  'firstName',
  'middleName',
  'lastName',
  'dateOfBirth',
  'phone',
]);

export const zPatronCaptureComparison = z.object({
  offerId: z.uuid().nullable(),
  differences: z.array(
    z.object({
      field: zPatronDetailField,
      recorded: z.string(),
      scanned: z.string(),
    }),
  ),
});

export const zPatronIdentityCapture = z.object({
  firstName: z.string().min(1).max(200),
  middleName: z.string().max(200).optional(),
  lastName: z.string().max(200).optional(),
  dateOfBirth: z.iso.date().optional(),
  phone: z.string().max(200).optional(),
  document: z
    .object({
      type: zPatronIdTypes,
      number: z.string().min(1).max(200),
    })
    .optional(),
  photoFileId: z.uuid().optional(),
});

export const zPatronRecorded = z.object({
  patronId: z.uuid(),
});

export const zPatronCaptureDecision = z.object({
  offerId: z.uuid(),
  outcome: z.enum(['updated', 'declined']),
  fields: z.array(zPatronDetailField),
  recorded: z.object({
    firstName: z.string().nullish(),
    middleName: z.string().nullish(),
    lastName: z.string().nullish(),
    dateOfBirth: z.string().nullish(),
    phone: z.string().nullish(),
  }),
});

export const zPatronCaptureConfirm = zPatronIdentityCapture.and(
  z.object({
    detailsDecision: zPatronCaptureDecision.optional(),
  }),
);

export const zPatronTypeUpdate = z.object({
  patronType: z.enum(['patron', 'employee', 'contractor']),
});

export const zPatronScreeningCheck = z.object({
  id: z.uuid(),
  triggerReason: z.enum(['payout_review', 'manual_recheck']),
  pepVerdict: z
    .enum([
      'failed',
      'unknown',
      'no-match',
      'confirmed-pep',
      'confirmed-not-pep',
      'confirmed-associated',
    ])
    .nullable(),
  sanctionVerdict: z.enum(['unknown', 'no-match', 'active', 'none']).nullable(),
  decidedAt: z.iso.datetime().nullable(),
  requestedAt: z.iso.datetime().nullable(),
  respondedAt: z.iso.datetime().nullable(),
  wasReused: z.boolean(),
  matchCount: z.int(),
});

export const zPatronDetail = z.object({
  id: z.uuid(),
  firstName: z.string(),
  middleName: z.string().nullable(),
  lastName: z.string().nullable(),
  dateOfBirth: z.string().nullable(),
  phone: z.string().nullable(),
  patronType: z.enum(['patron', 'employee', 'contractor']),
  lastCheckedAt: z.iso.datetime().nullable(),
  pepVerdict: z
    .enum([
      'failed',
      'unknown',
      'no-match',
      'confirmed-pep',
      'confirmed-not-pep',
      'confirmed-associated',
    ])
    .nullable(),
  sanctionVerdict: z.enum(['unknown', 'no-match', 'active', 'none']).nullable(),
  riskRating: z.int(),
  documentType: z.string().nullable(),
  documentNumberMasked: z.string().nullable(),
  lastDvs: z
    .object({
      outcome: zPayoutKycOutcome,
      checkedAt: z.iso.datetime(),
    })
    .nullable(),
  photoUrl: z.string().nullable(),
  checks: z.array(zPatronScreeningCheck),
  identityUpdatedAt: z.iso.datetime().nullable(),
  verdictPredatesIdentityChange: z.boolean(),
  dvsPredatesIdentityChange: z.boolean(),
});

export const zPatronDetailsUpdate = z.object({
  changes: z.object({
    firstName: z.string().min(1).max(200).nullish(),
    middleName: z.string().max(200).nullish(),
    lastName: z.string().min(1).max(200).nullish(),
    dateOfBirth: z.iso.date().nullish(),
    phone: z.string().max(200).nullish(),
  }),
  recorded: z.object({
    firstName: z.string().nullish(),
    middleName: z.string().nullish(),
    lastName: z.string().nullish(),
    dateOfBirth: z.string().nullish(),
    phone: z.string().nullish(),
  }),
});

export const zPatronAuditTrailEntry = z.object({
  createdAt: z.string(),
  message: z.string(),
  fieldsUpdated: z
    .record(
      z.string(),
      z.object({
        before: z.unknown().optional(),
        after: z.unknown().optional(),
      }),
    )
    .optional(),
  nativeAction: z.boolean().optional(),
});

export const zPatronAuditTrailPage = z.object({
  entries: z.array(zPatronAuditTrailEntry),
  nextPageToken: z.string().nullable(),
  earlierActivityMayBeIncomplete: z.boolean(),
});

export const zPatronPepCheckDecision = z.object({
  status: z.enum(['confirmed-pep', 'confirmed-associated', 'confirmed-not-pep']),
  match: zPepMatch.optional(),
});

export const zPatronPepCheckRunResult = z.object({
  checkId: z.uuid(),
  matches: z.array(zPepMatch),
});

export const zPatronDvsCheckResult = z.object({
  outcome: zPayoutKycOutcome,
  checkedAt: z.iso.datetime(),
});

export const zPatronDvsCheckRequest = z.object({
  firstName: z.string().min(1).max(200),
  middleName: z.string().max(200).optional(),
  lastName: z.string().max(200).optional(),
  dateOfBirth: z.iso.date(),
  document: z.union([
    z.object({
      type: z.enum(['physicalDriversLicence']),
      number: z.string().min(1).max(200),
      cardNumber: z.string().min(1).max(200),
      state: z.string().min(1).max(200),
      expiry: z.iso.date().optional(),
    }),
    z.object({
      type: z.enum(['passport']),
      number: z.string().min(1).max(200),
      gender: zGenders.optional(),
      expiry: z.iso.date().optional(),
    }),
  ]),
});

export const zPatronListItem = z.object({
  id: z.uuid(),
  firstName: z.string(),
  lastName: z.string().nullable(),
  dateOfBirth: z.string().nullable(),
  patronType: z.enum(['patron', 'employee', 'contractor']),
  lastCheckedAt: z.iso.datetime().nullable(),
  pepVerdict: z
    .enum([
      'failed',
      'unknown',
      'no-match',
      'confirmed-pep',
      'confirmed-not-pep',
      'confirmed-associated',
    ])
    .nullable(),
  sanctionVerdict: z.enum(['unknown', 'no-match', 'active', 'none']).nullable(),
});

export const zPatronCreate = zPatronIdentityCapture.and(
  z.object({
    patronType: z.enum(['patron', 'employee', 'contractor']).optional(),
  }),
);

export const zRiskRegisterMetrics = z.object({
  newRisks: z.int().gte(0),
  smrsSubmitted: z.int().gte(0),
  valueUnderReviewInCents: z.int().gte(0),
  actionedThisMonth: z.int().gte(0),
  actionedTotal: z.int().gte(0),
  highRiskPatrons: z.int().gte(0),
});

export const zRiskRegisterPatronSearchResult = z.object({
  id: z.uuid(),
  fullname: z.string(),
  dateOfBirth: z.string().nullable(),
});

export const zRiskRegisterPayoutSearchResult = z.object({
  id: z.uuid(),
  externalId: z.string(),
  patronFullname: z.string(),
  amountInCents: z.int(),
});

export const zRiskRegisterFindingReviewInput = z.object({
  id: z.uuid(),
  status: z.enum(['unreviewed', 'confirmed', 'dismissed', 'monitoring']),
  reviewerNotes: z.string().max(2000).optional().default(''),
});

export const zRiskRegisterReviewInput = z.object({
  status: z.enum([
    'closed_no_further_action',
    'closed_monitoring',
    'smr_in_progress',
    'smr_submitted',
  ]),
  decision: z.enum(['risk_identified', 'no_risk_identified']),
  actions: z
    .array(
      z.enum([
        'smr_being_prepared',
        'smr_submitted',
        'enhanced_customer_due_diligence',
        'additional_information_requested_staff',
        'additional_information_requested_patron',
        'source_of_funds_requested',
        'payout_history_reviewed',
        'related_patrons_reviewed',
        'patron_risk_rating_increased',
        'patron_added_to_watchlist',
        'enhanced_monitoring_applied',
        'future_payouts_require_review',
        'internal_investigation_created',
        'external_aml_advice_obtained',
        'payout_paused',
        'payout_restricted_or_declined',
        'customer_relationship_restricted_or_ended',
        'no_further_action_required',
        'other',
      ]),
    )
    .optional()
    .default([]),
  notes: z.string().max(5000).optional().default(''),
  otherActionText: z.string().max(1000).optional().default(''),
  managerRiskLevel: z.enum(['low', 'medium', 'high']).nullish(),
  findingReviews: z.array(zRiskRegisterFindingReviewInput).optional().default([]),
});

export const zRiskRegisterDocument = z.object({
  id: z.uuid(),
  fileId: z.uuid(),
  name: z.string(),
  filename: z.string(),
  contentType: z.string(),
  status: z.enum(['pending', 'confirmed']).nullable(),
  uploadedAt: z.string(),
  uploadedByName: z.string().nullable(),
  viewUrl: z.string().nullable(),
});

export const zRiskRegisterDocumentCreateInput = z.object({
  fileId: z.uuid(),
  name: z.string().max(255).optional(),
});

export const zRiskRegisterFinding = z.object({
  id: z.uuid(),
  ruleId: z.string(),
  label: z.string(),
  description: z.string(),
  score: z.int(),
  status: z.enum(['unreviewed', 'confirmed', 'dismissed', 'monitoring']),
  reviewerNotes: z.string(),
  reviewedAt: z.string().nullable(),
  reviewedByName: z.string().nullable(),
});

export const zRiskRegisterItem = z.object({
  entryId: z.uuid(),
  source: z.enum(['system', 'manual']),
  payoutId: z.uuid().nullable(),
  payoutExternalId: z.string().nullable(),
  patronId: z.uuid().nullable(),
  patronFullname: z.string(),
  patronDateOfBirth: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable(),
  patronPhoneNumber: z.string().nullable(),
  patronEmail: z.string().nullable(),
  patronOccupation: z.string().nullable(),
  patronOccupationNotes: z.string().nullable(),
  patronSourceOfFunds: z.string().nullable(),
  patronSourceOfFundsNotes: z.string().nullable(),
  patronSourceOfWealth: z.string().nullable(),
  patronSourceOfWealthNotes: z.string().nullable(),
  venueId: z.uuid(),
  venueName: z.string().nullable(),
  amountInCents: z.int(),
  payoutCreatedAt: z.string(),
  payoutStatus: z.string(),
  payoutType: z.string().nullable(),
  staffObservations: z.string().nullable(),
  riskLevel: z.enum(['low', 'medium', 'high']).nullable(),
  suggestedRiskLevel: z.enum(['low', 'medium', 'high']).nullable(),
  managerRiskLevel: z.enum(['low', 'medium', 'high']).nullable(),
  registerStatus: z.enum([
    'awaiting_review',
    'closed_no_further_action',
    'closed_monitoring',
    'smr_in_progress',
    'smr_submitted',
  ]),
  reviewDecision: z.enum(['risk_identified', 'no_risk_identified']).nullable(),
  reviewActions: z.array(
    z.enum([
      'smr_being_prepared',
      'smr_submitted',
      'enhanced_customer_due_diligence',
      'additional_information_requested_staff',
      'additional_information_requested_patron',
      'source_of_funds_requested',
      'payout_history_reviewed',
      'related_patrons_reviewed',
      'patron_risk_rating_increased',
      'patron_added_to_watchlist',
      'enhanced_monitoring_applied',
      'future_payouts_require_review',
      'internal_investigation_created',
      'external_aml_advice_obtained',
      'payout_paused',
      'payout_restricted_or_declined',
      'customer_relationship_restricted_or_ended',
      'no_further_action_required',
      'other',
    ]),
  ),
  reviewNotes: z.string(),
  otherActionText: z.string(),
  primaryTrigger: z.string().nullable(),
  primaryTriggerType: z.string().nullable(),
  findingCount: z.int().gte(0),
  findings: z.array(zRiskRegisterFinding),
  reviewedAt: z.string().nullable(),
  reviewedByName: z.string().nullable(),
});

export const zRiskRegisterNewPatron = z
  .object({
    firstName: z.string().min(1).max(255),
    middleName: z.string().max(255).nullish(),
    lastName: z.string().max(255).nullish(),
    dateOfBirth: z
      .string()
      .regex(/^\d{4}-\d{2}-\d{2}$/)
      .nullish(),
    phoneNumber: z.string().max(255).nullish(),
    email: z.string().max(255).nullish(),
  })
  .nullable();

export const zRiskRegisterManualCreateInput = z.object({
  payoutId: z.uuid().nullish(),
  associatedPatronId: z.uuid().nullish(),
  newPatron: zRiskRegisterNewPatron.optional(),
  patronName: z.string().max(255).nullish(),
  patronDateOfBirth: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullish(),
  patronPhoneNumber: z.string().max(255).nullish(),
  patronEmail: z.string().max(255).nullish(),
  patronOccupation: z.string().max(255).nullish(),
  patronSourceOfFunds: z.string().max(255).nullish(),
  patronSourceOfWealth: z.string().max(255).nullish(),
  payoutType: z.string().max(255).nullish(),
  amountInCents: z.int().gte(0).nullish(),
  occurredAt: z.string().nullish(),
  riskLevel: z.enum(['low', 'medium', 'high']),
  primaryTriggerType: z.string().max(255).nullish(),
  primaryTriggerLabel: z.string().max(255).nullish(),
  riskRules: z
    .array(
      z.object({
        type: z.string().max(255),
        label: z.string().max(255),
        description: z.string().max(1000).optional().default(''),
      }),
    )
    .optional(),
  summary: z.string().max(5000).optional().default(''),
  review: zRiskRegisterReviewInput.optional(),
});

export const zPermissionCatalogueEntry = z.object({
  key: z.string(),
  title: z.string(),
  kind: z.enum(['base', 'split', 'new']),
});

export const zPermissionCatalogueResponse = z.object({
  success: z.literal(true),
  data: z.array(zPermissionCatalogueEntry),
});

export const zVenueAssignableRole = z.object({
  id: z.string(),
  name: z.string(),
  helpText: z.string(),
  reservedName: z.boolean(),
  holderCount: z.int().nullable(),
});

export const zVenueAssignableRoleList = z.object({
  roles: z.array(zVenueAssignableRole),
});

export const zVenueRoleSummary = z.object({
  id: z.uuid(),
  name: z.string(),
  helpText: z.string(),
  reservedName: z.boolean(),
  permissions: z.array(z.string()),
  holderCount: z.int().gte(0),
  updatedAt: zDatetimeIsoString,
});

export const zVenueRoleListResponse = z.object({
  success: z.literal(true),
  data: z.array(zVenueRoleSummary),
});

export const zVenueRolePermissionsEditInput = z.object({
  roles: z
    .array(
      z.object({
        roleId: z.uuid(),
        permissions: z.array(z.string()).min(1),
        updatedAt: zDatetimeIsoString,
      }),
    )
    .min(1),
});

export const zVenueRoleHolder = z.object({
  userId: z.uuid(),
  fullname: z.string().nullable(),
  email: z.string(),
  status: z.string(),
});

export const zVenueRoleDetail = z.object({
  id: z.uuid(),
  name: z.string(),
  helpText: z.string(),
  reservedName: z.boolean(),
  permissions: z.array(z.string()),
  holderCount: z.int().gte(0),
  holders: z.array(zVenueRoleHolder),
  updatedAt: zDatetimeIsoString,
});

export const zVenueRoleResponse = z.object({
  success: z.literal(true),
  data: zVenueRoleDetail,
});

export const zVenueRoleCreateInput = z.object({
  name: z.string().min(1).max(100),
  helpText: z.string().min(1),
  permissions: z.array(z.string()).min(1),
});

export const zVenueRoleEditInput = zVenueRoleCreateInput.and(
  z.object({
    updatedAt: zDatetimeIsoString,
  }),
);

export const zAutoEftMetrics = z.object({
  period: z.object({
    from: zDatetimeIsoString,
    to: zDatetimeIsoString,
  }),
  volumes: z.object({
    total: z.int().gte(0),
    paid: z.int().gte(0),
    failed: z.int().gte(0),
    cancelled: z.int().gte(0),
    inFlight: z.int(),
    settled: z.int().gte(0),
    successRate: z.number().nullable(),
    failureRate: z.number().nullable(),
    byStatus: z.array(
      z.object({
        status: z.enum([
          'scheduled',
          'held',
          'locked',
          'submitting',
          'processing',
          'paid',
          'payment_failed',
          'cancelled',
        ]),
        count: z.int().gte(0),
      }),
    ),
  }),
  failureReasons: z.array(
    z.object({
      reason: z.string(),
      count: z.int().gte(0),
      reasonNotReported: z.boolean(),
    }),
  ),
  exceptions: z.object({
    total: z.int().gte(0),
    byCohort: z.array(
      z.object({
        cohort: z.enum([
          'past_due_unsubmitted',
          'stuck',
          'rejected_at_submission',
          'credential_or_funding_failure',
          'returned_funds',
        ]),
        count: z.int().gte(0),
      }),
    ),
    scanned: z.int().gte(0),
    truncated: z.boolean(),
  }),
  sweepHealth: z.object({
    state: z.enum(['nothing_due', 'healthy', 'sweep_not_processing', 'venue_ineligible']),
    dueTotal: z.int().gte(0),
    overdueTotal: z.int().gte(0),
    attributedToScheduler: z.int().gte(0),
    attributedToVenueIneligibility: z.int().gte(0),
    awaitingNextSweep: z.int().gte(0),
    graceMinutes: z.int().gt(0),
    venueIneligibility: z.array(
      z.object({
        venueId: z.uuid(),
        venueName: z.string(),
        cause: z.enum(['entitlement_withdrawn', 'toggle_off', 'credential_not_confirmed']),
        count: z.int().gte(0),
      }),
    ),
  }),
  records: z.object({
    data: z.array(
      z.object({
        id: z.uuid(),
        payoutId: z.uuid(),
        payoutReference: z.string(),
        venueId: z.uuid(),
        venueName: z.string(),
        amountInCents: z.int(),
        status: z.enum([
          'scheduled',
          'held',
          'locked',
          'submitting',
          'processing',
          'paid',
          'payment_failed',
          'cancelled',
        ]),
        cohort: z.enum([
          'past_due_unsubmitted',
          'stuck',
          'rejected_at_submission',
          'credential_or_funding_failure',
          'returned_funds',
        ]),
        reason: z.string().nullable(),
        failureReason: z.string().nullable(),
        mwReportedStatus: z.string().nullable(),
        mwResponseCode: z.number().nullable(),
        mwResponseMessage: z.string().nullable(),
        eligibleAt: zDatetimeIsoString,
        submittedAt: zDatetimeIsoString.nullable(),
        outcomeObservedAt: zDatetimeIsoString.nullable(),
        stuckFlaggedAt: zDatetimeIsoString.nullable(),
        staffResolutionRecordedAt: zDatetimeIsoString.nullable(),
        overdueAttribution: z
          .enum(['sweep_not_processing', 'venue_ineligible', 'awaiting_next_sweep'])
          .nullable(),
      }),
    ),
    pagination: zPaginationMeta,
  }),
});

export const zAutoEftRecords = z.object({
  records: z.object({
    data: z.array(
      z.object({
        id: z.uuid(),
        payoutId: z.uuid(),
        payoutReference: z.string(),
        venueId: z.uuid(),
        venueName: z.string(),
        amountInCents: z.int(),
        status: z.enum([
          'scheduled',
          'held',
          'locked',
          'submitting',
          'processing',
          'paid',
          'payment_failed',
          'cancelled',
        ]),
        cohort: z.enum([
          'past_due_unsubmitted',
          'stuck',
          'rejected_at_submission',
          'credential_or_funding_failure',
          'returned_funds',
          'none',
        ]),
        reason: z.string().nullable(),
        failureReason: z.string().nullable(),
        mwReportedStatus: z.string().nullable(),
        mwResponseCode: z.number().nullable(),
        mwResponseMessage: z.string().nullable(),
        eligibleAt: zDatetimeIsoString,
        submittedAt: zDatetimeIsoString.nullable(),
        outcomeObservedAt: zDatetimeIsoString.nullable(),
        stuckFlaggedAt: zDatetimeIsoString.nullable(),
        cancelledAt: zDatetimeIsoString.nullable(),
        cancellationReason: z.string().nullable(),
        staffResolutionRecordedAt: zDatetimeIsoString.nullable(),
        payoutEftOutstanding: z.boolean(),
        createdAt: zDatetimeIsoString,
      }),
    ),
    pagination: zPaginationMeta,
  }),
  scan: z.object({
    classified: z.boolean(),
    scanned: z.int().gte(0),
    truncated: z.boolean(),
  }),
});

export const zAutoEftMerchantWarriorCheck = z.object({
  recordId: z.uuid(),
  payoutId: z.uuid(),
  venueId: z.uuid(),
  status: z.enum([
    'scheduled',
    'held',
    'locked',
    'submitting',
    'processing',
    'paid',
    'payment_failed',
    'cancelled',
  ]),
  identifier: z.string(),
  identifierSource: z.enum([
    'mw_payout_id',
    'stored_submission_reference',
    'computed_submission_reference',
  ]),
  outcome: z.enum(['batch_found', 'no_batch_found', 'unconfirmed']),
  summary: z.string(),
  provider: z
    .object({
      responseCode: z.number(),
      responseMessage: z.string(),
      mwPayoutId: z.string().nullable(),
      reference: z.string().nullable(),
      reportedStatus: z.string().nullable(),
      total: z.number().nullable(),
      processed: z.number().nullable(),
      fundsSource: z.string().nullable(),
      createdAt: z.string().nullable(),
      lastUpdated: z.string().nullable(),
    })
    .nullable(),
  unconfirmedReason: z.string().nullable(),
  checkedAt: zDatetimeIsoString,
});

export const zAutoEftStaffResolution = z.object({
  recordId: z.uuid(),
  payoutId: z.uuid(),
  status: z.enum([
    'scheduled',
    'held',
    'locked',
    'submitting',
    'processing',
    'paid',
    'payment_failed',
    'cancelled',
  ]),
  staffResolutionRecordedAt: zDatetimeIsoString,
});

export const zAutoEftRetryableResult = z.object({
  recordId: z.uuid(),
  payoutId: z.uuid(),
  venueId: z.uuid(),
  status: z.enum([
    'scheduled',
    'held',
    'locked',
    'submitting',
    'processing',
    'paid',
    'payment_failed',
    'cancelled',
  ]),
});

export const zCheckdManagerDashboardMetric = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  venueCreated: z.iso.datetime(),
  totalPayouts: z.number(),
  lastPayout: z.iso.datetime().nullish(),
  lastLogin: z.iso.datetime().nullish(),
  daysSinceLastPayout: z.number(),
});

export const zCheckdManagerDashboardMetrics = z.array(zCheckdManagerDashboardMetric);

export const zCheckdGrandTotals = z.object({
  venues: z.number(),
  users: z.number(),
  payouts: z.number(),
  winningsInCents: z.number(),
  dvsChecks: z.number(),
  pepChecks: z.number(),
  confirmationOfPayeeChecks: z.number(),
});

export const zCheckdMetricTrend = z.object({
  value: z.number(),
  delta30d: z.number().nullable(),
  delta90d: z.number().nullable(),
  deltaAll: z.number().nullable(),
});

export const zCheckdPaymentType = z.object({
  amountInCents: z.number(),
  count: z.number(),
});

export const zCheckdRiskBucket = z.object({
  level: z.enum(['low', 'medium', 'high', 'unassessed']),
  count: z.number(),
  amountInCents: z.number(),
});

export const zCheckdRiskMatrixCell = z.object({
  suggested: z.enum(['low', 'medium', 'high', 'unassessed']),
  manager: z.enum(['low', 'medium', 'high', 'unassessed']),
  count: z.number(),
});

export const zCheckdStageStat = z.object({
  count: z.number(),
  minSeconds: z.number(),
  maxSeconds: z.number(),
  avgSeconds: z.number(),
});

export const zCheckdMetrics = z.object({
  grandTotals: z.object({
    allTime: zCheckdGrandTotals,
    current: z.object({
      venues: zCheckdMetricTrend,
      users: zCheckdMetricTrend,
      payouts: zCheckdMetricTrend,
      winningsInCents: zCheckdMetricTrend,
      dvsChecks: zCheckdMetricTrend,
      pepChecks: zCheckdMetricTrend,
      confirmationOfPayeeChecks: zCheckdMetricTrend,
    }),
  }),
  aggregate: z.object({
    totalPayouts: z.number(),
    totalPaidInCents: z.number(),
    meanPayoutInCents: z.number(),
    medianPayoutInCents: z.number(),
    meanTimeToPaidSeconds: z.number(),
    medianTimeToPaidSeconds: z.number(),
  }),
  paymentsByType: z.object({
    cash: zCheckdPaymentType,
    eft: zCheckdPaymentType,
    cheque: zCheckdPaymentType,
  }),
  risk: z.object({
    suggested: z.array(zCheckdRiskBucket),
    manager: z.array(zCheckdRiskBucket),
    matrix: z.array(zCheckdRiskMatrixCell),
  }),
  stageTimes: z.object({
    createToSubmit: zCheckdStageStat,
    submitToReview: zCheckdStageStat,
    reviewToFinalise: zCheckdStageStat,
    createToPaid: zCheckdStageStat,
  }),
  confirmationOfPayee: z.object({
    totalChecks: z.number(),
    servedFromCache: z.number(),
    unavailableChecks: z.number(),
    resultBreakdown: z.array(
      z.object({
        resultCode: z.string(),
        count: z.number(),
      }),
    ),
    coverage: z.object({
      eligiblePayouts: z.number(),
      checkedPayouts: z.number(),
      skippedPayouts: z.number(),
    }),
    riskAcceptances: z.number(),
    venueSettings: z.array(
      z.object({
        setting: z.string(),
        venues: z.number(),
      }),
    ),
  }),
});

export const zCheckdDecliningVenue = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  sparkline: z.array(z.number()),
  avgMonth: z.number(),
  prev30d: z.number(),
  last30d: z.number(),
  trendPct: z.number(),
});

export const zCheckdDiscardedRejectedVenue = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  sparkline: z.array(z.number()),
  allTime: z.number(),
  last90d: z.number(),
  last30d: z.number(),
  diffToAvgVenue: z.number(),
});

export const zCheckdSlowestPayoutVenue = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  meanPaidSeconds: z.number(),
  finalisedCount: z.number(),
});

export const zCheckdDvsFailureVenue = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  totalChecks: z.number(),
  fails: z.number(),
  failRatePct: z.number(),
});

export const zCheckdPayoutTimeTrendVenue = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  recentMeanSeconds: z.number(),
  priorMeanSeconds: z.number(),
  deltaPct: z.number(),
});

export const zCheckdVenueTables = z.object({
  declining: z.array(zCheckdDecliningVenue),
  discardedRejected: z.array(zCheckdDiscardedRejectedVenue),
  slowestPayout: z.array(zCheckdSlowestPayoutVenue),
  dvsFailures: z.array(zCheckdDvsFailureVenue),
  payoutTimeTrend: z.array(zCheckdPayoutTimeTrendVenue),
});

export const zCheckdVenueWindowMetrics = z.object({
  payoutsCreated: z.number(),
  payoutsCompleted: z.number(),
  payoutsCompletedPct: z.number(),
  discarded: z.number(),
  rejected: z.number(),
  incomplete: z.number(),
  incompletePct: z.number(),
  additionalIdDocPct: z.number(),
  activeUsers: z.number(),
});

export const zCheckdVenueStageStat = z.object({
  count: z.number(),
  minSeconds: z.number(),
  maxSeconds: z.number(),
  avgSeconds: z.number(),
});

export const zCheckdVenueRiskBucket = z.object({
  level: z.enum(['low', 'medium', 'high', 'unassessed']),
  count: z.number(),
  amountInCents: z.number(),
});

export const zCheckdVenueConfirmationOfPayeeWindow = z.object({
  totalChecks: z.number(),
  coverage: z.object({
    eligiblePayouts: z.number(),
    checkedPayouts: z.number(),
    skippedPayouts: z.number(),
  }),
  riskAcceptances: z.number(),
});

export const zCheckdVenueMetrics = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  lastLoginAt: z.string().nullable(),
  windows: z.object({
    last30d: zCheckdVenueWindowMetrics,
    last90d: zCheckdVenueWindowMetrics,
    allTime: zCheckdVenueWindowMetrics,
  }),
  allVenueAvgLast30d: zCheckdVenueWindowMetrics,
  stageTimes: z.object({
    createToSubmit: zCheckdVenueStageStat,
    submitToReview: zCheckdVenueStageStat,
    reviewToFinalise: zCheckdVenueStageStat,
    createToPaid: zCheckdVenueStageStat,
  }),
  risk: z.object({
    suggested: z.array(zCheckdVenueRiskBucket),
    manager: z.array(zCheckdVenueRiskBucket),
  }),
  bndryConfirmed: z.object({
    pep: z.number(),
    sanction: z.number(),
    adverseMedia: z.number(),
  }),
  hourOfDay: z.array(
    z.object({
      hour: z.number(),
      count: z.number(),
    }),
  ),
  dvs: z.object({
    totalChecks: z.number(),
    fails: z.number(),
    failRatePct: z.number(),
  }),
  payoutTimeTrend: z.object({
    recentMeanSeconds: z.number().nullable(),
    priorMeanSeconds: z.number().nullable(),
    deltaPct: z.number().nullable(),
  }),
  confirmationOfPayee: z.object({
    windows: z.object({
      last30d: zCheckdVenueConfirmationOfPayeeWindow,
      last90d: zCheckdVenueConfirmationOfPayeeWindow,
      allTime: zCheckdVenueConfirmationOfPayeeWindow,
    }),
    allVenueAvgLast30d: zCheckdVenueConfirmationOfPayeeWindow,
    servedFromCache: z.number(),
    unavailableChecks: z.number(),
    resultBreakdown: z.array(
      z.object({
        resultCode: z.string(),
        count: z.number(),
      }),
    ),
    setting: z.string(),
  }),
});

export const zCheckdPayoutListRow = z.object({
  id: z.uuid(),
  payoutNumber: z.number(),
  externalId: z.string(),
  venueId: z.uuid(),
  venueName: z.string(),
  amountInCents: z.number(),
  status: z.string(),
  suggestedRiskLevel: z.string().nullable(),
  managerRiskLevel: z.string().nullable(),
  confirmationOfPayeeResult: z.string().nullable(),
  createdAt: z.iso.datetime(),
  paidFullyAt: z.iso.datetime().nullable(),
});

export const zCheckdPayoutListResponse = z.object({
  data: z.array(zCheckdPayoutListRow),
  pagination: zPaginationMeta,
});

export const zPayoutVenueMovePreview = z.object({
  payoutId: z.uuid(),
  currentExternalId: z.string(),
  currentVenue: z.object({
    id: z.uuid(),
    name: z.string(),
  }),
  destinationVenue: z.object({
    id: z.uuid(),
    name: z.string(),
  }),
  projectedExternalId: z.string(),
  status: z.string(),
  riskRegisterEntryCount: z.number(),
  patronAction: z.enum(['none', 'move', 'clone']),
  requiresFinalisedAcknowledgement: z.boolean(),
  blockers: z.array(
    z.object({
      code: z.string(),
      message: z.string(),
    }),
  ),
  warnings: z.array(
    z.object({
      code: z.string(),
      message: z.string(),
    }),
  ),
  canMove: z.boolean(),
});

export const zPayoutVenueMoveResult = z.object({
  payoutId: z.uuid(),
  previousExternalId: z.string(),
  newExternalId: z.string(),
  destinationVenue: z.object({
    id: z.uuid(),
    name: z.string(),
  }),
  patronAction: z.enum(['none', 'move', 'clone']),
  riskRegisterEntriesMoved: z.number(),
  payeeChecksMoved: z.number(),
});

export const zPayoutVenueMoveInput = z.object({
  destinationVenueId: z.uuid(),
  reason: z.string().min(3).max(500),
  acknowledgeFinalised: z.boolean().optional().default(false),
});

export const zPayoutCorrectionEffects = z.object({
  patronUnlinked: z.boolean(),
  kycReset: z.boolean(),
  reviewReset: z.boolean(),
});

export const zPayoutCorrectionPreview = z.object({
  canApply: z.boolean(),
  blockers: z.array(z.string()),
  warnings: z.array(z.string()),
  requiresFinalisedAcknowledgement: z.boolean(),
  effects: zPayoutCorrectionEffects,
  diff: z.array(
    z.object({
      field: z.string(),
      label: z.string(),
      before: z.string(),
      after: z.string(),
    }),
  ),
});

export const zPayoutCorrectionChanges = z.object({
  paymentCashInCents: z.int().gte(0).optional(),
  paymentChequeInCents: z.int().gte(0).optional(),
  paymentEftInCents: z.int().gte(0).optional(),
  patronFirstName: z.string().min(1).optional(),
  patronMiddleName: z.string().nullish(),
  patronLastName: z.string().nullish(),
  paymentEftBsb: z.string().min(1).optional(),
  paymentEftAccountNumber: z.string().min(1).optional(),
  paymentEftAccountName: z.string().min(1).max(50).optional(),
});

export const zIduCorrectablePayout = z.object({
  id: z.uuid(),
  externalId: z.string(),
  payoutNumber: z.number(),
  venueId: z.uuid(),
  venueName: z.string(),
  status: z.string(),
  amountInCents: z.number(),
  paymentCashInCents: z.number(),
  paymentChequeInCents: z.number(),
  paymentEftInCents: z.number(),
  patronFirstName: z.string(),
  patronMiddleName: z.string().nullable(),
  patronLastName: z.string().nullable(),
  patronIdType: z.string().nullable(),
  paymentEftBsbMasked: z.string(),
  paymentEftAccountNumberMasked: z.string(),
  paymentEftAccountName: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const zPayoutCorrectionResult = z.object({
  payout: zIduCorrectablePayout,
  effects: zPayoutCorrectionEffects,
});

export const zPayoutCorrectionInput = z.object({
  paymentCashInCents: z.int().gte(0).optional(),
  paymentChequeInCents: z.int().gte(0).optional(),
  paymentEftInCents: z.int().gte(0).optional(),
  patronFirstName: z.string().min(1).optional(),
  patronMiddleName: z.string().nullish(),
  patronLastName: z.string().nullish(),
  paymentEftBsb: z.string().min(1).optional(),
  paymentEftAccountNumber: z.string().min(1).optional(),
  paymentEftAccountName: z.string().min(1).max(50).optional(),
  reason: z.string().min(3).max(500),
  acknowledgeFinalised: z.boolean().optional(),
  expectedUpdatedAt: z.iso.datetime(),
});

export const zIduPayoutCorrectability = z.object({
  canCorrect: z.boolean(),
  blockers: z.array(z.string()),
  requiresFinalisedAcknowledgement: z.boolean(),
  identityEditable: z.boolean(),
  bankingEditable: z.boolean(),
  editableFields: z.array(z.string()),
});

export const zIduPayoutDetail = z.object({
  payout: zIduCorrectablePayout,
  correctability: zIduPayoutCorrectability,
});

export const zLogsPaginationMeta = zPaginationMeta.and(
  z.object({
    nextPageToken: z.string().optional(),
  }),
);

export const zIduLogsListResponse = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      timestamp: z.iso.datetime(),
      source: z.string(),
      severity: z.string(),
      message: z.string(),
      eventName: z.string().optional(),
      type: z.string().optional(),
      level: z.string().optional(),
      frontendLogType: z.string().optional(),
      logType: z.string().optional(),
      actionKey: z.string().optional(),
      component: z.string().optional(),
      origin: z.string().optional(),
      requestId: z.string().optional(),
      userId: z.string().optional(),
      userEmail: z.string().optional(),
      venueId: z.string().optional(),
      venueName: z.string().optional(),
      userAgent: z.string().optional(),
      rawPayload: z.record(z.string(), z.unknown()),
    }),
  ),
  pagination: zLogsPaginationMeta,
});

export const zVenueCountry = z.enum(['AU', 'NZ', 'US']);

export const zSupportedStates = z.enum(['ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA']);

export const zUserVenueInviteStatus = z.enum([
  'invited',
  'requested',
  'active',
  'inactive',
  'suspended',
]);

export const zPokieVenueSettingAdminUpdateInput = z.object({
  requirePatronResidentialAddress: zRequire,
  collectionPointPatronResidentialAddress: zCollectionPoint.optional(),
  requirePatronPhoneNumber: zRequire,
  collectionPointPatronPhoneNumber: zCollectionPoint.optional(),
  requirePatronEmail: zRequire,
  collectionPointPatronEmail: zCollectionPoint.optional(),
  requirePatronOccupation: zRequire,
  collectionPointPatronOccupation: zCollectionPoint.optional(),
  requirePatronSourceOfFunds: zRequire,
  collectionPointPatronSourceOfFunds: zCollectionPoint.optional(),
  requirePatronSourceOfWealth: zRequire,
  collectionPointPatronSourceOfWealth: zCollectionPoint.optional(),
  proofOfPayout: zProofOfPayoutOptions.optional(),
  confirmationOfPayeeSetting: zConfirmationOfPayeeSettingOptions.optional(),
  requirePatronBehaviourObservations: zRequire,
  collectionPointPatronBehaviourObservations: zCollectionPoint.optional(),
  requireGamingBehaviourObservations: zRequire,
  collectionPointGamingBehaviourObservations: zCollectionPoint.optional(),
  allowCheque: z.boolean(),
  allowCash: z.boolean(),
  allowEft: z.boolean(),
  cashFloorLimitInCents: z.int().gte(0),
  requiredPointsOfId: z.int().gte(0),
  mandatoryKycThresholdInCents: z.int().gte(0).lte(500000),
  notificationRecipients: z.array(zNotificationRecipient).optional(),
  patronReceiptMode: zPatronReceiptMode.optional(),
  primaryIdDocumentStorage: zPatronIdStorageOptions.optional(),
  primaryIdDocumentRetentionDays: z.int().gte(0).lte(180).optional().default(30),
  secondaryIdDocumentStorage: zPatronIdStorageOptions.optional(),
  secondaryIdDocumentRetentionDays: z.int().gte(0).lte(180).optional().default(30),
  connectIdSecondDocumentRequired: z.boolean().optional(),
  autoEftEnabled: z.boolean().optional(),
  autoEftHoldHours: z.int().gte(1).lte(72).optional(),
  venueLat: z.number().nullish(),
  venueLong: z.number().nullish(),
  autoEftPlatformEntitled: z.boolean().optional(),
  autoEftMwEnabledConfirmed: z.boolean().optional(),
  patronPhotoRetention: z.enum(['as_needed', 'after_last_visit']).optional(),
  patronPhotoRetentionDays: z.int().gte(15).lte(180).optional(),
  connectIdEnabled: z.boolean().optional(),
  patronMediumRiskScoreThreshold: z.int().gte(0).optional(),
  patronHighRiskScoreThreshold: z.int().gte(0).optional(),
  shortTermPayoutLimitRuleScore: z.int().gte(0).optional(),
  shortTermPayoutLimitRuleEnabled: z.boolean().optional(),
  shortTermPayoutLimitRuleIncludeInRiskRegister: z.boolean().optional(),
  identityVerificationFailedRuleScore: z.int().gte(0).optional(),
  identityVerificationFailedRuleEnabled: z.boolean().optional(),
  identityVerificationFailedRuleIncludeInRiskRegister: z.boolean().optional(),
  identityVerificationNotRanRuleScore: z.int().gte(0).optional(),
  identityVerificationNotRanRuleEnabled: z.boolean().optional(),
  identityVerificationNotRanRuleIncludeInRiskRegister: z.boolean().optional(),
  patronPepAssociatedRuleScore: z.int().gte(0).optional(),
  patronPepAssociatedRuleEnabled: z.boolean().optional(),
  patronPepAssociatedRuleIncludeInRiskRegister: z.boolean().optional(),
  patronPepRuleScore: z.int().gte(0).optional(),
  patronPepRuleEnabled: z.boolean().optional(),
  patronPepRuleIncludeInRiskRegister: z.boolean().optional(),
  pepCheckFailRuleScore: z.int().gte(0).optional(),
  pepCheckFailRuleEnabled: z.boolean().optional(),
  pepCheckFailRuleIncludeInRiskRegister: z.boolean().optional(),
  patronSanctionedRuleScore: z.int().gte(0).optional(),
  patronSanctionedRuleEnabled: z.boolean().optional(),
  patronSanctionedRuleIncludeInRiskRegister: z.boolean().optional(),
  nonCashPaymentOnlyRuleScore: z.int().gte(0).optional(),
  nonCashPaymentOnlyRuleEnabled: z.boolean().optional(),
  nonCashPaymentOnlyRuleIncludeInRiskRegister: z.boolean().optional(),
  newEftAccountRuleScore: z.int().gte(0).optional(),
  newEftAccountRuleEnabled: z.boolean().optional(),
  newEftAccountRuleIncludeInRiskRegister: z.boolean().optional(),
  differentIdToLastPayoutRuleScore: z.int().gte(0).optional(),
  differentIdToLastPayoutRuleEnabled: z.boolean().optional(),
  differentIdToLastPayoutRuleIncludeInRiskRegister: z.boolean().optional(),
  multipleLargePayoutsSameDayRuleScore: z.int().gte(0).optional(),
  multipleLargePayoutsSameDayRuleEnabled: z.boolean().optional(),
  multipleLargePayoutsSameDayRuleIncludeInRiskRegister: z.boolean().optional(),
  mediumTermPayoutLimitRuleScore: z.int().gte(0).optional(),
  mediumTermPayoutLimitRuleEnabled: z.boolean().optional(),
  mediumTermPayoutLimitRuleIncludeInRiskRegister: z.boolean().optional(),
  rejectedPayoutsInLookbackRuleScore: z.int().gte(0).optional(),
  rejectedPayoutsInLookbackRuleEnabled: z.boolean().optional(),
  rejectedPayoutsInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  addressDiffersFromPreviousPayoutRuleScore: z.int().gte(0).optional(),
  addressDiffersFromPreviousPayoutRuleEnabled: z.boolean().optional(),
  addressDiffersFromPreviousPayoutRuleIncludeInRiskRegister: z.boolean().optional(),
  frequentPayoutsInLookbackRuleScore: z.int().gte(0).optional(),
  frequentPayoutsInLookbackRuleEnabled: z.boolean().optional(),
  frequentPayoutsInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  highRiskPayoutInLookbackRuleScore: z.int().gte(0).optional(),
  highRiskPayoutInLookbackRuleEnabled: z.boolean().optional(),
  highRiskPayoutInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  mediumRiskPayoutInLookbackRuleScore: z.int().gte(0).optional(),
  mediumRiskPayoutInLookbackRuleEnabled: z.boolean().optional(),
  mediumRiskPayoutInLookbackRuleIncludeInRiskRegister: z.boolean().optional(),
  averageMonthlyPayoutChangeRuleScore: z.int().gte(0).optional(),
  averageMonthlyPayoutChangeRuleEnabled: z.boolean().optional(),
  averageMonthlyPayoutChangeRuleIncludeInRiskRegister: z.boolean().optional(),
  cashPayoutBehaviourChangeRuleScore: z.int().gte(0).optional(),
  cashPayoutBehaviourChangeRuleEnabled: z.boolean().optional(),
  cashPayoutBehaviourChangeRuleIncludeInRiskRegister: z.boolean().optional(),
  adverseMediaRuleScore: z.int().gte(0).optional(),
  adverseMediaRuleEnabled: z.boolean().optional(),
  adverseMediaRuleIncludeInRiskRegister: z.boolean().optional(),
  suspiciousPatronBehavioursObservedRuleScore: z.int().gte(0).optional(),
  suspiciousPatronBehavioursObservedRuleEnabled: z.boolean().optional(),
  suspiciousPatronBehavioursObservedRuleIncludeInRiskRegister: z.boolean().optional(),
  unusualSourceOfFundsRuleScore: z.int().gte(0).optional(),
  unusualSourceOfFundsRuleEnabled: z.boolean().optional(),
  unusualSourceOfFundsRuleIncludeInRiskRegister: z.boolean().optional(),
  unusualSourceOfWealthRuleScore: z.int().gte(0).optional(),
  unusualSourceOfWealthRuleEnabled: z.boolean().optional(),
  unusualSourceOfWealthRuleIncludeInRiskRegister: z.boolean().optional(),
  venueDistanceRuleScore: z.int().gte(0).optional(),
  venueDistanceRuleEnabled: z.boolean().optional(),
  venueDistanceRuleIncludeInRiskRegister: z.boolean().optional(),
  venueDistanceRuleThresholdKm: z.int().gte(1).optional(),
  nonAustralianIdRuleScore: z.int().gte(0).optional(),
  nonAustralianIdRuleEnabled: z.boolean().optional(),
  nonAustralianIdRuleIncludeInRiskRegister: z.boolean().optional(),
  confirmationOfPayeeRuleScore: z.int().gte(0).optional(),
  confirmationOfPayeeRuleEnabled: z.boolean().optional(),
  confirmationOfPayeeRuleIncludeInRiskRegister: z.boolean().optional(),
  confirmationOfPayeeNotRunRuleScore: z.int().gte(0).optional(),
  confirmationOfPayeeNotRunRuleEnabled: z.boolean().optional(),
  confirmationOfPayeeNotRunRuleIncludeInRiskRegister: z.boolean().optional(),
  accountNameMismatchRuleScore: z.int().gte(0).optional(),
  accountNameMismatchRuleEnabled: z.boolean().optional(),
  accountNameMismatchRuleIncludeInRiskRegister: z.boolean().optional(),
  connectIdDocumentNamePartialMatchRuleScore: z.int().gte(0).optional(),
  connectIdDocumentNamePartialMatchRuleEnabled: z.boolean().optional(),
  connectIdDocumentNamePartialMatchRuleIncludeInRiskRegister: z.boolean().optional(),
  connectIdDocumentNameNotCheckedRuleScore: z.int().gte(0).optional(),
  connectIdDocumentNameNotCheckedRuleEnabled: z.boolean().optional(),
  connectIdDocumentNameNotCheckedRuleIncludeInRiskRegister: z.boolean().optional(),
  shortTermPayoutLimitLookbackDays: z.int().gte(1).optional(),
  shortTermPayoutLimitThresholdInCents: z.int().gte(0).optional(),
  mediumTermPayoutLimitLookbackDays: z.int().gte(1).optional(),
  mediumTermPayoutLimitThresholdInCents: z.int().gte(0).optional(),
  rejectedPayoutsLookbackDays: z.int().gte(1).optional(),
  averageMonthlyPayoutChangeThresholdPercentage: z.int().gte(0).optional(),
  nonCashPaymentCashThresholdInCents: z.int().gte(0).optional(),
  nonCashPaymentMinimumNonCashInCents: z.int().gte(0).optional(),
  newEftAccountPayoutHistoryLimit: z.int().gte(1).optional(),
  cashPayoutBehaviourPayoutHistoryLimit: z.int().gte(1).optional(),
  differentIdPayoutHistoryLimit: z.int().gte(1).optional(),
  addressDiffersPayoutHistoryLimit: z.int().gte(1).optional(),
  frequentPayoutsCountThreshold: z.int().gte(1).optional(),
  frequentPayoutsLookbackDays: z.int().gte(1).optional(),
  highRiskPayoutLookbackDays: z.int().gte(1).optional(),
  mediumRiskPayoutLookbackDays: z.int().gte(1).optional(),
  multipleLargePayoutsSameDayThresholdInCents: z.int().gte(0).optional(),
  multipleLargePayoutsSameDayCountThreshold: z.int().gte(1).optional(),
  unusualSourceOfFundsValues: z.array(z.string()).optional(),
  unusualSourceOfWealthValues: z.array(z.string()).optional(),
});

export const zVenueMwCredentialStatus = z.object({
  exists: z.boolean(),
  lastWrittenAt: z.iso.datetime().nullable(),
});

export const zIduVenueApplicationAssignResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduVenueApplicationAssignRequest = z.object({
  application: z.enum(['trackd', 'checkd', 'nightlife_snp', 'nightlife_osnp']),
});

export const zIduVenueApplicationRemoveResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zNightlifeCustomerStatus = z.enum(['active', 'suspended', 'inactive']).nullable();

export const zIduNightlifeVenueListing = z.object({
  firestoreVenueId: z.string(),
  name: z.string().nullable(),
  customerStatus: zNightlifeCustomerStatus,
  siteNumber: z.number().nullable(),
  hubspotCompanyId: z.string().nullable(),
  webappsVenueId: z.string().nullable(),
  state: z.enum(['linked', 'unlinked', 'needs_hubspot_id']),
  link: z
    .object({
      venueId: z.uuid(),
      venueName: z.string(),
      venueSlug: z.string(),
      venueStatus: zVenueStatus,
      linkedAt: z.iso.datetime(),
      linkedBy: z.uuid().nullable(),
      needsHubspotId: z.boolean(),
    })
    .nullable(),
});

export const zIduNightlifeVenuePage = z.object({
  items: z.array(zIduNightlifeVenueListing),
  nextCursor: z.string().nullable(),
});

export const zNightlifeApplication = z.enum(['nightlife_snp', 'nightlife_osnp']);

export const zIduNightlifeVenueLink = z.object({
  venueId: z.uuid(),
  application: zNightlifeApplication,
  firestoreVenueId: z.string(),
  hubspotCompanyId: z.string().nullable(),
  needsHubspotId: z.boolean(),
  linkedAt: z.iso.datetime(),
  linkedBy: z.uuid().nullable(),
});

export const zIduNightlifeVenueLinkResult = z.object({
  link: zIduNightlifeVenueLink,
  outcome: z.enum(['existing', 'unchanged', 'linked', 'created', 'relinked']),
  documentSynced: z.boolean(),
});

export const zIduNightlifeTargetVenueRequest = z.object({
  venueId: z.uuid(),
});

export const zIduNightlifeVenueRelinkResult = z.object({
  link: zIduNightlifeVenueLink,
  outcome: z.enum(['existing', 'unchanged', 'linked', 'created', 'relinked']),
  documentSynced: z.boolean(),
  previousVenueId: z.uuid().nullable(),
  grantsMoved: z.int(),
  grantsMerged: z.int(),
});

export const zIduVenueNightlifeLinks = z.array(
  z.object({
    application: zNightlifeApplication,
    configured: z.boolean(),
    link: z
      .object({
        firestoreVenueId: z.string(),
        hubspotCompanyId: z.string().nullable(),
        needsHubspotId: z.boolean(),
        linkedAt: z.iso.datetime(),
        linkedBy: z.uuid().nullable(),
      })
      .nullable(),
  }),
);

export const zIduVenueNightlifeSettings = z.object({
  application: zNightlifeApplication,
  venueId: z.uuid(),
  firestoreVenueId: z.string(),
  webappsVenueId: z.string().nullable(),
  name: z.string().nullable(),
  customerStatus: zNightlifeCustomerStatus,
  hubspotCompanyId: z.string().nullable(),
  idScannerStatus: z.enum(['Regulated', 'Exempt']).nullable(),
  licenseNumber: z.string().nullable(),
  licenseType: z.string().nullable(),
  siteNumber: z.number().nullable(),
  siteType: z.string().nullable(),
  snopId: z.number().nullable(),
  safeNightPrecinct: z.string().nullable(),
  address: z.string().nullable(),
  buildingName: z.string().nullable(),
  streetNumber: z.string().nullable(),
  streetType: z.string().nullable(),
  suburb: z.string().nullable(),
  postcode: z.string().nullable(),
  city: z.string().nullable(),
  state: z.string().nullable(),
  country: z.string().nullable(),
  xcoord: z.string().nullable(),
  ycoord: z.string().nullable(),
  crossStreetName: z.string().nullable(),
  crossStreetType: z.string().nullable(),
  floorNumber: z.string().nullable(),
  floorType: z.string().nullable(),
  unitNumber: z.string().nullable(),
  unitType: z.string().nullable(),
  patronCount: z
    .object({
      capacity: z.number().nullable(),
      count: z.number().nullable(),
      date: z.string().nullable(),
    })
    .nullable(),
  settings: z.record(z.string(), z.unknown()),
  createdAt: z.string().nullable(),
  lastModifiedDate: z.string().nullable(),
});

export const zIduVenueNightlifeCreateConflict = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['NIGHTLIFE_VENUE_ALREADY_LINKED', 'SITE_NUMBER_TAKEN', 'SITE_NUMBER_SHARED']),
    }),
  }),
});

export const zNightlifeVenueSettingsFields = z.object({
  idScannerStatus: z.enum(['Regulated', 'Exempt']).nullable(),
  licenseNumber: z.string().max(512),
  licenseType: z.string().max(512),
  siteNumber: z.int().gte(0).nullable(),
  siteType: z.string().max(512),
  snopId: z.int().gte(0).nullable(),
  safeNightPrecinct: z.string().max(512),
  address: z.string().max(512),
  buildingName: z.string().max(512).nullable(),
  streetNumber: z.string().max(512).nullable(),
  streetType: z.string().max(512).nullable(),
  suburb: z.string().max(512),
  postcode: z.string().max(512),
  city: z.string().max(512),
  state: z.string().max(512),
  country: z.string().max(512),
  xcoord: z.string().max(512),
  ycoord: z.string().max(512),
  crossStreetName: z.string().max(512).nullable(),
  crossStreetType: z.string().max(512).nullable(),
  floorNumber: z.string().max(512).nullable(),
  floorType: z.string().max(512).nullable(),
  unitNumber: z.string().max(512).nullable(),
  unitType: z.string().max(512).nullable(),
  patronCount: z.object({
    capacity: z.int().gte(0),
    count: z.int().gte(0),
  }),
  settings: z.record(z.string(), z.unknown()),
});

export const zIduVenueNightlifeCreateRequest = zNightlifeVenueSettingsFields.and(
  z.object({
    confirmSharedSite: z.boolean().optional(),
  }),
);

export const zIduVenueNightlifeSettingsUpdateConflict = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['SITE_NUMBER_TAKEN', 'SITE_NUMBER_SHARED']),
    }),
  }),
});

export const zIduVenueNightlifeSettingsUpdateRequest = z.object({
  idScannerStatus: z.enum(['Regulated', 'Exempt']).nullish(),
  licenseNumber: z.string().max(512).optional(),
  licenseType: z.string().max(512).optional(),
  siteNumber: z.int().gte(0).nullish(),
  siteType: z.string().max(512).optional(),
  snopId: z.int().gte(0).nullish(),
  safeNightPrecinct: z.string().max(512).optional(),
  address: z.string().max(512).optional(),
  buildingName: z.string().max(512).nullish(),
  streetNumber: z.string().max(512).nullish(),
  streetType: z.string().max(512).nullish(),
  suburb: z.string().max(512).optional(),
  postcode: z.string().max(512).optional(),
  city: z.string().max(512).optional(),
  state: z.string().max(512).optional(),
  country: z.string().max(512).optional(),
  xcoord: z.string().max(512).optional(),
  ycoord: z.string().max(512).optional(),
  crossStreetName: z.string().max(512).nullish(),
  crossStreetType: z.string().max(512).nullish(),
  floorNumber: z.string().max(512).nullish(),
  floorType: z.string().max(512).nullish(),
  unitNumber: z.string().max(512).nullish(),
  unitType: z.string().max(512).nullish(),
  patronCount: z
    .object({
      capacity: z.int().gte(0),
      count: z.int().gte(0),
    })
    .optional(),
  settings: z.record(z.string(), z.unknown()).optional(),
  confirmSharedSite: z.boolean().optional(),
});

export const zIduVenueNightlifeLegacyManagers = z.array(
  z.object({
    id: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
  }),
);

export const zKycDvsMetricsTotals = z.object({
  backToOrigin: z.number(),
  servedFromCache: z.number(),
  venues: z.number(),
});

export const zKycMetricsTotals = z.object({
  checks: z.number(),
  venues: z.number(),
});

export const zKycConnectIdMetricsTotals = z.object({
  verifications: z.number(),
  venues: z.number(),
});

export const zKycMetricsSummary = z.object({
  totals: z.object({
    dvs: zKycDvsMetricsTotals,
    pep: zKycMetricsTotals,
    connectId: zKycConnectIdMetricsTotals,
  }),
});

export const zKycDvsMetricsVenueTotals = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  payoutsCreated: z.number(),
  backToOrigin: z.number(),
  servedFromCache: z.number(),
});

export const zKycMetricsVenueTotals = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  payoutsCreated: z.number(),
  checks: z.number(),
});

export const zKycConnectIdMetricsVenueTotals = z.object({
  venueId: z.uuid(),
  venueName: z.string(),
  payoutsCreated: z.number(),
  verifications: z.number(),
});

export const zKycMetricsVenueTotalsList = z.object({
  dvs: z.array(zKycDvsMetricsVenueTotals),
  pep: z.array(zKycMetricsVenueTotals),
  connectId: z.array(zKycConnectIdMetricsVenueTotals),
});

export const zKycDashboardQueryPeriod = z.enum(['1d', '7d', '30d', '365d']).default('7d');

export const zPepCheckActivityItem = z.object({
  id: z.uuid(),
  patronId: z.uuid(),
  venueId: z.uuid().nullable(),
  venueName: z.string().nullable(),
  payoutId: z.uuid().nullable(),
  payoutExternalId: z.string().nullable(),
  triggerReason: z.string(),
  wasReused: z.boolean(),
  reusedFromCheckId: z.uuid().nullable(),
  matchCount: z.number(),
  outcome: z.enum(['match', 'no_match', 'failed', 'pending']),
  pepStatus: z.enum([
    'failed',
    'unknown',
    'no-match',
    'confirmed-pep',
    'confirmed-not-pep',
    'confirmed-associated',
  ]),
  associatedPepMatch: zPepMatch.nullable(),
  createdAt: z.iso.datetime(),
  requestedAt: z.iso.datetime().nullable(),
  respondedAt: z.iso.datetime().nullable(),
});

export const zPepCheckRunStatsResponse = z.object({
  total: z.number(),
  fresh: z.number(),
  reused: z.number(),
});

export const zBndryAlertHistoryItem = z.object({
  id: z.uuid(),
  windowStart: z.iso.datetime(),
  windowEnd: z.iso.datetime(),
  checkCount: z.number(),
  thresholdNumber: z.number(),
  environment: z.string(),
  recipientEmails: z.array(z.string()),
  createdAt: z.iso.datetime(),
});

export const zConfirmationOfPayeeRollout = z.enum(['disabled', 'selected_venues', 'all_venues']);

export const zIduUserCreateResponse = z.object({
  id: z.uuid(),
  fullname: z.string(),
  email: z.string(),
  phoneNumber: z.string().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export const zIduUserCreateRequest = z.object({
  fullname: z.string().min(1).max(255),
  email: z.email(),
  phoneNumber: z.string().max(255).nullish(),
  password: z.string().min(6).nullish(),
  assignments: z
    .array(
      z.object({
        venueId: z.uuid(),
        application: zApplications,
        role: zRoles.optional(),
        roleId: z.uuid().optional(),
        jobTitle: zJobTitles,
        securityFirm: z.string().max(255).nullish(),
      }),
    )
    .optional(),
  sendResetEmail: z.boolean().optional(),
  continueUrl: z.url().optional(),
});

export const zIduUserSearchResponse = z.object({
  data: z.array(
    z.object({
      id: z.uuid(),
      fullname: z.string(),
      email: z.email(),
      photoFileId: z.string().nullable(),
      createdAt: zDatetimeIsoString,
      createdBy: z.uuid().nullable(),
      updatedAt: zDatetimeIsoString,
      updatedBy: z.uuid().nullable(),
      discardedAt: zDatetimeIsoString.nullable(),
      discardedBy: z.uuid().nullable(),
      phoneNumber: z.string().nullable(),
      status: z.enum(['active', 'inactive', 'suspended']),
    }),
  ),
  pagination: zPaginationMeta,
});

export const zAssignmentSchema = z.object({
  id: z.uuid(),
  slug: z.string(),
  name: z.string(),
  application: zApplications,
  role: zRoles.nullable(),
  roleId: z.uuid().nullish(),
  roleName: z.string().nullish(),
  jobTitle: zJobTitles,
  securityFirm: z.string().nullable(),
});

export const zInviteStatus = z.enum(['pending', 'accepted', 'revoked', 'expired']);

export const zInAppMessageCreateOrUpdateRequestBody = z.object({
  title: z.string().min(1).max(255),
  type: zInAppMessageTypeEnum,
  application: zInAppMessageApplicationEnum,
  startAt: z.iso.datetime(),
  endAt: z.iso.datetime(),
  message: z.string().min(1),
});

export const zNightlifeVenueManager = z.object({
  id: z.uuid(),
  fullname: z.string(),
  email: z.email(),
  phoneNumber: z.string().nullable(),
  status: z.enum(['active', 'invited']),
  invitedByName: z.string().nullable(),
  invitedAt: z.iso.datetime().nullable(),
  inviteExpiresAt: z.iso.datetime().nullable(),
  lastLoginAt: z.iso.datetime().nullable(),
});

export const zNightlifeVenueManagers = z.object({
  managers: z.array(zNightlifeVenueManager),
  invites: z.array(zNightlifeVenueManager),
});

export const zNightlifeManagerInviteRefusal = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['ALREADY_INVITED', 'ALREADY_HAS_ACCESS']),
    }),
  }),
});

export const zNightlifeManagerInviteRequest = z.object({
  email: z.email(),
  firstName: z.string().max(255).optional(),
  lastName: z.string().max(255).optional(),
  phone: z.string().max(32).optional(),
});

export const zNightlifeManagerInviteResendRefusal = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['NO_PENDING_INVITE']),
    }),
  }),
});

export const zNightlifeManagerInviteResendRefusalNotFound = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['INVITE_NOT_FOUND']),
    }),
  }),
});

export const zNightlifeManagerInviteRevokeRefusal = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['NO_PENDING_INVITE']),
    }),
  }),
});

export const zNightlifeManagerInviteRevokeRefusalNotFound = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['INVITE_NOT_FOUND']),
    }),
  }),
});

export const zNightlifeManagerRemoveNotFound = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['MANAGER_NOT_FOUND']),
    }),
  }),
});

export const zNightlifeManagerRemoveRefusal = z.object({
  success: z.literal(false).optional(),
  error: z.object({
    message: z.string(),
    cause: z.object({
      code: z.enum(['INVITE_PENDING', 'CANNOT_REMOVE_SELF']),
    }),
  }),
});

export const zInternalNightlifeGrantCreateResponse = z.object({
  userId: z.uuid(),
  venueId: z.uuid(),
});

export const zInternalNightlifeGrantCreateRequest = z.object({
  application: zNightlifeApplication,
  firestoreVenueId: z.string().min(1).max(128),
  firebaseUid: z.string().min(1).max(128),
  email: z.email(),
  firstName: z.string().max(255).optional(),
  lastName: z.string().max(255).optional(),
});

/**
 * Success
 */
export const zGetHealthResponse = zHealthResponse;

/**
 * Success
 */
export const zGetFeatureFlagsResponse = z.object({
  success: z.literal(true),
  data: zFeatureFlags,
});

/**
 * Log request payload
 */
export const zLogCreateBody = z.array(zLogRequest);

/**
 * Success
 */
export const zLogCreateResponse = zLogResponse;

/**
 * Password reset request payload
 */
export const zResetPasswordBody = zAuthResetPasswordRequest;

/**
 * User retrieved successfully
 */
export const zResetPasswordResponse = zAuthResetPasswordResponse;

/**
 * Signup user request payload
 */
export const zAuthSignupBody = zSignupUserRequest;

/**
 * User retrieved successfully
 */
export const zAuthSignupResponse = zSignupUserResponse;

/**
 * OAuth user provisioned
 */
export const zOauthProvisionResponse2 = zOauthProvisionResponse;

/**
 * Signup user request payload
 */
export const zAuthAcceptInviteNewUserBody = zAuthAcceptInviteRequest;

export const zAuthAcceptInviteNewUserQuery = z.object({
  inviteId: z.string(),
});

/**
 * User retrieved successfully
 */
export const zAuthAcceptInviteNewUserResponse = zSignupUserWithInviteIdResponse;

export const zAuthAcceptInviteExistingUserQuery = z.object({
  inviteId: z.string(),
});

/**
 * User retrieved successfully
 */
export const zAuthAcceptInviteExistingUserResponse = zSignupUserWithInviteIdResponse;

export const zAuthCheckInviteQuery = z.object({
  inviteId: z.string(),
});

/**
 * Sign up check invite id successful
 */
export const zAuthCheckInviteResponse = zSignUpUserCheckInviteIdResponse;

/**
 * Status
 */
export const zTwoStepStatusResponse = z.object({
  success: z.literal(true),
  data: zTwoStepStatus,
});

export const zTwoStepSetChoiceBody = z.object({
  twoStep: z.enum(['on', 'off']),
});

/**
 * Changed
 */
export const zTwoStepSetChoiceResponse = z.object({
  success: z.literal(true),
  data: zTwoStepDone,
});

/**
 * Required
 */
export const zTwoStepRequireResponse = z.object({
  success: z.literal(true),
  data: zTwoStepDone,
});

/**
 * Key for the app
 */
export const zTwoStepStartAuthenticatorResponse = z.object({
  success: z.literal(true),
  data: zTwoStepAuthenticator,
});

export const zTwoStepStartSmsBody = z.object({
  phoneNumber: z.string().min(8).max(20),
});

/**
 * Code sent
 */
export const zTwoStepStartSmsResponse = z.object({
  success: z.literal(true),
  data: zTwoStepCodeSent,
});

export const zTwoStepConfirmMethodBody = z.object({
  code: z.string().regex(/^\d{6}$/),
});

export const zTwoStepConfirmMethodPath = z.object({
  kind: zTwoStepMethodKind,
});

/**
 * Confirmed and passed
 */
export const zTwoStepConfirmMethodResponse = z.object({
  success: z.literal(true),
  data: zTwoStepSignIn,
});

export const zTwoStepRemoveMethodPath = z.object({
  kind: zTwoStepMethodKind,
});

/**
 * Removed
 */
export const zTwoStepRemoveMethodResponse = z.object({
  success: z.literal(true),
  data: zTwoStepDone,
});

export const zTwoStepSetPreferredBody = z.object({
  preferred: z.literal(true),
});

export const zTwoStepSetPreferredPath = z.object({
  kind: zTwoStepMethodKind,
});

/**
 * Preferred
 */
export const zTwoStepSetPreferredResponse = z.object({
  success: z.literal(true),
  data: zTwoStepDone,
});

export const zTwoStepSendCodeBody = z.object({
  kind: z.enum(['sms']),
});

/**
 * Code sent
 */
export const zTwoStepSendCodeResponse = z.object({
  success: z.literal(true),
  data: zTwoStepCodeSent,
});

export const zTwoStepVerifyBody = zTwoStepVerificationBody;

/**
 * Passed
 */
export const zTwoStepVerifyResponse = z.object({
  success: z.literal(true),
  data: zTwoStepSignIn,
});

export const zTwoStepVerifyDeviceBody = z.object({
  deviceToken: z.string().min(20).max(200),
});

/**
 * Passed
 */
export const zTwoStepVerifyDeviceResponse = z.object({
  success: z.literal(true),
  data: zTwoStepSignIn,
});

/**
 * Forgotten
 */
export const zTwoStepForgetAllDevicesResponse = z.object({
  success: z.literal(true),
  data: zTwoStepDone,
});

/**
 * Remembered devices, newest first
 */
export const zTwoStepListDevicesResponse = z.object({
  success: z.literal(true),
  data: zTwoStepDevices,
});

export const zTwoStepForgetDevicePath = z.object({
  id: z.uuid(),
});

/**
 * Forgotten
 */
export const zTwoStepForgetDeviceResponse = z.object({
  success: z.literal(true),
  data: zTwoStepDone,
});

/**
 * Staff or not; an account web-apps does not know is not staff
 */
export const zStaffAccessResponse = z.object({
  success: z.literal(true),
  data: zStaffAccess,
});

export const zUserPublicProfilePath = z.object({
  userId: z.uuid(),
});

/**
 * User retrieved successfully
 */
export const zUserPublicProfileResponse = zUserPublicResponse;

/**
 * Raw QR data string (VIC Roads payload or Service Victoria JWT)
 */
export const zScanLicenseBody = z.object({
  qrData: z
    .string()
    .min(1)
    .regex(/qr-scan/),
});

/**
 * Successfully scanned and validated license credential
 */
export const zScanLicenseResponse = z.object({
  success: z.literal(true),
  data: zVicDigitalResponse,
});

/**
 * User retrieved successfully
 */
export const zGetSelfAppDataResponse = zUserAppDataResponse;

/**
 * Profile retrieved successfully
 */
export const zSelfProfileGetResponse2 = zSelfProfileGetResponse;

/**
 * Updated profile data
 */
export const zSelfProfileUpdateBody = zUpdateSelfProfileInput;

/**
 * Profile updated successfully
 */
export const zSelfProfileUpdateResponse2 = zSelfProfileUpdateResponse;

/**
 * Profile retrieved successfully
 */
export const zUserGetDataResponse = zSelfProfileGetResponse;

/**
 * Updated profile data
 */
export const zUserUpdateProfileBody = zUpdateSelfProfileInput;

/**
 * Profile updated successfully
 */
export const zUserUpdateProfileResponse = zSelfProfileUpdateResponse;

export const zInAppMessageUnreadForApplicationListQuery = z.object({
  application: z.enum(['checkd']),
});

/**
 * In-app messages retrieved successfully
 */
export const zInAppMessageUnreadForApplicationListResponse2 =
  zInAppMessageUnreadForApplicationListResponse;

export const zInAppMessageMarkReadBody = z.object({
  messageIds: z.array(z.uuid()).min(1),
});

/**
 * Messages marked as read
 */
export const zInAppMessageMarkReadResponse2 = zInAppMessageMarkReadResponse;

export const zGetLookupTableValuesQuery = z.object({
  tables: z.array(z.enum(['occupation', 'sourceOfWealth', 'sourceOfFunds'])),
});

/**
 * Success
 */
export const zGetLookupTableValuesResponse = zRouteResponse;

/**
 * File upload intent data
 */
export const zFileUploadIntentBody = z.object({
  filename: z.string().min(1).max(255),
  contentType: z.string(),
  sizeBytes: z.int().gt(0),
});

/**
 * User updated successfully
 */
export const zFileUploadIntentResponse = z.object({
  success: z.literal(true),
  data: z.object({
    fileId: z.uuid(),
    filepath: z.string(),
    filename: z.string(),
    uploadSignedUrl: z.url(),
    viewSignedUrl: z.url(),
    uploadExpiresAt: zDatetimeIsoString.nullable(),
    uploadHeaders: z.record(z.string(), z.string()),
  }),
});

export const zFileViewPath = z.object({
  fileId: z.uuid(),
});

export const zPayoutConnectIdShortLinkPath = z.object({
  code: z
    .string()
    .length(10)
    .regex(/^[0-9A-HJKMNP-TV-Z]+$/),
});

/**
 * The address as entered by the floor user
 */
export const zCheckdAddressValidateBody = zCheckdAddressValidateInput;

export const zCheckdAddressValidatePath = z.object({
  venueId: z.uuid(),
});

/**
 * The proposal, or an unavailable result
 */
export const zCheckdAddressValidateResponse = z.object({
  success: z.literal(true),
  data: zCheckdAddressValidateResult,
});

export const zPayoutListPath = z.object({
  venueId: z.uuid(),
});

export const zPayoutListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  q: z.string().optional(),
  statuses: z.array(zPayoutStatuses).optional(),
  amount: z.union([z.string(), z.number()]).optional(),
  amountMin: z.union([z.string(), z.number()]).optional(),
  amountMax: z.union([z.string(), z.number()]).optional(),
  methods: z.array(zPayoutMethods).optional(),
  machineNumber: z.string().min(1).optional(),
  identityVerificationResult: z
    .array(z.enum(['valid', 'unknown', 'error', 'skipped', 'pending']))
    .optional(),
  from: z.union([z.iso.datetime(), z.enum([''])]).optional(),
  to: z.union([z.iso.datetime(), z.enum([''])]).optional(),
  creator: z.uuid().optional(),
  signedOffBy: z.uuid().optional(),
  patronId: z.uuid().optional(),
});

/**
 * Payouts retrieved successfully
 */
export const zPayoutListResponse = z.object({
  data: z.array(zPayoutEnriched),
  pagination: zPaginationMeta,
});

/**
 * Ticket details
 */
export const zPayoutCreateBody = zPayoutCreateInput;

export const zPayoutCreatePath = z.object({
  venueId: z.uuid(),
});

/**
 * Payout created successfully
 */
export const zPayoutCreateResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

export const zPayoutGetHeaders = z.object({
  'x-temporary-manager-token': z.string().optional(),
});

export const zPayoutGetPath = z.object({
  venueId: z.uuid(),
  payoutId: z.uuid(),
});

export const zPayoutGetQuery = z.object({
  mask: z.string().optional().default('false'),
  purpose: z.enum(['view', 'capture']).optional().default('view'),
});

/**
 * Payout retrieved successfully
 */
export const zPayoutGetResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
  resultsMasked: z.boolean(),
});

/**
 * Fields to update on the payout
 */
export const zPayoutUpdateBody = zPayoutUpdateRequest;

export const zPayoutUpdateHeaders = z.object({
  'x-temporary-manager-token': z.string().optional(),
});

export const zPayoutUpdatePath = z.object({
  venueId: z.uuid(),
  payoutId: z.uuid(),
});

/**
 * Success
 */
export const zPayoutUpdateResponse2 = zPayoutUpdateResponse;

export const zPayoutViewPath = z.object({
  venueId: z.uuid(),
  payoutId: z.uuid(),
});

/**
 * Payout view recorded successfully
 */
export const zPayoutViewResponse2 = zPayoutViewResponse;

/**
 * payoutReceipt request payload
 */
export const zPayoutReceiptSendBody = zPayoutReceiptRequest;

export const zPayoutReceiptSendHeaders = z.object({
  'x-temporary-manager-token': z.string().optional(),
});

export const zPayoutReceiptSendPath = z.object({
  venueId: z.uuid(),
  payoutId: z.uuid(),
});

/**
 * Success
 */
export const zPayoutReceiptSendResponse = zPayoutReceiptResponse;

/**
 * Patron ID details
 */
export const zPayoutPhase1PatronIdBody = zPayoutPhase1PatronIdInput;

export const zPayoutPhase1PatronIdPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Patron identification updated successfully
 */
export const zPayoutPhase1PatronIdResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

/**
 * The scanned VIC QR, or the QLD device result
 */
export const zPayoutIdentityCheckDigitalBody = zDigitalCapture;

export const zPayoutIdentityCheckDigitalPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * The digital licence was verified and recorded
 */
export const zPayoutIdentityCheckDigitalResponse = z.object({
  success: z.literal(true),
  data: zDigitalCaptureResult,
});

export const zPayoutConnectIdVerificationCancelPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Verification cancelled
 */
export const zPayoutConnectIdVerificationCancelResponse = z.object({
  success: z.literal(true),
  data: zPayoutConnectIdVerificationStatus,
});

export const zPayoutConnectIdVerificationStatusPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * The verification’s current state
 */
export const zPayoutConnectIdVerificationStatusResponse = z.object({
  success: z.literal(true),
  data: zPayoutConnectIdVerificationStatus,
});

/**
 * The patron’s name, used only to seed the vendor entity
 */
export const zPayoutConnectIdVerificationStartBody = zPayoutConnectIdVerificationStartInput;

export const zPayoutConnectIdVerificationStartPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Verification started — show the returned destination to the patron
 */
export const zPayoutConnectIdVerificationStartResponse = z.object({
  success: z.literal(true),
  data: zPayoutConnectIdVerificationStarted,
});

/**
 * Ticket details
 */
export const zPayoutPhase2TicketBody = zPayoutPhase2TicketInput;

export const zPayoutPhase2TicketPath = z.object({
  venueId: z.uuid(),
  payoutId: z.uuid(),
});

/**
 * Ticket details updated successfully
 */
export const zPayoutPhase2TicketResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

/**
 * KYC details
 */
export const zPayoutPhase3KycBody = zPayoutPhase3KycInput;

export const zPayoutPhase3KycPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * KYC submitted successfully
 */
export const zPayoutPhase3KycResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

export const zPayoutPhase3KycVerifyPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Verification triggered
 */
export const zPayoutPhase3KycVerifyResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

/**
 * Contact and payment details
 */
export const zPayoutPhase4ContactPaymentBody = zPayoutPhase4ContactPaymentInput;

export const zPayoutPhase4ContactPaymentPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Contact and payment details updated successfully
 */
export const zPayoutPhase4ContactPaymentResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

/**
 * The BSB, account number and account name currently entered in Phase 4
 */
export const zPayoutConfirmationOfPayeeVerifyBody = zPayoutConfirmationOfPayeeVerifyInput;

export const zPayoutConfirmationOfPayeeVerifyPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Verification triggered
 */
export const zPayoutConfirmationOfPayeeVerifyResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

export const zPayoutConfirmationOfPayeeReVerifyHeaders = z.object({
  'x-temporary-manager-token': z.string().optional(),
});

export const zPayoutConfirmationOfPayeeReVerifyPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Re-verification triggered
 */
export const zPayoutConfirmationOfPayeeReVerifyResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

export const zPayoutConfirmationOfPayeeNotesUpdateBody = zPayoutConfirmationOfPayeeNotesUpdateInput;

export const zPayoutConfirmationOfPayeeNotesUpdatePath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Notes saved
 */
export const zPayoutConfirmationOfPayeeNotesUpdateResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

/**
 * Signature details
 */
export const zPayoutPhase5PatronSignOffBody = zPayoutPhase5PatronSignOffInput;

export const zPayoutPhase5PatronSignOffPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Signature collected successfully
 */
export const zPayoutPhase5PatronSignOffResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

/**
 * Signature details
 */
export const zPayoutPhase6AttendantSignOffBody = zPayoutPhase6AttendantSignOffInput;

export const zPayoutPhase6AttendantSignOffPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Signature collected successfully
 */
export const zPayoutPhase6AttendantSignOffResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

export const zPayoutManagerReviewGetHeaders = z.object({
  'x-temporary-manager-token': z.string().optional(),
});

export const zPayoutManagerReviewGetPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Current review state
 */
export const zPayoutManagerReviewGetResponse = z.object({
  success: z.literal(true),
  data: zPayoutReviewState,
});

/**
 * Action to perform
 */
export const zPayoutManagerReviewPostBody = zPayoutReviewAction;

export const zPayoutManagerReviewPostPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Updated review state
 */
export const zPayoutManagerReviewPostResponse = z.object({
  success: z.literal(true),
  data: zPayoutReviewState,
});

export const zPayoutManagerElevationRefreshHeaders = z.object({
  'x-temporary-manager-token': z.string().optional(),
});

export const zPayoutManagerElevationRefreshPath = z.object({
  venueId: z.uuid(),
  payoutId: z.uuid(),
});

/**
 * Extended token
 */
export const zPayoutManagerElevationRefreshResponse = z.object({
  success: z.literal(true),
  data: zPayoutManagerElevationRefresh,
});

/**
 * Review decision
 */
export const zPayoutPhase7ManagerSignOffBody = zPayoutPhase7ManagerSignOffInput;

export const zPayoutPhase7ManagerSignOffPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Manager approval submitted successfully
 */
export const zPayoutPhase7ManagerSignOffResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

/**
 * Payment confirmation(s) - provide cash, eft, and/or cheque
 */
export const zPayoutPhase8PayoutBody = zPayoutPhase8PayoutInput;

export const zPayoutPhase8PayoutHeaders = z.object({
  'x-temporary-manager-token': z.string().optional(),
});

export const zPayoutPhase8PayoutPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Per-leg outcome for every payment confirmation the request carried
 */
export const zPayoutPhase8PayoutResponse = z.object({
  success: z.literal(true),
  data: zPayoutPhase8PayoutResult,
});

/**
 * Reason for discarding
 */
export const zPayoutDiscardBody = zPayoutDiscardInput;

export const zPayoutDiscardPath = z.object({
  payoutId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * Payout discarded successfully
 */
export const zPayoutDiscardResponse = z.object({
  success: z.literal(true),
  data: zPayoutEnriched,
});

export const zPayoutAuditTrailPath = z.object({
  venueId: z.uuid(),
  payoutId: z.uuid(),
});

/**
 * AuditTrail returned successfully
 */
export const zPayoutAuditTrailResponse = z.object({
  success: z.literal(true),
  data: z.array(
    z.object({
      createdAt: z.string(),
      message: z.string(),
      fieldsUpdated: z.record(z.string(), z.unknown()).optional(),
      nativeAction: z.boolean().optional(),
    }),
  ),
});

export const zEftAutoPaymentListPath = z.object({
  venueId: z.uuid(),
});

export const zEftAutoPaymentListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  from: z.iso.date().optional(),
  to: z.iso.date().optional(),
  stage: zEftAutoPaymentStage.optional(),
  payoutReference: z.string().min(1).optional(),
});

/**
 * Automated EFT payments retrieved successfully
 */
export const zEftAutoPaymentListResponse = z.object({
  data: z.array(zEftAutoPaymentHistoryItem),
  pagination: zPaginationMeta,
});

export const zPpVenueUserListPath = z.object({
  venueId: z.uuid(),
});

export const zPpVenueUserListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  q: z.string().optional(),
  holdsPermission: z.string().optional(),
  venueAssociated: z.string().optional(),
  excludedUserId: z.uuid().optional(),
  includeInvitedUsers: z.string().optional(),
});

/**
 * Payouts retrieved successfully
 */
export const zPpVenueUserListResponse = z.object({
  data: z.array(zPpVenueUser),
  pagination: zPaginationMeta,
});

/**
 * User PIN check data
 */
export const zUserPinCheckBody = zUserPinCheckInput;

export const zUserPinCheckPath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * PIN check result
 */
export const zUserPinCheckResponse2 = z.object({
  success: z.literal(true),
  data: zUserPinCheckResponse,
});

export const zPpVenueUserDeletePath = z.object({
  userId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * User updated successfully
 */
export const zPpVenueUserDeleteResponse = zDeleteEntityResponse;

export const zPpVenueUserGetPath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * User retrieved successfully
 */
export const zPpVenueUserGetResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
    fullname: z.string(),
    email: z.email(),
    phoneNumber: z.string().nullable(),
    jobTitle: z.string().nullable(),
    role: zCheckdVenueUserRole,
    roleId: z.uuid().nullable(),
    roleName: z.string().nullable(),
    application: zApplications,
    isApplicationMember: z.boolean(),
    status: z.enum(['invited', 'requested', 'active', 'inactive', 'suspended']).nullable(),
    invitedBy: z.uuid().nullable(),
    invitedByName: z.string().nullable(),
    invitedAt: z.iso.datetime().nullable(),
    inviteExpiresAt: z.iso.datetime().nullable(),
    lastLoginAt: z.iso.datetime().nullable(),
    inviteId: z.string().nullable(),
    inviteUrl: z.string().nullable(),
    createdAt: z.iso.datetime().nullable(),
    createdBy: z.uuid().nullable(),
    createdByName: z.string().nullable(),
  }),
});

/**
 * User-Venue association data
 */
export const zPpVenueUserCreateBody = zCheckdCreateUserVenueAssociation;

export const zPpVenueUserCreatePath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * User updated successfully
 */
export const zPpVenueUserCreateResponse = z.object({
  success: z.literal(true),
  data: zCheckdUserVenueAssociation,
});

/**
 * Updated user data
 */
export const zPpVenueUserUpdateBody = zCheckdUpdateUserVenueAssociation;

export const zPpVenueUserUpdatePath = z.object({
  userId: z.uuid(),
  venueId: z.uuid(),
});

/**
 * User updated successfully
 */
export const zPpVenueUserUpdateResponse = z.object({
  success: z.literal(true),
  data: zCheckdUserVenueAssociation,
});

export const zPokieVenueSettingRiskRuleListPath = z.object({
  venueId: z.uuid(),
});

/**
 * Risk rule metadata retrieved successfully
 */
export const zPokieVenueSettingRiskRuleListResponse = z.object({
  success: z.literal(true),
  data: z.array(zPokieVenueSettingRiskRule),
});

export const zPokieVenueSettingGetPath = z.object({
  venueId: z.uuid(),
});

/**
 * Venue Settings retrieved successfully
 */
export const zPokieVenueSettingGetResponse = z.object({
  success: z.literal(true),
  data: zPokieVenueSetting,
});

/**
 * Venue Settings to update
 */
export const zPokieVenueSettingUpdateBody = zPokieVenueSettingUpdateInput;

export const zPokieVenueSettingUpdatePath = z.object({
  venueId: z.uuid(),
});

/**
 * Venue settings updated successfully
 */
export const zPokieVenueSettingUpdateResponse = z.object({
  success: z.literal(true),
  data: zPokieVenueSetting,
});

export const zVoiSettingGetPath = z.object({
  venueId: z.uuid(),
});

/**
 * VoI setting retrieved successfully
 */
export const zVoiSettingGetResponse = z.object({
  success: z.literal(true),
  data: zVoiSetting,
});

/**
 * Complete VoI setting to apply
 */
export const zVoiSettingUpdateBody = zVoiSettingUpdateInput;

export const zVoiSettingUpdatePath = z.object({
  venueId: z.uuid(),
});

/**
 * VoI setting updated successfully
 */
export const zVoiSettingUpdateResponse = z.object({
  success: z.literal(true),
  data: zVoiSetting,
});

export const zCheckdDashboardMetricsPath = z.object({
  venueId: z.uuid(),
});

/**
 * Payout created successfully
 */
export const zCheckdDashboardMetricsResponse = z.object({
  success: z.literal(true),
  data: zCheckdDashboardMetrics,
});

export const zCheckdAutoEftDashboardPath = z.object({
  venueId: z.uuid(),
});

/**
 * Automated EFT dashboard summary retrieved successfully
 */
export const zCheckdAutoEftDashboardResponse = z.object({
  success: z.literal(true),
  data: zCheckdAutoEftDashboard,
});

export const zPatronSearchBody = zPatronIdentitySearch;

export const zPatronSearchPath = z.object({
  venueId: z.uuid(),
});

/**
 * Similar people, most similar first
 */
export const zPatronSearchResponse = z.object({
  success: z.literal(true),
  data: zPatronSimilaritySearchResult,
});

export const zPatronCaptureCompareBody = zPatronIdentityCapture;

export const zPatronCaptureComparePath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * The details that differ, if any
 */
export const zPatronCaptureCompareResponse = z.object({
  success: z.literal(true),
  data: zPatronCaptureComparison,
});

export const zPatronCaptureAddBody = zPatronCaptureConfirm;

export const zPatronCaptureAddPath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * Capture added
 */
export const zPatronCaptureAddResponse = z.object({
  success: z.literal(true),
  data: zPatronRecorded,
});

export const zPatronTypeUpdateBody = zPatronTypeUpdate;

export const zPatronTypeUpdatePath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * Patron type updated
 */
export const zPatronTypeUpdateResponse = z.object({
  success: z.literal(true),
  data: zPatronTypeUpdate,
});

export const zPatronDetailsUpdateBody = zPatronDetailsUpdate;

export const zPatronDetailsUpdatePath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * The person, as updated
 */
export const zPatronDetailsUpdateResponse = z.object({
  success: z.literal(true),
  data: zPatronDetail,
});

export const zPatronAuditTrailPath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

export const zPatronAuditTrailQuery = z.object({
  pageToken: z.string().max(2000).optional(),
  pageSize: z.int().gte(1).lte(100).optional().default(50),
});

/**
 * One page of the trail
 */
export const zPatronAuditTrailResponse = z.object({
  success: z.literal(true),
  data: zPatronAuditTrailPage,
});

export const zPatronPepCheckDecideBody = zPatronPepCheckDecision;

export const zPatronPepCheckDecidePath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
  checkId: z.uuid(),
});

/**
 * Decision recorded
 */
export const zPatronPepCheckDecideResponse = z.object({
  success: z.literal(true),
  data: z.record(z.string(), z.unknown()),
});

export const zPatronPepCheckRunPath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * Check completed
 */
export const zPatronPepCheckRunResponse = z.object({
  success: z.literal(true),
  data: zPatronPepCheckRunResult,
});

export const zPatronDvsCheckRunBody = zPatronDvsCheckRequest;

export const zPatronDvsCheckRunPath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * Check completed, whatever its outcome
 */
export const zPatronDvsCheckRunResponse = z.object({
  success: z.literal(true),
  data: zPatronDvsCheckResult,
});

export const zPatronIdentityCheckDigitalBody = zDigitalCapture;

export const zPatronIdentityCheckDigitalPath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * The licence was verified and recorded, whatever its outcome, with the identity it verified
 */
export const zPatronIdentityCheckDigitalResponse = z.object({
  success: z.literal(true),
  data: zDigitalCaptureResult,
});

export const zPatronIdentityCheckAttachPath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
  identityCheckId: z.uuid(),
});

/**
 * The check is now the person’s
 */
export const zPatronIdentityCheckAttachResponse = z.object({
  success: z.literal(true),
  data: zPatronDvsCheckResult,
});

export const zAdhocIdentityCheckDigitalBody = zDigitalCapture;

export const zAdhocIdentityCheckDigitalPath = z.object({
  venueId: z.uuid(),
});

/**
 * The licence was verified and held for attaching
 */
export const zAdhocIdentityCheckDigitalResponse = z.object({
  success: z.literal(true),
  data: zDigitalCaptureResult,
});

export const zPatronGetPath = z.object({
  venueId: z.uuid(),
  patronId: z.uuid(),
});

/**
 * Person retrieved successfully
 */
export const zPatronGetResponse = z.object({
  success: z.literal(true),
  data: zPatronDetail,
});

export const zPatronListPath = z.object({
  venueId: z.uuid(),
});

export const zPatronListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  q: z.string().max(200).optional(),
  patronType: z.array(z.enum(['patron', 'employee', 'contractor'])).optional(),
});

/**
 * People retrieved successfully
 */
export const zPatronListResponse = z.object({
  data: z.array(zPatronListItem),
  pagination: zPaginationMeta,
});

export const zPatronCreateBody = zPatronCreate;

export const zPatronCreatePath = z.object({
  venueId: z.uuid(),
});

/**
 * Person recorded
 */
export const zPatronCreateResponse = z.object({
  success: z.literal(true),
  data: zPatronRecorded,
});

export const zRiskRegisterMetricsPath = z.object({
  venueId: z.uuid(),
});

/**
 * Risk register metrics retrieved successfully
 */
export const zRiskRegisterMetricsResponse = z.object({
  success: z.literal(true),
  data: zRiskRegisterMetrics,
});

export const zRiskRegisterPatronSearchPath = z.object({
  venueId: z.uuid(),
});

export const zRiskRegisterPatronSearchQuery = z.object({
  q: z.string().optional(),
});

/**
 * Matching patrons
 */
export const zRiskRegisterPatronSearchResponse = z.object({
  success: z.literal(true),
  data: z.array(zRiskRegisterPatronSearchResult),
});

export const zRiskRegisterPayoutSearchPath = z.object({
  venueId: z.uuid(),
});

export const zRiskRegisterPayoutSearchQuery = z.object({
  q: z.string().optional(),
});

/**
 * Matching payouts
 */
export const zRiskRegisterPayoutSearchResponse = z.object({
  success: z.literal(true),
  data: z.array(zRiskRegisterPayoutSearchResult),
});

export const zRiskRegisterReviewBody = zRiskRegisterReviewInput;

export const zRiskRegisterReviewPath = z.object({
  venueId: z.uuid(),
  entryId: z.uuid(),
});

/**
 * Risk register item reviewed successfully
 */
export const zRiskRegisterReviewResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
  }),
});

export const zRiskRegisterAttachmentDeletePath = z.object({
  venueId: z.uuid(),
  entryId: z.uuid(),
});

export const zRiskRegisterAttachmentDeleteQuery = z.object({
  documentId: z.uuid(),
});

/**
 * Supporting document removed successfully
 */
export const zRiskRegisterAttachmentDeleteResponse = z.object({
  success: z.literal(true),
  data: z.object({
    success: z.boolean(),
  }),
});

export const zRiskRegisterAttachmentGetPath = z.object({
  venueId: z.uuid(),
  entryId: z.uuid(),
});

/**
 * Supporting documents retrieved successfully
 */
export const zRiskRegisterAttachmentGetResponse = z.object({
  success: z.literal(true),
  data: z.array(zRiskRegisterDocument),
});

/**
 * Supporting document details
 */
export const zRiskRegisterAttachmentCreateBody = zRiskRegisterDocumentCreateInput;

export const zRiskRegisterAttachmentCreatePath = z.object({
  venueId: z.uuid(),
  entryId: z.uuid(),
});

/**
 * Supporting document attached successfully
 */
export const zRiskRegisterAttachmentCreateResponse = z.object({
  success: z.literal(true),
  data: zRiskRegisterDocument,
});

export const zRiskRegisterListPath = z.object({
  venueId: z.uuid(),
});

export const zRiskRegisterListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  q: z.string().optional(),
  status: z.enum(['awaiting', 'actioned']).optional().default('awaiting'),
  riskLevel: z.enum(['low', 'medium', 'high']).optional(),
  triggerType: z.string().optional(),
  actionsTaken: z.string().optional(),
  amountMin: z.string().optional(),
  amountMax: z.string().optional(),
  from: z.iso.date().optional(),
  to: z.iso.date().optional(),
  sort: z
    .enum(['risk-desc', 'risk-asc', 'amount-desc', 'amount-asc', 'date-desc', 'date-asc'])
    .optional()
    .default('risk-desc'),
});

/**
 * Risk register items retrieved successfully
 */
export const zRiskRegisterListResponse = z.object({
  data: z.array(zRiskRegisterItem),
  pagination: zPaginationMeta,
});

/**
 * Manual risk register entry details
 */
export const zRiskRegisterCreateBody = zRiskRegisterManualCreateInput;

export const zRiskRegisterCreatePath = z.object({
  venueId: z.uuid(),
});

/**
 * Manual risk register entry created successfully
 */
export const zRiskRegisterCreateResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
  }),
});

export const zPpUserInviteBody = z.object({
  email: z.email(),
  roleId: z.uuid(),
  application: zApplications,
});

export const zPpUserInvitePath = z.object({
  venueId: z.uuid(),
});

export const zPpUserInviteQuery = z.object({
  skipEmail: z.string().optional(),
});

/**
 * Success
 */
export const zPpUserInviteResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
    inviteUrl: z.string().optional(),
  }),
});

export const zPpUserReinvitePath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * Success
 */
export const zPpUserReinviteResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zPpUserRevokeInvitePath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * Success
 */
export const zPpUserRevokeInviteResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zPermissionCatalogueListPath = z.object({
  venueId: z.uuid(),
});

/**
 * The application’s permissions
 */
export const zPermissionCatalogueListResponse = zPermissionCatalogueResponse;

export const zVenueAssignableRoleListPath = z.object({
  venueId: z.uuid(),
});

/**
 * Roles retrieved successfully
 */
export const zVenueAssignableRoleListResponse = z.object({
  success: z.literal(true),
  data: zVenueAssignableRoleList,
});

/**
 * Each role and the permissions it should grant
 */
export const zVenueRolePermissionsUpdateBody = zVenueRolePermissionsEditInput;

export const zVenueRolePermissionsUpdatePath = z.object({
  venueId: z.uuid(),
});

/**
 * Every role at the venue, as saved
 */
export const zVenueRolePermissionsUpdateResponse = zVenueRoleListResponse;

export const zVenueRoleListPath = z.object({
  venueId: z.uuid(),
});

/**
 * The venue-application roles
 */
export const zVenueRoleListResponse2 = zVenueRoleListResponse;

/**
 * The role to create
 */
export const zVenueRoleCreateBody = zVenueRoleCreateInput;

export const zVenueRoleCreatePath = z.object({
  venueId: z.uuid(),
});

/**
 * The created role
 */
export const zVenueRoleCreateResponse = zVenueRoleResponse;

export const zVenueRoleDeletePath = z.object({
  venueId: z.uuid(),
  roleId: z.uuid(),
});

/**
 * The role was deleted
 */
export const zVenueRoleDeleteResponse = zDeleteEntityResponse;

export const zVenueRoleGetPath = z.object({
  venueId: z.uuid(),
  roleId: z.uuid(),
});

/**
 * The role
 */
export const zVenueRoleGetResponse = zVenueRoleResponse;

/**
 * The role as it should be saved
 */
export const zVenueRoleUpdateBody = zVenueRoleEditInput;

export const zVenueRoleUpdatePath = z.object({
  venueId: z.uuid(),
  roleId: z.uuid(),
});

/**
 * The saved role
 */
export const zVenueRoleUpdateResponse = zVenueRoleResponse;

export const zIduAutoEftMetricsQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  from: z.iso.datetime(),
  to: z.iso.datetime(),
  venueId: z.uuid().optional(),
  cohort: z
    .enum([
      'past_due_unsubmitted',
      'stuck',
      'rejected_at_submission',
      'credential_or_funding_failure',
      'returned_funds',
    ])
    .optional(),
  failureReason: z.string().optional(),
});

/**
 * Automated EFT metrics retrieved
 */
export const zIduAutoEftMetricsResponse = z.object({
  success: z.literal(true),
  data: zAutoEftMetrics,
});

export const zIduAutoEftRecordsQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  statuses: z
    .array(
      z.enum([
        'scheduled',
        'held',
        'locked',
        'submitting',
        'processing',
        'paid',
        'payment_failed',
        'cancelled',
      ]),
    )
    .optional(),
  cohorts: z
    .array(
      z.enum([
        'past_due_unsubmitted',
        'stuck',
        'rejected_at_submission',
        'credential_or_funding_failure',
        'returned_funds',
      ]),
    )
    .optional(),
  venueId: z.uuid().optional(),
  payoutReference: z.string().optional(),
});

/**
 * Automated EFT records retrieved
 */
export const zIduAutoEftRecordsResponse = z.object({
  success: z.literal(true),
  data: zAutoEftRecords,
});

export const zIduAutoEftMerchantWarriorCheckPath = z.object({
  recordId: z.uuid(),
});

/**
 * What Merchant Warrior reports for this payment, or why it could not be asked
 */
export const zIduAutoEftMerchantWarriorCheckResponse = z.object({
  success: z.literal(true),
  data: zAutoEftMerchantWarriorCheck,
});

export const zIduAutoEftResolutionRecordBody = z.object({
  recordId: z.uuid(),
  reason: z.string().min(1),
  resolutionMethod: z.enum([
    'provider_confirmed_settled',
    'paid_outside_automation',
    'resubmitted_and_paid',
    'no_payment_owed',
  ]),
});

/**
 * Staff resolution recorded
 */
export const zIduAutoEftResolutionRecordResponse = z.object({
  success: z.literal(true),
  data: zAutoEftStaffResolution,
});

export const zIduAutoEftRetryableBody = z.object({
  payoutId: z.uuid(),
  reasonText: z.string().optional(),
});

/**
 * Payment marked retryable
 */
export const zIduAutoEftRetryableResponse = z.object({
  success: z.literal(true),
  data: zAutoEftRetryableResult,
});

export const zIduDashboardMetricsQuery = z.object({
  limit: z.string().optional(),
});

/**
 * Checkd metrics retrieved successfully
 */
export const zIduDashboardMetricsResponse = z.object({
  success: z.literal(true),
  data: zCheckdManagerDashboardMetrics,
});

/**
 * Checkd metrics retrieved successfully
 */
export const zIduDashboardCheckdMetricsResponse = z.object({
  success: z.literal(true),
  data: zCheckdMetrics,
});

/**
 * Venue tables retrieved successfully
 */
export const zIduDashboardCheckdVenueTablesResponse = z.object({
  success: z.literal(true),
  data: zCheckdVenueTables,
});

export const zIduDashboardCheckdVenueMetricsPath = z.object({
  venueId: z.uuid(),
});

/**
 * Venue metrics retrieved successfully
 */
export const zIduDashboardCheckdVenueMetricsResponse = z.object({
  success: z.literal(true),
  data: zCheckdVenueMetrics,
});

export const zIduDashboardCheckdPayoutListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  venueId: z.uuid().optional(),
  status: z
    .enum(['draft', 'discarded', 'needs_review', 'payment_pending', 'rejected', 'finalised'])
    .optional(),
  riskType: z.enum(['suggested', 'manager']).optional(),
  riskLevel: z.enum(['low', 'medium', 'high', 'unassessed']).optional(),
  confirmationOfPayeeResult: z
    .enum([
      'match',
      'close_match',
      'weak_match',
      'not_enough_info',
      'no_match',
      'account_closed',
      'account_not_found',
      'unavailable',
    ])
    .optional(),
  externalId: z.string().optional(),
});

/**
 * Payouts retrieved successfully
 */
export const zIduDashboardCheckdPayoutListResponse = zCheckdPayoutListResponse;

export const zIduPayoutVenueMovePreviewPath = z.object({
  payoutId: z.uuid(),
});

export const zIduPayoutVenueMovePreviewQuery = z.object({
  destinationVenueId: z.uuid(),
  acknowledgeFinalised: z.enum(['true', 'false']).optional(),
});

/**
 * Preview generated successfully
 */
export const zIduPayoutVenueMovePreviewResponse = z.object({
  success: z.literal(true),
  data: zPayoutVenueMovePreview,
});

/**
 * Destination venue and the reason for the move
 */
export const zIduPayoutVenueMoveBody = zPayoutVenueMoveInput;

export const zIduPayoutVenueMovePath = z.object({
  payoutId: z.uuid(),
});

/**
 * Payout moved successfully
 */
export const zIduPayoutVenueMoveResponse = z.object({
  success: z.literal(true),
  data: zPayoutVenueMoveResult,
});

export const zIduPayoutAuditPath = z.object({
  payoutId: z.uuid(),
});

/**
 * Audit trail returned successfully
 */
export const zIduPayoutAuditResponse = z.object({
  success: z.literal(true),
  data: z.array(
    z.object({
      createdAt: z.string(),
      message: z.string(),
      fieldsUpdated: z.record(z.string(), z.unknown()).optional(),
      nativeAction: z.boolean().optional(),
    }),
  ),
});

/**
 * The proposed correction
 */
export const zIduPayoutCorrectionPreviewBody = zPayoutCorrectionChanges;

export const zIduPayoutCorrectionPreviewPath = z.object({
  payoutId: z.uuid(),
});

/**
 * Preview generated successfully
 */
export const zIduPayoutCorrectionPreviewResponse = z.object({
  success: z.literal(true),
  data: zPayoutCorrectionPreview,
});

/**
 * The correction, the reason for it, and the conflict guard
 */
export const zIduPayoutCorrectionBody = zPayoutCorrectionInput;

export const zIduPayoutCorrectionPath = z.object({
  payoutId: z.uuid(),
});

/**
 * Payout corrected successfully
 */
export const zIduPayoutCorrectionResponse = z.object({
  success: z.literal(true),
  data: zPayoutCorrectionResult,
});

export const zIduPayoutDetailPath = z.object({
  payoutId: z.uuid(),
});

/**
 * Payout detail returned successfully
 */
export const zIduPayoutDetailResponse = z.object({
  success: z.literal(true),
  data: zIduPayoutDetail,
});

export const zIduLogsListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  pageToken: z.string().optional(),
  source: z.string().optional(),
  severity: z.string().optional(),
  query: z.string().optional(),
  eventName: z.string().optional(),
  logType: z.string().optional(),
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  venueIds: z.array(z.string()).optional(),
  userIds: z.array(z.string()).optional(),
});

/**
 * Log entries retrieved successfully
 */
export const zIduLogsListResponse2 = zIduLogsListResponse;

export const zIduVenueListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  name: z.string().optional(),
  statuses: z.array(zVenueStatus).optional(),
  states: z.array(zSupportedStates).optional(),
  application: zApplications.and(z.unknown()).optional(),
  autoEftPlatformEntitled: z.boolean().optional(),
});

/**
 * Venues retrieved successfully
 */
export const zIduVenueListResponse = z.object({
  data: z.array(
    z.object({
      id: z.uuid(),
      slug: z.string(),
      name: z.string(),
      status: zVenueStatus,
      country: zVenueCountry,
      state: z.string(),
      createdAt: z.iso.datetime(),
      updatedAt: z.iso.datetime(),
      autoEftPlatformEntitled: z.boolean(),
      autoEftEnabled: z.boolean(),
      autoEftHoldHours: z.int(),
      autoEftVenueChoiceAt: z.iso.datetime().nullable(),
    }),
  ),
  pagination: zPaginationMeta,
});

export const zIduVenueCreateBody = z.object({
  slug: z.string().min(1).max(12),
  name: z.string().min(1).max(512),
  status: zVenueStatus,
  country: zVenueCountry.optional(),
  state: z.string().min(1).max(100),
  address: z.string().min(1).max(255),
  timezone: z.string().max(100).optional(),
  shiftCutoffTime: z.iso.time().optional(),
  licenceNumber: z.string().min(1).optional(),
  shiftOverageInMinutes: z.int().gte(0).nullish(),
  shiftUnderageInMinutes: z.int().gte(0).nullish(),
  numberOfEgms: z.int().gte(0),
  hubspotId: z.string().min(1),
});

/**
 * Venue created
 */
export const zIduVenueCreateResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
    slug: z.string(),
    name: z.string(),
    status: zVenueStatus,
    country: zVenueCountry,
    state: z.string(),
    licenceNumber: z.string().nullable(),
    shiftOverageInMinutes: z.number().nullable(),
    shiftUnderageInMinutes: z.number().nullable(),
    numberOfEgms: z.number().nullable(),
    hubspotId: z.string().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
  }),
});

export const zIduVenueGetPath = z.object({
  targetVenueId: z.uuid(),
});

/**
 * Venue retrieved successfully
 */
export const zIduVenueGetResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
    slug: z.string(),
    name: z.string(),
    applications: z.array(z.enum(['trackd', 'checkd', 'nightlife_snp', 'nightlife_osnp'])),
    riskRegisterEnabled: z.boolean(),
    patronNowEnabled: z.boolean(),
    status: zVenueStatus,
    country: zVenueCountry,
    state: z.string(),
    address: z.string().nullish(),
    timezone: z.string().nullish(),
    shiftCutoffTime: z.string().nullish(),
    initialPayoutDate: z.iso.datetime().nullish(),
    licenceNumber: z.string().nullable(),
    shiftOverageInMinutes: z.number().nullable(),
    shiftUnderageInMinutes: z.number().nullable(),
    numberOfEgms: z.number().nullable(),
    hubspotId: z.string().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
  }),
});

/**
 * IduVenueUpdateRequest
 *
 * Schema for updating venue details from the IDU dashboard
 */
export const zIduVenueUpdateBody = z.object({
  name: z.string().optional(),
  address: z.string().min(1).optional(),
  shiftCutoffTime: z.string().nullish(),
  initialPayoutDate: z.iso.datetime().nullish(),
  status: zVenueStatus.optional(),
  timezone: z.string().optional(),
  locations: z
    .array(
      z.object({
        id: z.string().optional(),
        name: z.string().min(1),
        isDeleted: z.boolean(),
      }),
    )
    .optional(),
  riskRegisterEnabled: z.boolean().optional(),
  patronNowEnabled: z.boolean().optional(),
  reason: z.string().optional(),
  numberOfEgms: z.int().gte(0).optional(),
  hubspotId: z.string().min(1).optional(),
  country: zVenueCountry.optional(),
  state: z.string().min(1).max(100).optional(),
  licenceNumber: z.string().min(1).nullish(),
  shiftOverageInMinutes: z.int().gte(0).nullish(),
  shiftUnderageInMinutes: z.int().gte(0).nullish(),
});

export const zIduVenueUpdatePath = z.object({
  targetVenueId: z.uuid(),
});

/**
 * Venue updated successfully
 */
export const zIduVenueUpdateResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
    slug: z.string(),
    name: z.string(),
    applications: z.array(z.enum(['trackd', 'checkd', 'nightlife_snp', 'nightlife_osnp'])),
    riskRegisterEnabled: z.boolean(),
    patronNowEnabled: z.boolean(),
    status: zVenueStatus,
    country: zVenueCountry,
    state: z.string(),
    address: z.string().nullish(),
    timezone: z.string().nullish(),
    shiftCutoffTime: z.string().nullish(),
    initialPayoutDate: z.iso.datetime().nullish(),
    licenceNumber: z.string().nullable(),
    shiftOverageInMinutes: z.number().nullable(),
    shiftUnderageInMinutes: z.number().nullable(),
    numberOfEgms: z.number().nullable(),
    hubspotId: z.string().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
  }),
});

export const zIduAuditListQuery = z.object({
  actorId: z.uuid().optional(),
  entityType: z.enum(['venue', 'user', 'userVenue']).optional(),
  entityId: z.string().optional(),
  venueId: z.uuid().optional(),
  action: z.string().optional(),
  dateFrom: z.string().optional(),
  dateTo: z.string().optional(),
  page: z.string().optional(),
  pageSize: z.string().optional(),
  pageToken: z.string().optional(),
});

/**
 * Audit entries
 */
export const zIduAuditListResponse = z.object({
  data: z.array(
    z.object({
      id: z.string(),
      actorId: z.string(),
      actorName: z.string().nullable(),
      action: z.string(),
      entityType: z.string(),
      entityId: z.string(),
      venueId: z.string().nullable(),
      venueName: z.string().nullable(),
      reason: z.string().nullable(),
      createdAt: z.string(),
    }),
  ),
  pagination: zPaginationMeta.and(
    z.object({
      nextPageToken: z.string().optional(),
    }),
  ),
});

export const zIduVenueUsersListPath = z.object({
  targetVenueId: z.uuid(),
});

export const zIduVenueUsersListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  application: zApplications,
  includeInvitedUsers: z.string().optional(),
});

/**
 * Users retrieved successfully
 */
export const zIduVenueUsersListResponse = z.object({
  data: z.array(
    z.object({
      id: z.uuid(),
      fullname: z.string(),
      email: z.string(),
      phoneNumber: z.string().nullable(),
      createdAt: z.iso.datetime(),
      updatedAt: z.iso.datetime(),
      lastLoginAt: z.iso.datetime().nullable(),
      lastActivityAt: z.iso.datetime().nullable(),
      application: zApplications,
      status: zUserVenueInviteStatus,
      role: zRoles.nullable(),
      roleId: z.uuid().nullable(),
      roleName: z.string().nullable(),
      jobTitle: zJobTitles.nullable(),
      securityFirm: z.string().nullable(),
      invitedAt: z.iso.datetime().nullable(),
      invitedByName: z.string().nullable(),
      inviteExpiresAt: z.iso.datetime().nullable(),
      inviteUrl: z.string().nullable(),
    }),
  ),
  pagination: zPaginationMeta,
});

export const zIduVenueRolesListPath = z.object({
  targetVenueId: z.uuid(),
});

export const zIduVenueRolesListQuery = z.object({
  application: zApplications,
});

/**
 * Roles retrieved successfully
 */
export const zIduVenueRolesListResponse = z.object({
  success: z.literal(true),
  data: zVenueAssignableRoleList,
});

export const zIduCheckdVenueSettingGetPath = z.object({
  targetVenueId: z.uuid(),
});

/**
 * Venue settings retrieved successfully
 */
export const zIduCheckdVenueSettingGetResponse = z.object({
  success: z.literal(true),
  data: zPokieVenueSetting,
});

/**
 * Venue settings to update
 */
export const zIduCheckdVenueSettingUpdateBody = zPokieVenueSettingAdminUpdateInput;

export const zIduCheckdVenueSettingUpdatePath = z.object({
  targetVenueId: z.uuid(),
});

/**
 * Venue settings updated successfully
 */
export const zIduCheckdVenueSettingUpdateResponse = z.object({
  success: z.literal(true),
  data: zPokieVenueSetting,
});

/**
 * The full credential set — a rotation replaces all three values
 */
export const zIduVenueMwCredentialsUpdateBody = z.object({
  merchantUuid: z.string().min(1),
  apiKey: z.string().min(1),
  apiPassphrase: z.string().min(1),
});

export const zIduVenueMwCredentialsUpdatePath = z.object({
  targetVenueId: z.uuid(),
});

/**
 * Credentials stored
 */
export const zIduVenueMwCredentialsUpdateResponse = z.void();

export const zIduVenueMwCredentialsStatusPath = z.object({
  targetVenueId: z.uuid(),
});

/**
 * Credential status for the venue
 */
export const zIduVenueMwCredentialsStatusResponse = z.object({
  success: z.literal(true),
  data: zVenueMwCredentialStatus,
});

/**
 * venueApplication request payload
 */
export const zIduVenueApplicationAssignBody = zIduVenueApplicationAssignRequest;

export const zIduVenueApplicationAssignPath = z.object({
  venueId: z.uuid(),
});

/**
 * Success
 */
export const zIduVenueApplicationAssignResponse2 = zIduVenueApplicationAssignResponse;

export const zIduVenueApplicationRemovePath = z.object({
  venueId: z.uuid(),
  application: z.enum(['trackd', 'checkd', 'nightlife_snp', 'nightlife_osnp']),
});

/**
 * Success
 */
export const zIduVenueApplicationRemoveResponse2 = zIduVenueApplicationRemoveResponse;

export const zIduNightlifeVenueListPath = z.object({
  application: zNightlifeApplication,
});

export const zIduNightlifeVenueListQuery = z.object({
  cursor: z.string().min(1).max(2048).optional(),
  customerStatus: zNightlifeCustomerStatus.and(z.unknown()).optional(),
});

/**
 * Success
 */
export const zIduNightlifeVenueListResponse = z.object({
  success: z.literal(true),
  data: zIduNightlifeVenuePage,
});

export const zIduNightlifeVenueLinkPath = z.object({
  application: zNightlifeApplication,
  firestoreVenueId: z.string().min(1).max(128),
});

/**
 * Created and linked
 */
export const zIduNightlifeVenueLinkResponse = z.object({
  success: z.literal(true),
  data: zIduNightlifeVenueLinkResult,
});

export const zIduNightlifeVenueLinkToBody = zIduNightlifeTargetVenueRequest;

export const zIduNightlifeVenueLinkToPath = z.object({
  application: zNightlifeApplication,
  firestoreVenueId: z.string().min(1).max(128),
});

/**
 * Linked
 */
export const zIduNightlifeVenueLinkToResponse = z.object({
  success: z.literal(true),
  data: zIduNightlifeVenueLinkResult,
});

export const zIduNightlifeVenueRelinkBody = zIduNightlifeTargetVenueRequest;

export const zIduNightlifeVenueRelinkPath = z.object({
  application: zNightlifeApplication,
  firestoreVenueId: z.string().min(1).max(128),
});

/**
 * Relinked
 */
export const zIduNightlifeVenueRelinkResponse = z.object({
  success: z.literal(true),
  data: zIduNightlifeVenueRelinkResult,
});

export const zIduVenueNightlifeLinksPath = z.object({
  targetVenueId: z.uuid(),
});

/**
 * Success
 */
export const zIduVenueNightlifeLinksResponse = z.object({
  success: z.literal(true),
  data: zIduVenueNightlifeLinks,
});

export const zIduVenueNightlifeCreateBody = zIduVenueNightlifeCreateRequest;

export const zIduVenueNightlifeCreatePath = z.object({
  targetVenueId: z.uuid(),
  application: zNightlifeApplication,
});

/**
 * Created and linked
 */
export const zIduVenueNightlifeCreateResponse = z.object({
  success: z.literal(true),
  data: zIduVenueNightlifeSettings,
});

export const zIduVenueNightlifeSettingsGetPath = z.object({
  targetVenueId: z.uuid(),
  application: zNightlifeApplication,
});

/**
 * Success
 */
export const zIduVenueNightlifeSettingsGetResponse = z.object({
  success: z.literal(true),
  data: zIduVenueNightlifeSettings,
});

export const zIduVenueNightlifeSettingsUpdateBody = zIduVenueNightlifeSettingsUpdateRequest;

export const zIduVenueNightlifeSettingsUpdatePath = z.object({
  targetVenueId: z.uuid(),
  application: zNightlifeApplication,
});

/**
 * Updated
 */
export const zIduVenueNightlifeSettingsUpdateResponse = z.object({
  success: z.literal(true),
  data: zIduVenueNightlifeSettings,
});

export const zIduVenueNightlifeLegacyManagersPath = z.object({
  targetVenueId: z.uuid(),
  application: zNightlifeApplication,
});

/**
 * Success
 */
export const zIduVenueNightlifeLegacyManagersResponse = z.object({
  success: z.literal(true),
  data: zIduVenueNightlifeLegacyManagers,
});

export const zIduKycDashboardQuery = z.object({
  period: zKycDashboardQueryPeriod.optional(),
});

/**
 * User retrieved successfully
 */
export const zIduKycDashboardResponse = z.object({
  success: z.literal(true),
  data: z.object({
    metrics: zKycMetricsSummary,
    venues: zKycMetricsVenueTotalsList,
  }),
});

export const zIduPepCheckActivityListQuery = z.object({
  page: z.int().gt(0).optional().default(1),
  pageSize: z.int().gt(0).lte(100).optional().default(20),
  venueId: z.uuid().optional(),
  startDate: z.iso.datetime().nullish(),
  endDate: z.iso.datetime().nullish(),
  outcome: z.enum(['match', 'no_match', 'failed', 'pending']).optional(),
  wasReused: z.string().optional(),
});

/**
 * PEP check activity retrieved successfully
 */
export const zIduPepCheckActivityListResponse = z.object({
  data: z.array(zPepCheckActivityItem),
  pagination: zPaginationMeta,
});

export const zIduPepCheckRunStatsQuery = z.object({
  period: zKycDashboardQueryPeriod.optional(),
});

/**
 * PEP check run stats retrieved successfully
 */
export const zIduPepCheckRunStatsResponse = z.object({
  success: z.literal(true),
  data: zPepCheckRunStatsResponse,
});

export const zIduBndryAlertHistoryQuery = z.object({
  limit: z.int().gt(0).lte(200).optional().default(50),
});

/**
 * BNDRY alert history retrieved successfully
 */
export const zIduBndryAlertHistoryResponse = z.object({
  success: z.literal(true),
  data: z.array(zBndryAlertHistoryItem),
});

/**
 * Settings retrieved successfully
 */
export const zIduSettingsGetResponse = z.object({
  success: z.literal(true),
  data: z.object({
    isBndryEnabled: z.boolean().optional(),
    bndryDailyThresholdNumber: z.number().optional(),
    bndryDailyThresholdEmails: z.array(z.email()).optional(),
    bndryThresholdWindowHours: z.int().gt(0).optional(),
    bndryAlertCooldownHours: z.int().gte(0).optional(),
    inviteExpiryHours: z.int().gte(1).lte(8760).optional(),
    confirmationOfPayeeCacheDurationDays: z.int().gt(0).optional(),
    isConfirmationOfPayeeEnabled: z.boolean().optional(),
    confirmationOfPayeeRollout: zConfirmationOfPayeeRollout.optional(),
    confirmationOfPayeeVenueIds: z.array(z.uuid()).optional(),
    identityCheckCacheDurationDays: z.int().gt(0).optional(),
    isAddressValidationEnabled: z.boolean().optional(),
    isPatronNowEnabled: z.boolean().optional(),
    confirmationOfPayeeVenues: z.array(
      z.object({
        id: z.uuid(),
        name: z.string(),
      }),
    ),
    updatedBy: z.uuid(),
    updatedAt: z.iso.datetime(),
  }),
});

export const zIduSettingsUpdateBody = z.object({
  isBndryEnabled: z.boolean().optional(),
  bndryDailyThresholdNumber: z.number().optional(),
  bndryDailyThresholdEmails: z.array(z.email()).optional(),
  bndryThresholdWindowHours: z.int().gt(0).optional(),
  bndryAlertCooldownHours: z.int().gte(0).optional(),
  inviteExpiryHours: z.int().gte(1).lte(8760).optional(),
  confirmationOfPayeeCacheDurationDays: z.int().gt(0).optional(),
  isConfirmationOfPayeeEnabled: z.boolean().optional(),
  confirmationOfPayeeRollout: zConfirmationOfPayeeRollout.optional(),
  confirmationOfPayeeVenueIds: z.array(z.uuid()).optional(),
  identityCheckCacheDurationDays: z.int().gt(0).optional(),
  isAddressValidationEnabled: z.boolean().optional(),
  isPatronNowEnabled: z.boolean().optional(),
});

/**
 * Settings updated successfully
 */
export const zIduSettingsUpdateResponse = z.object({
  success: z.literal(true),
  data: z.object({
    isBndryEnabled: z.boolean().optional(),
    bndryDailyThresholdNumber: z.number().optional(),
    bndryDailyThresholdEmails: z.array(z.email()).optional(),
    bndryThresholdWindowHours: z.int().gt(0).optional(),
    bndryAlertCooldownHours: z.int().gte(0).optional(),
    inviteExpiryHours: z.int().gte(1).lte(8760).optional(),
    confirmationOfPayeeCacheDurationDays: z.int().gt(0).optional(),
    isConfirmationOfPayeeEnabled: z.boolean().optional(),
    confirmationOfPayeeRollout: zConfirmationOfPayeeRollout.optional(),
    confirmationOfPayeeVenueIds: z.array(z.uuid()).optional(),
    identityCheckCacheDurationDays: z.int().gt(0).optional(),
    isAddressValidationEnabled: z.boolean().optional(),
    isPatronNowEnabled: z.boolean().optional(),
    confirmationOfPayeeVenues: z.array(
      z.object({
        id: z.uuid(),
        name: z.string(),
      }),
    ),
    updatedBy: z.uuid(),
    updatedAt: z.iso.datetime(),
  }),
});

export const zIduUserListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  name: z.string().optional(),
  venues: z.array(z.uuid()).optional(),
  products: z.array(zApplications).optional(),
  status: zUserVenueInviteStatus.optional(),
});

/**
 * Users retrieved successfully
 */
export const zIduUserListResponse = z.object({
  data: z.array(
    z.object({
      id: z.uuid(),
      fullname: z.string(),
      email: z.string(),
      lastLogin: z.iso.datetime().nullable(),
      lastActivityAt: z.iso.datetime().nullable(),
      venues: z.array(
        z.object({
          id: z.uuid(),
          name: z.string(),
          status: z.string(),
          application: zApplications,
          membershipStatus: zUserVenueInviteStatus,
        }),
      ),
      products: z.array(zApplications),
      phoneNumber: z.string().nullable(),
      createdAt: z.iso.datetime(),
      updatedAt: z.iso.datetime(),
    }),
  ),
  pagination: zPaginationMeta,
});

export const zIduUserCreateBody = zIduUserCreateRequest;

/**
 * User created
 */
export const zIduUserCreateResponse2 = z.object({
  success: z.literal(true),
  data: zIduUserCreateResponse,
});

export const zIduUserEmailSearchQuery = z.object({
  email: z.string(),
});

/**
 * User retrieved successfully
 */
export const zIduUserEmailSearchResponse = z.object({
  success: z.literal(true),
  data: z
    .object({
      id: z.uuid(),
      fullname: z.string(),
      email: z.string(),
      phoneNumber: z.string().nullable(),
      createdAt: z.iso.datetime(),
      updatedAt: z.iso.datetime(),
    })
    .optional(),
});

export const zIduUserSearchQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  q: z.string().optional(),
});

/**
 * Success
 */
export const zIduUserSearchResponse2 = zIduUserSearchResponse;

export const zIduUserGetPath = z.object({
  userId: z.uuid(),
});

/**
 * User retrieved successfully
 */
export const zIduUserGetResponse = z.object({
  success: z.literal(true),
  data: z.object({
    user: z.object({
      id: z.uuid(),
      fullname: z.string(),
      email: z.string(),
      phoneNumber: z.string().nullable(),
      createdAt: z.iso.datetime(),
      updatedAt: z.iso.datetime(),
    }),
    assignments: z.array(zAssignmentSchema),
  }),
});

export const zIduUserUpdateBody = z.object({
  fullname: z.string().min(1).optional(),
  phoneNumber: z.string().nullish(),
  newPassword: z.string().min(6).max(20).optional(),
});

export const zIduUserUpdatePath = z.object({
  userId: z.uuid(),
});

/**
 * User updated successfully
 */
export const zIduUserUpdateResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
    fullname: z.string(),
    email: z.string(),
    phoneNumber: z.string().nullable(),
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
  }),
});

export const zIduUserRemoveFromVenueBody = z.object({
  application: zApplications,
  reason: z.string().optional(),
});

export const zIduUserRemoveFromVenuePath = z.object({
  userId: z.uuid(),
  targetVenueId: z.uuid(),
});

/**
 * User associated
 */
export const zIduUserRemoveFromVenueResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduUserAssignToVenueBody = z.object({
  application: zApplications,
  role: zRoles.optional(),
  roleId: z.uuid().optional(),
  jobTitle: zJobTitles,
  securityFirm: z.string().max(255).nullish(),
});

export const zIduUserAssignToVenuePath = z.object({
  userId: z.uuid(),
  targetVenueId: z.uuid(),
});

/**
 * User associated
 */
export const zIduUserAssignToVenueResponse = z.object({
  success: z.literal(true),
  data: z.object({
    id: z.uuid(),
    fullname: z.string(),
    email: z.string(),
    phoneNumber: z.string().nullable(),
    role: zRoles.nullable(),
    roleName: z.string().nullish(),
    application: zApplications,
    securityFirm: z.string().nullable(),
    jobTitle: zJobTitles,
  }),
});

export const zIduUserPasswordChangeBody = z.object({
  password: z.string().min(6).max(20),
});

export const zIduUserPasswordChangePath = z.object({
  userId: z.uuid(),
});

/**
 * Password updated / reset triggered
 */
export const zIduUserPasswordChangeResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduUserResetPasswordBody = z.object({
  continueUrl: z.url().optional(),
});

export const zIduUserResetPasswordPath = z.object({
  userId: z.uuid(),
});

export const zIduUserResetPasswordQuery = z.object({
  skipEmail: z.string().optional(),
});

/**
 * Password updated / reset triggered
 */
export const zIduUserResetPasswordResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
    resetUrl: z.string().optional(),
  }),
});

export const zIduUserTwoStepPath = z.object({
  userId: z.uuid(),
});

/**
 * Two-step sign-in
 */
export const zIduUserTwoStepResponse = z.object({
  success: z.literal(true),
  data: z.object({
    twoStep: z.enum(['off', 'on', 'required']),
    requiredByAccess: z.boolean(),
    methods: z.array(z.enum(['authenticator', 'sms'])),
  }),
});

export const zIduUserTwoStepUpdateBody = z.object({
  twoStep: z.enum(['on', 'off']),
  reason: z.string().min(1).max(500).optional(),
});

export const zIduUserTwoStepUpdatePath = z.object({
  userId: z.uuid(),
});

/**
 * Two-step sign-in
 */
export const zIduUserTwoStepUpdateResponse = z.object({
  success: z.literal(true),
  data: z.object({
    twoStep: z.enum(['off', 'on', 'required']),
    requiredByAccess: z.boolean(),
    methods: z.array(z.enum(['authenticator', 'sms'])),
  }),
});

export const zIduUserTwoStepResetBody = z.object({
  reason: z.string().min(1).max(500),
});

export const zIduUserTwoStepResetPath = z.object({
  userId: z.uuid(),
});

/**
 * Reset
 */
export const zIduUserTwoStepResetResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduUserTwoStepCodeBody = z.object({
  reason: z.string().min(1).max(500),
});

export const zIduUserTwoStepCodePath = z.object({
  userId: z.uuid(),
});

/**
 * Code issued
 */
export const zIduUserTwoStepCodeResponse = z.object({
  success: z.literal(true),
  data: z.object({
    code: z.string(),
    expiresAt: z.iso.datetime(),
  }),
});

export const zIduUserInviteCreateBody = z.object({
  email: z.email(),
  role: zRoles.optional(),
  roleId: z.uuid().optional(),
  application: zApplications,
});

export const zIduUserInviteCreatePath = z.object({
  venueId: z.uuid(),
});

export const zIduUserInviteCreateQuery = z.object({
  skipEmail: z.string().optional(),
});

/**
 * Success
 */
export const zIduUserInviteCreateResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
    inviteUrl: z.string().optional(),
  }),
});

export const zIduInviteManualAcceptBody = z.object({
  application: zApplications,
  reason: z.string().min(1),
});

export const zIduInviteManualAcceptPath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * Invitation manually accepted
 */
export const zIduInviteManualAcceptResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduInviteSkipAndAddBody = z.object({
  email: z.email(),
  role: zRoles.optional(),
  roleId: z.uuid().optional(),
  application: zApplications,
  reason: z.string().min(1),
});

export const zIduInviteSkipAndAddPath = z.object({
  venueId: z.uuid(),
});

/**
 * User added without invitation
 */
export const zIduInviteSkipAndAddResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduInviteResendBody = z.object({
  application: zApplications,
});

export const zIduInviteResendPath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * Invitation re-sent
 */
export const zIduInviteResendResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduInviteRevokeBody = z.object({
  application: zApplications,
});

export const zIduInviteRevokePath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * Invitation revoked
 */
export const zIduInviteRevokeResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduInviteListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
  application: zApplications.optional(),
  venueId: z.uuid().optional(),
  search: z.string().optional(),
  status: zInviteStatus.optional(),
});

/**
 * Invitations retrieved successfully
 */
export const zIduInviteListResponse = z.object({
  data: z.array(
    z.object({
      id: z.uuid(),
      userId: z.uuid(),
      venueId: z.uuid(),
      application: zApplications,
      email: z.string(),
      fullname: z.string(),
      venue: z.object({
        id: z.uuid(),
        name: z.string(),
      }),
      role: zRoles.nullable(),
      roleName: z.string().nullable(),
      invitedAt: z.iso.datetime(),
      invitedByName: z.string().nullable(),
      expiresAt: z.iso.datetime(),
      status: zInviteStatus,
      inviteUrl: z.string(),
    }),
  ),
  pagination: zPaginationMeta,
});

/**
 * Invite availability per application
 */
export const zIduInviteAvailabilityResponse = z.object({
  success: z.literal(true),
  data: z.object({
    applications: z.array(
      z.object({
        application: zApplications,
        link: z.object({
          available: z.boolean(),
          reason: z.enum(['INVITE_DESTINATION_NOT_CONFIGURED']).optional(),
        }),
        email: z.object({
          available: z.boolean(),
          reason: z
            .enum(['INVITE_DESTINATION_NOT_CONFIGURED', 'INVITE_EMAIL_NOT_CONFIGURED'])
            .optional(),
        }),
      }),
    ),
  }),
});

export const zIduDashboardUsersListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
});

/**
 * Dashboard users retrieved successfully
 */
export const zIduDashboardUsersListResponse = z.object({
  data: z.array(
    z.object({
      id: z.uuid(),
      email: z.email(),
      phoneNumber: z.string().nullable(),
      fullname: z.string().min(1).max(255),
      photoFileId: z.uuid().nullable(),
      createdAt: zDatetimeIsoString,
      updatedAt: zDatetimeIsoString,
      createdBy: z.uuid().nullable(),
      updatedBy: z.uuid().nullable(),
      discardedAt: zDatetimeIsoString.nullable(),
      discardedBy: z.uuid().nullable(),
      venueId: z.string().nullable(),
      role: zRoles.nullable(),
      roleName: z.string().nullable(),
      isActive: z.boolean(),
      invitedBy: z.string().nullable(),
      invitedAt: z.iso.datetime().nullable(),
      lastLogin: z.iso.datetime().nullable(),
    }),
  ),
  pagination: zPaginationMeta,
});

export const zIduDashboardUserAddBody = z.object({
  email: z.email(),
  fullname: z.string().min(1).max(255).optional(),
  password: z.string().min(8).optional(),
});

/**
 * Dashboard access granted
 */
export const zIduDashboardUserAddResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zIduInAppMessageListQuery = z.object({
  page: z.string().regex(/^\d+$/).optional().default('1'),
  pageSize: z.string().regex(/^\d+$/).optional().default('10'),
});

/**
 * In-app messages retrieved successfully
 */
export const zIduInAppMessageListResponse = z.object({
  data: z.array(zInAppMessageResponseData),
  pagination: zPaginationMeta,
});

export const zIduInAppMessageCreateBody = zInAppMessageCreateOrUpdateRequestBody;

/**
 * In-app message created successfully
 */
export const zIduInAppMessageCreateResponse = z.object({
  success: z.literal(true),
  data: zInAppMessageResponseData,
});

export const zIduInAppMessageDeletePath = z.object({
  id: z.uuid(),
});

/**
 * In-app message deleted successfully
 */
export const zIduInAppMessageDeleteResponse = zDeleteEntityResponse;

export const zIduInAppMessageGetPath = z.object({
  id: z.uuid(),
});

/**
 * In-app message retrieved successfully
 */
export const zIduInAppMessageGetResponse = z.object({
  success: z.literal(true),
  data: zInAppMessageResponseData,
});

export const zIduInAppMessageUpdateBody = zInAppMessageCreateOrUpdateRequestBody;

export const zIduInAppMessageUpdatePath = z.object({
  id: z.uuid(),
});

/**
 * In-app message updated successfully
 */
export const zIduInAppMessageUpdateResponse = z.object({
  success: z.literal(true),
  data: zInAppMessageResponseData,
});

export const zNightlifeManagerListPath = z.object({
  venueId: z.uuid(),
});

/**
 * Success
 */
export const zNightlifeManagerListResponse = z.object({
  success: z.literal(true),
  data: zNightlifeVenueManagers,
});

export const zNightlifeManagerInviteBody = zNightlifeManagerInviteRequest;

export const zNightlifeManagerInvitePath = z.object({
  venueId: z.uuid(),
});

/**
 * The invitation was sent
 */
export const zNightlifeManagerInviteResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zNightlifeManagerInviteResendPath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * The invitation was re-sent
 */
export const zNightlifeManagerInviteResendResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zNightlifeManagerInviteRevokePath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * The invitation was revoked
 */
export const zNightlifeManagerInviteRevokeResponse = z.object({
  success: z.literal(true),
  data: z.object({
    message: z.string(),
  }),
});

export const zNightlifeManagerRemovePath = z.object({
  venueId: z.uuid(),
  userId: z.uuid(),
});

/**
 * The manager was removed
 */
export const zNightlifeManagerRemoveResponse = zDeleteEntityResponse;

export const zInternalNightlifeGrantCreateBody = zInternalNightlifeGrantCreateRequest;

/**
 * The grant was already active
 */
export const zInternalNightlifeGrantCreateResponse2 = zInternalNightlifeGrantCreateResponse;
